require=(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({"@toolkit/backend":[function(require,module,exports){
"use strict";
var ajaxProxy_1 = require('./src/backend/ajaxProxy');
exports.ProxyHttp = ajaxProxy_1.ProxyHttp;
exports.BinaryTransferObject = ajaxProxy_1.BinaryTransferObject;
var Dto = require('./src/backend/dtos');
exports.Dto = Dto;
var Api = require('./src/backend/webapis');
exports.Api = Api;
var Pdf = require('./src/backend/pdf');
exports.Pdf = Pdf;



},{"./src/backend/ajaxProxy":14,"./src/backend/dtos":15,"./src/backend/pdf":16,"./src/backend/webapis":17}],"@toolkit/changeTracking":[function(require,module,exports){
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./src/changeTracking/decorators'));
__export(require('./src/changeTracking/main'));



},{"./src/changeTracking/decorators":18,"./src/changeTracking/main":19}],"@toolkit/components":[function(require,module,exports){
"use strict";
var currencySelector_1 = require('./src/components/currencySelector');
exports.CurrencySelectorComponent = currencySelector_1.CurrencySelectorComponent;
var languageSelector_1 = require('./src/components/languageSelector');
exports.LanguageSelectorComponent = languageSelector_1.LanguageSelectorComponent;
var loadingIndicator_1 = require('./src/components/loadingIndicator');
exports.LoadingIndicator = loadingIndicator_1.LoadingIndicator;
var multiLevelMenu_1 = require('./src/components/multiLevelMenu');
exports.MultiLevelMenuComponent = multiLevelMenu_1.MultiLevelMenuComponent;
var progressIndicator_1 = require('./src/components/progressIndicator');
exports.ProgressIndicatorComponent = progressIndicator_1.ProgressIndicatorComponent;
var industryMix_1 = require('./src/components/industryMix');
exports.IndustryMixComponent = industryMix_1.IndustryMixComponent;
var strategySelector_1 = require('./src/components/strategySelector');
exports.StrategySelectorComponent = strategySelector_1.StrategySelectorComponent;
var stickyTable_1 = require('./src/components/stickyTable');
exports.StickyTableComponent = stickyTable_1.StickyTableComponent;
var columnSelector_1 = require('./src/components/columnSelector');
exports.ColumnSelectorComponent = columnSelector_1.ColumnSelectorComponent;
exports.ColumnSelectorImplementation = columnSelector_1.ColumnSelectorImplementation;
var customModel_1 = require('./src/components/customModel');
exports.CustomModal = customModel_1.CustomModal;
var customModalDeselect_1 = require('./src/components/customModalDeselect');
exports.CustomModalDeselect = customModalDeselect_1.CustomModalDeselect;



},{"./src/components/columnSelector":23,"./src/components/currencySelector":25,"./src/components/customModalDeselect":27,"./src/components/customModel":29,"./src/components/industryMix":33,"./src/components/languageSelector":35,"./src/components/loadingIndicator":36,"./src/components/multiLevelMenu":38,"./src/components/progressIndicator":40,"./src/components/stickyTable":41,"./src/components/strategySelector":43}],"@toolkit/directives":[function(require,module,exports){
"use strict";
var tab_1 = require('./src/directives/tab');
var tabs_1 = require('./src/directives/tabs');
exports.TabsControl = tabs_1.TabsControl;
var numberFormat_1 = require('./src/directives/numberFormat');
var localenumberFormat_1 = require('./src/directives/localenumberFormat');
var trimFormat_1 = require('./src/directives/trimFormat');
exports.TAB_DIRECTIVE = [tabs_1.TabsControl, tab_1.Tab];
var dateValueAccessor_1 = require('./src/directives/dateValueAccessor');
var checkedObjectAccessor_1 = require('./src/directives/checkedObjectAccessor');
exports.CUSTOM_VALUE_ACCESSORS = [numberFormat_1.FormattedNumbersAccessor, localenumberFormat_1.FormattedLocaleNumbersAccessor, trimFormat_1.TrimAccessor, dateValueAccessor_1.DateValueAccessor, checkedObjectAccessor_1.CheckedValueAccessor, checkedObjectAccessor_1.MultiCheckedValueAccessor, checkedObjectAccessor_1.SelectValueAccessor, checkedObjectAccessor_1.SelectOption];
var clickInput_1 = require('./src/directives/clickInput');
exports.CLICK_INPUT_DIRECTIVE = clickInput_1.CLICK_INPUT_DIRECTIVE;
var validation_1 = require('./src/directives/validation');
exports.VALIDATORS = validation_1.VALIDATORS;
var scrollIntoView_1 = require('./src/directives/scrollIntoView');
exports.ScrollDirective = scrollIntoView_1.ScrollDirective;
var pdfLink_1 = require('./src/directives/pdfLink');
exports.PdfLinkDirective = pdfLink_1.PdfLinkDirective;
var autocomplete_1 = require('./src/directives/autocomplete');
exports.AUTOCOMPLETE = autocomplete_1.AUTOCOMPLETE;
exports.AutocompleteComponent = autocomplete_1.AutocompleteComponent;
var slider_1 = require('./src/directives/slider');
exports.SLIDER = slider_1.SLIDER;
var expander_1 = require('./src/directives/expander');
exports.ExpanderComponent = expander_1.ExpanderComponent;
var clickOutside_1 = require('./src/directives/clickOutside');
exports.ClickOutsideDirective = clickOutside_1.ClickOutsideDirective;
var tooltip_1 = require('./src/directives/tooltip');
exports.TOOLTIP = tooltip_1.TOOLTIP;
var readOnlyInputs_1 = require('./src/directives/readOnlyInputs');
exports.READONLY_DIRECTIVES = readOnlyInputs_1.READONLY_DIRECTIVES;
var toggle_1 = require('./src/directives/toggle');
exports.Toggle = toggle_1.Toggle;
var navigationChevron_1 = require('./src/directives/navigationChevron');
exports.NavigationChevronDirective = navigationChevron_1.NavigationChevronDirective;
var ExtHighcharts = require('angular2-highcharts');
var tab_2 = require('./src/directives/tab');
exports.CHART_DIRECTIVES = ExtHighcharts.CHART_DIRECTIVES.concat([tab_2.TabChartResizer]);
var axisAlign_1 = require('./src/directives/axisAlign');
exports.ALIGN_TO_AXIS = axisAlign_1.ALIGN_TO_AXIS;
var clickAndHold_1 = require('./src/directives/clickAndHold');
exports.ClickAndHoldDirective = clickAndHold_1.ClickAndHoldDirective;



},{"./src/directives/autocomplete":44,"./src/directives/axisAlign":45,"./src/directives/checkedObjectAccessor":46,"./src/directives/clickAndHold":47,"./src/directives/clickInput":48,"./src/directives/clickOutside":49,"./src/directives/dateValueAccessor":50,"./src/directives/expander":51,"./src/directives/localenumberFormat":52,"./src/directives/navigationChevron":53,"./src/directives/numberFormat":54,"./src/directives/pdfLink":55,"./src/directives/readOnlyInputs":56,"./src/directives/scrollIntoView":57,"./src/directives/slider":58,"./src/directives/tab":59,"./src/directives/tabs":60,"./src/directives/toggle":61,"./src/directives/tooltip":62,"./src/directives/trimFormat":63,"./src/directives/validation":64,"angular2-highcharts":"angular2-highcharts"}],"@toolkit/interfaces":[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ng2_toastr_1 = require('ng2-toastr');
var ToastDefinition = (function (_super) {
    __extends(ToastDefinition, _super);
    function ToastDefinition(message, type, title) {
        _super.call(this, type || "info", message, title);
    }
    return ToastDefinition;
}(ng2_toastr_1.Toast));
exports.ToastDefinition = ToastDefinition;
(function (NavigationDirection) {
    NavigationDirection[NavigationDirection["forward"] = 1] = "forward";
    NavigationDirection[NavigationDirection["backward"] = -1] = "backward";
    NavigationDirection[NavigationDirection["sideways"] = 666] = "sideways";
})(exports.NavigationDirection || (exports.NavigationDirection = {}));
var NavigationDirection = exports.NavigationDirection;



},{"ng2-toastr":"ng2-toastr"}],"@toolkit/pipes":[function(require,module,exports){
"use strict";
var intPercentPipe_1 = require('./src/pipes/intPercentPipe');
exports.IntPercentPipe = intPercentPipe_1.IntPercentPipe;
var yesNoPipe_1 = require('./src/pipes/yesNoPipe');
exports.YesNoPipe = yesNoPipe_1.YesNoPipe;
var casingPipes_1 = require('./src/pipes/casingPipes');
exports.CamelPipe = casingPipes_1.CamelPipe;
exports.PascalPipe = casingPipes_1.PascalPipe;
var uniqueIdPipe_1 = require('./src/pipes/uniqueIdPipe');
exports.UniqueIdPipe = uniqueIdPipe_1.UniqueIdPipe;
var safeDatePipe_1 = require('./src/pipes/safeDatePipe');
exports.SafeDatePipe = safeDatePipe_1.SafeDatePipe;
var shortNumberPipe_1 = require('./src/pipes/shortNumberPipe');
exports.ShortNumberPipe = shortNumberPipe_1.ShortNumberPipe;
var enumKeysPipe_1 = require('./src/pipes/enumKeysPipe');
exports.KeysPipe = enumKeysPipe_1.KeysPipe;
var thresholdPipe_1 = require('./src/pipes/thresholdPipe');
exports.ThresholdPipe = thresholdPipe_1.ThresholdPipe;
var ordinalPipe_1 = require('./src/pipes/ordinalPipe');
exports.OrdinalPipe = ordinalPipe_1.OrdinalPipe;
var localeOrdinalPipe_1 = require('./src/pipes/localeOrdinalPipe');
exports.LocaleOrdinalPipe = localeOrdinalPipe_1.LocaleOrdinalPipe;
var isoDateOnlyPipe_1 = require('./src/pipes/isoDateOnlyPipe');
exports.IsoDateOnlyPipe = isoDateOnlyPipe_1.IsoDateOnlyPipe;
var localeNumberPipe_1 = require('./src/pipes/localeNumberPipe');
exports.LocaleNumberPipe = localeNumberPipe_1.LocaleNumberPipe;
var LocaleDatePipe_1 = require('./src/pipes/LocaleDatePipe');
exports.LocaleDatePipe = LocaleDatePipe_1.LocaleDatePipe;
var LocalePercentPipe_1 = require('./src/pipes/LocalePercentPipe');
exports.LocalePercentPipe = LocalePercentPipe_1.LocalePercentPipe;
var LocaleIntPercentPipe_1 = require('./src/pipes/LocaleIntPercentPipe');
exports.LocaleIntPercentPipe = LocaleIntPercentPipe_1.LocaleIntPercentPipe;
var LocaleShortNumberPipe_1 = require('./src/pipes/LocaleShortNumberPipe');
exports.LocaleShortNumberPipe = LocaleShortNumberPipe_1.LocaleShortNumberPipe;
var formatDatePipe_1 = require("./src/pipes/formatDatePipe");
exports.FormatDatePipe = formatDatePipe_1.FormatDatePipe;
exports.CUSTOM_PIPES = [intPercentPipe_1.IntPercentPipe, yesNoPipe_1.YesNoPipe, casingPipes_1.PascalPipe, casingPipes_1.CamelPipe, uniqueIdPipe_1.UniqueIdPipe, safeDatePipe_1.SafeDatePipe, shortNumberPipe_1.ShortNumberPipe, enumKeysPipe_1.KeysPipe, ordinalPipe_1.OrdinalPipe, thresholdPipe_1.ThresholdPipe, isoDateOnlyPipe_1.IsoDateOnlyPipe, localeNumberPipe_1.LocaleNumberPipe, LocaleDatePipe_1.LocaleDatePipe, LocalePercentPipe_1.LocalePercentPipe, LocaleIntPercentPipe_1.LocaleIntPercentPipe, LocaleShortNumberPipe_1.LocaleShortNumberPipe, localeOrdinalPipe_1.LocaleOrdinalPipe, formatDatePipe_1.FormatDatePipe];



},{"./src/pipes/LocaleDatePipe":65,"./src/pipes/LocaleIntPercentPipe":66,"./src/pipes/LocalePercentPipe":67,"./src/pipes/LocaleShortNumberPipe":68,"./src/pipes/casingPipes":69,"./src/pipes/enumKeysPipe":70,"./src/pipes/formatDatePipe":71,"./src/pipes/intPercentPipe":72,"./src/pipes/isoDateOnlyPipe":73,"./src/pipes/localeNumberPipe":74,"./src/pipes/localeOrdinalPipe":75,"./src/pipes/ordinalPipe":76,"./src/pipes/safeDatePipe":77,"./src/pipes/shortNumberPipe":78,"./src/pipes/thresholdPipe":79,"./src/pipes/uniqueIdPipe":80,"./src/pipes/yesNoPipe":81}],"@toolkit/reactiveComponent":[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var core_1 = require('@angular/core');
exports.QueryList = core_1.QueryList;
var forms_1 = require('@angular/forms');
var Rx = require('rxjs');
var ReactiveComponent = (function () {
    function ReactiveComponent() {
        this._subscriptions = [];
        this.__viewInit = new Rx.ReplaySubject(1);
        this._viewInit = this.__viewInit;
    }
    ReactiveComponent.prototype.ngOnDestroy = function () {
        if (this._subscriptions)
            this._subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    ReactiveComponent.prototype.ngAfterViewInit = function () {
        this.__viewInit.next(null);
        this.__viewInit.complete();
    };
    Object.defineProperty(ReactiveComponent.prototype, "$instance", {
        get: function () {
            return this;
        },
        enumerable: true,
        configurable: true
    });
    return ReactiveComponent;
}());
exports.ReactiveComponent = ReactiveComponent;
function dynamicFormDirectiveProvider(type) {
    return {
        provide: forms_1.ControlContainer,
        useExisting: core_1.forwardRef(type)
    };
}
exports.dynamicFormDirectiveProvider = dynamicFormDirectiveProvider;
var DynamicFormComponent = (function (_super) {
    __extends(DynamicFormComponent, _super);
    function DynamicFormComponent(_form) {
        _super.call(this);
        this._form = _form;
        this._subscriptions = [];
        this.__viewInit = new Rx.ReplaySubject(1);
        this._viewInit = this.__viewInit;
    }
    Object.defineProperty(DynamicFormComponent.prototype, "formDirective", {
        get: function () { return this._form; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicFormComponent.prototype, "path", {
        get: function () { return this._form.path; },
        enumerable: true,
        configurable: true
    });
    DynamicFormComponent.prototype.ngOnDestroy = function () {
        if (this._subscriptions)
            this._subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    DynamicFormComponent.prototype.ngAfterViewInit = function () {
        this.__viewInit.next(null);
        this.__viewInit.complete();
    };
    Object.defineProperty(DynamicFormComponent.prototype, "$instance", {
        get: function () {
            return this;
        },
        enumerable: true,
        configurable: true
    });
    return DynamicFormComponent;
}(forms_1.ControlContainer));
exports.DynamicFormComponent = DynamicFormComponent;



},{"@angular/core":"@angular/core","@angular/forms":"@angular/forms","rxjs":"rxjs"}],"@toolkit/services":[function(require,module,exports){
"use strict";
var userService_1 = require('./src/services/userService');
exports.UserService = userService_1.UserService;
var sharedDataService_1 = require('./src/services/sharedDataService');
exports.SharedDataService = sharedDataService_1.SharedDataService;
var clientService_1 = require('./src/services/clientService');
exports.ClientService = clientService_1.ClientService;
var runService_1 = require('./src/services/runService');
exports.RunService = runService_1.RunService;
var siteHeaderService_1 = require('./src/services/siteHeaderService');
exports.SiteHeaderService = siteHeaderService_1.SiteHeaderService;
var configService_1 = require('./src/services/configService');
exports.ConfigService = configService_1.ConfigService;
var pageService_1 = require('./src/services/pageService');
exports.PageService = pageService_1.PageService;
var applicationInsightsService_1 = require('./src/services/applicationInsightsService');
exports.ApplicationInsightsService = applicationInsightsService_1.ApplicationInsightsService;
var LanguageFormatterService_1 = require("./src/services/LanguageFormatterService");
exports.LanguageFormatterService = LanguageFormatterService_1.LanguageFormatterService;
var navigationService_1 = require('./src/services/navigationService');
exports.NavigationService = navigationService_1.NavigationService;
var referenceTranslationService_1 = require('./src/services/referenceTranslationService');
exports.ReferenceTranslationService = referenceTranslationService_1.ReferenceTranslationService;
var readOnlyInputs_1 = require('./src/directives/readOnlyInputs');
var translation_1 = require('./src/services/translation');
exports.ExtendedTranslateService = translation_1.ExtendedTranslateService;
exports.TranslateService = translation_1.TranslateService;
var WindowRef = (function () {
    function WindowRef() {
    }
    Object.defineProperty(WindowRef.prototype, "nativeElement", {
        get: function () { return window; },
        enumerable: true,
        configurable: true
    });
    return WindowRef;
}());
exports.WindowRef = WindowRef;
exports.INTERNAL_SHARED_SERVICES = [
    configService_1.ConfigService,
    clientService_1.ClientService,
    siteHeaderService_1.SiteHeaderService,
    userService_1.UserService,
    sharedDataService_1.SharedDataService,
    runService_1.RunService,
    applicationInsightsService_1.ApplicationInsightsService,
    pageService_1.PageService,
    LanguageFormatterService_1.LanguageFormatterService,
    WindowRef
].concat(translation_1.TRANSLATIONS, [
    { provide: readOnlyInputs_1.READONLY_PROVIDER, useExisting: runService_1.RunService },
    navigationService_1.NavigationService,
    referenceTranslationService_1.ReferenceTranslationService
]);



},{"./src/directives/readOnlyInputs":56,"./src/services/LanguageFormatterService":82,"./src/services/applicationInsightsService":83,"./src/services/clientService":84,"./src/services/configService":85,"./src/services/navigationService":86,"./src/services/pageService":87,"./src/services/referenceTranslationService":88,"./src/services/runService":89,"./src/services/sharedDataService":90,"./src/services/siteHeaderService":91,"./src/services/translation":92,"./src/services/userService":93}],1:[function(require,module,exports){
//! moment.js
//! version : 2.17.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    var k;
    for (k in obj) {
        // even if its not own property I'd still call it non-empty
        return false;
    }
    return true;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

var some$1 = some;

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

function isUndefined(input) {
    return input === void 0;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i in momentProperties) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _ordinalParseLenient.
    this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var keys$1 = keys;

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid()) {
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

var indexOf$1 = indexOf;

function daysInMonth(year, month) {
    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return this._months;
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return this._monthsShort;
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function createDate (y, m, d, h, M, s, ms) {
    //can't just apply() to create a date:
    //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
    var date = new Date(y, m, d, h, M, s, ms);

    //the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    //the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

//http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return this._weekdays;
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    ordinalParse: defaultOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            require('./locale/' + name);
            // because defineLocale currently also sets the global locale, we
            // want to undo that for lazy loaded locales
            getSetGlobalLocale(oldLocale);
        } catch (e) { }
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, parentConfig = baseConfig;
        // MERGE
        if (locales[name] != null) {
            parentConfig = locales[name]._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys$1(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
        hooks.createFromInputFallback(config);
    }
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse)) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }

    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (input === undefined) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (typeof(input) === 'object') {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    if (units === 'year' || units === 'month' || units === 'quarter') {
        output = monthDiff(this, that);
        if (units === 'quarter') {
            output = output / 3;
        } else if (units === 'year') {
            output = output / 12;
        }
    } else {
        delta = this - that;
        output = units === 'second' ? delta / 1e3 : // 1000
            units === 'minute' ? delta / 6e4 : // 1000 * 60
            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
            delta;
    }
    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString () {
    var m = this.clone().utc();
    if (0 < m.year() && m.year() <= 9999) {
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            return this.toDate().toISOString();
        } else {
            return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
        }
    } else {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 < this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$1 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$1;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    ordinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function get$2 (units) {
    units = normalizeUnits(units);
    return this[units + 's']();
}

function makeGetter(name) {
    return function () {
        return this._data[name];
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    s: 45,  // seconds to minute
    m: 45,  // minutes to hour
    h: 22,  // hours to day
    d: 26,  // days to month
    M: 11   // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds < thresholds.s && ['s', seconds]  ||
            minutes <= 1           && ['m']           ||
            minutes < thresholds.m && ['mm', minutes] ||
            hours   <= 1           && ['h']           ||
            hours   < thresholds.h && ['hh', hours]   ||
            days    <= 1           && ['d']           ||
            days    < thresholds.d && ['dd', days]    ||
            months  <= 1           && ['M']           ||
            months  < thresholds.M && ['MM', months]  ||
            years   <= 1           && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    return true;
}

function humanize (withSuffix) {
    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds;
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    return (total < 0 ? '-' : '') +
        'P' +
        (Y ? Y + 'Y' : '') +
        (M ? M + 'M' : '') +
        (D ? D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? h + 'H' : '') +
        (m ? m + 'M' : '') +
        (s ? s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.17.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

},{}],2:[function(require,module,exports){
arguments[4]["@toolkit/reactiveComponent"][0].apply(exports,arguments)
},{"@angular/core":"@angular/core","@angular/forms":"@angular/forms","dup":"@toolkit/reactiveComponent","rxjs":"rxjs"}],3:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var ajaxProxy_1 = require('./ajaxProxy');
var core_1 = require('@angular/core');
var ClientsProxy = (function () {
    function ClientsProxy(_http) {
        this._http = _http;
    }
    ClientsProxy.prototype.search = function (term) {
        return this._http.get("/api/clients/search/" + encodeURIComponent(term), null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    ClientsProxy.prototype.clientSearch = function (term) {
        return this._http.post("/api/clients/clientsearch", term || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    ClientsProxy.prototype.get = function (id) {
        return this._http.get("/api/clients/" + id, null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    ClientsProxy.prototype.getDetails = function (id) {
        return this._http.get("/api/clients/" + id + "/details", null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    ClientsProxy = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [ajaxProxy_1.ProxyHttp])
    ], ClientsProxy);
    return ClientsProxy;
}());
exports.ClientsProxy = ClientsProxy;



},{"./ajaxProxy":14,"@angular/core":"@angular/core"}],4:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var ajaxProxy_1 = require('./ajaxProxy');
var core_1 = require('@angular/core');
var CurrencyProxy = (function () {
    function CurrencyProxy(_http) {
        this._http = _http;
    }
    CurrencyProxy.prototype.list = function (modelName) {
        return this._http.get("/api/currency/" + modelName, null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    CurrencyProxy.prototype.changeCurrency = function (data) {
        return this._http.post("/api/currency/change", data || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    CurrencyProxy = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [ajaxProxy_1.ProxyHttp])
    ], CurrencyProxy);
    return CurrencyProxy;
}());
exports.CurrencyProxy = CurrencyProxy;



},{"./ajaxProxy":14,"@angular/core":"@angular/core"}],5:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var ajaxProxy_1 = require('./ajaxProxy');
var core_1 = require('@angular/core');
var ErrorProxy = (function () {
    function ErrorProxy(_http) {
        this._http = _http;
    }
    ErrorProxy.prototype.error = function (error) {
        return this._http.post("/api/error", error || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    ErrorProxy = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [ajaxProxy_1.ProxyHttp])
    ], ErrorProxy);
    return ErrorProxy;
}());
exports.ErrorProxy = ErrorProxy;



},{"./ajaxProxy":14,"@angular/core":"@angular/core"}],6:[function(require,module,exports){
"use strict";
(function (NavigationType) {
    NavigationType[NavigationType["none"] = 0] = "none";
    NavigationType[NavigationType["persist"] = 1] = "persist";
    NavigationType[NavigationType["persistAndExecute"] = 2] = "persistAndExecute";
    NavigationType[NavigationType["persistAndProcess"] = 3] = "persistAndProcess";
})(exports.NavigationType || (exports.NavigationType = {}));
var NavigationType = exports.NavigationType;



},{}],7:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var http_1 = require('@angular/http');
var core_1 = require('@angular/core');
var ModulesProxy = (function () {
    function ModulesProxy(_http) {
        this._http = _http;
    }
    ModulesProxy.prototype.modules = function () {
        return this._http.get("/api/modules", null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    ModulesProxy = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [http_1.Http])
    ], ModulesProxy);
    return ModulesProxy;
}());
exports.ModulesProxy = ModulesProxy;



},{"@angular/core":"@angular/core","@angular/http":"@angular/http"}],8:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var http_1 = require('@angular/http');
var core_1 = require('@angular/core');
var PdfProxy = (function () {
    function PdfProxy(_http) {
        this._http = _http;
    }
    PdfProxy.downloadReport_url = function (runId, pdfName, language, parameter) {
        return { method: 'get', url: "/api/pdf/" + runId + "/" + pdfName + "?language=" + language + "&parameter=" + parameter };
    };
    PdfProxy = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [http_1.Http])
    ], PdfProxy);
    return PdfProxy;
}());
exports.PdfProxy = PdfProxy;



},{"@angular/core":"@angular/core","@angular/http":"@angular/http"}],9:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var http_1 = require('@angular/http');
var core_1 = require('@angular/core');
var ProxyProxy = (function () {
    function ProxyProxy(_http) {
        this._http = _http;
    }
    ProxyProxy.prototype.authenticateWindowsAuth = function () {
        return this._http.get("/api/proxy/windowsauth", null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    ProxyProxy.prototype.useWindowsAuth = function () {
        return this._http.get("/api/proxy/usewindowsauth", null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    ProxyProxy.prototype.login = function (logonDetails) {
        return this._http.post("/api/proxy/login", logonDetails || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    ProxyProxy.prototype.proxy = function (proxyDetails) {
        return this._http.post("/api/proxy/ajax", proxyDetails || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    ProxyProxy.prototype.binary = function (id, body) {
        return this._http.post("/api/proxy/binary/" + id, body || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    ProxyProxy.prototype.binaryUpload = function (binary, fwdUri) {
        return this._http.post("/api/proxy/binary-upload/" + fwdUri, binary || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    ProxyProxy.redirector_url = function (backendUri) {
        return { method: 'get', url: "/api/proxy/redirector/" + backendUri };
    };
    ProxyProxy.binary_url = function (id) {
        return { method: 'get', url: "/api/proxy/binary/" + id };
    };
    ProxyProxy = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [http_1.Http])
    ], ProxyProxy);
    return ProxyProxy;
}());
exports.ProxyProxy = ProxyProxy;



},{"@angular/core":"@angular/core","@angular/http":"@angular/http"}],10:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var http_1 = require('@angular/http');
var core_1 = require('@angular/core');
var ReferenceTranslationProxy = (function () {
    function ReferenceTranslationProxy(_http) {
        this._http = _http;
    }
    ReferenceTranslationProxy.prototype.getReferenceTranslationValues = function (culture) {
        return this._http.get("/api/referenceTranslation/translationValues/" + encodeURIComponent(culture), null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    ReferenceTranslationProxy = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [http_1.Http])
    ], ReferenceTranslationProxy);
    return ReferenceTranslationProxy;
}());
exports.ReferenceTranslationProxy = ReferenceTranslationProxy;



},{"@angular/core":"@angular/core","@angular/http":"@angular/http"}],11:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var ajaxProxy_1 = require('./ajaxProxy');
var core_1 = require('@angular/core');
var RunsProxy = (function () {
    function RunsProxy(_http) {
        this._http = _http;
    }
    RunsProxy.prototype.createRun = function (model, data) {
        return this._http.post("/api/runs/" + encodeURIComponent(model), data || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    RunsProxy.prototype.get = function (runId) {
        return this._http.get("/api/runs/" + runId, null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    RunsProxy.prototype.countRuns = function (model, clientId) {
        return this._http.get("/api/runs/" + encodeURIComponent(model) + "/" + clientId + "/count", null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    RunsProxy.prototype.list = function (model, clientId) {
        return this._http.get("/api/runs/" + encodeURIComponent(model) + "/" + clientId, null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    RunsProxy.prototype.clone = function (options) {
        return this._http.post("/api/runs/clone", options || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    RunsProxy.prototype.delete = function (runId) {
        return this._http.delete("/api/runs/" + runId, null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    RunsProxy.prototype.updateRunInfo = function (runId, info) {
        return this._http.put("/api/runs/" + runId + "/info", info || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    RunsProxy.prototype.updateRunJson = function (runId, run) {
        return this._http.put("/api/runs/" + runId + "/model", run || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    RunsProxy.prototype.updateRunStage = function (runId, run) {
        return this._http.put("/api/runs/" + runId + "/stage", run || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    RunsProxy.prototype.execute = function (runId, execution) {
        return this._http.post("/api/runs/" + runId + "/execute", execution || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    RunsProxy.prototype.createShare = function (runId, options) {
        return this._http.post("/api/runs/" + runId + "/share/create", options || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    RunsProxy.prototype.manageShares = function (runId, options) {
        return this._http.put("/api/runs/" + runId + "/share/management", options || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    RunsProxy.prototype.getFinalRunIds = function (model, clientId, policyYear) {
        return this._http.get("/api/runs/finalized/" + encodeURIComponent(model) + "/" + clientId + "/" + policyYear, null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    RunsProxy.prototype.setRunStatus = function (model, runId, isFinalized, policyYear) {
        return this._http.post("/api/runs/finalize/" + encodeURIComponent(model) + "/" + runId + "/" + isFinalized + "/" + policyYear, null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    RunsProxy.prototype.setProspectStatus = function (model, runId, isProspect) {
        return this._http.post("/api/runs/prospect/" + runId + "/" + isProspect + "?model=" + encodeURIComponent(model), null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    RunsProxy.prototype.getLobsFromRun = function (runId) {
        return this._http.get("/api/runs/getLobs/" + runId, null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    RunsProxy.prototype.getFinalRunsForYear = function (modelId, year, clientId) {
        return this._http.get("/api/runs/getFinalRunsForYear/" + encodeURIComponent(modelId) + "/" + year + "?clientId=" + clientId, null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    RunsProxy.prototype.setMultipleRunAsFinal = function (finalRuns) {
        return this._http.post("/api/runs/setMultipleRunAsFinal", finalRuns || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    RunsProxy.prototype.deselectFinalRunWithLob = function (runId, lob) {
        return this._http.post("/api/runs/deselectFinalRunWithLob?runId=" + runId + "&lob=" + encodeURIComponent(lob), null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    RunsProxy.prototype.getFullFinalRuns = function (modelId, clientId) {
        return this._http.get("/api/runs/getFullFinalRuns/" + encodeURIComponent(modelId) + "/" + clientId, null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    RunsProxy.prototype.getLobsFromFinalRun = function (runId) {
        return this._http.get("/api/runs/getLobsFromFinalRun/" + runId, null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    RunsProxy.prototype.updateFinalRunDetails = function (runId, displayName) {
        return this._http.post("/api/runs/updateFinalRunDetails/" + runId + "/" + encodeURIComponent(displayName), null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    RunsProxy.prototype.deleteFinalRun = function (runId) {
        return this._http.post("/api/runs/deleteFinalRun/" + runId, null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    RunsProxy.createIntegrationRun_url = function (model, data) {
        return { method: 'post', url: "/api/runs/" + encodeURIComponent(model) + "/integration/create" };
    };
    RunsProxy.executeIntegrationRun_url = function (model, runId) {
        return { method: 'post', url: "/api/runs/" + encodeURIComponent(model) + "/" + runId + "/integration/execute" };
    };
    RunsProxy.getIntegrationRunDetail_url = function (model, runId) {
        return { method: 'get', url: "/api/runs/" + encodeURIComponent(model) + "/" + runId + "/integration/detail" };
    };
    RunsProxy = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [ajaxProxy_1.ProxyHttp])
    ], RunsProxy);
    return RunsProxy;
}());
exports.RunsProxy = RunsProxy;



},{"./ajaxProxy":14,"@angular/core":"@angular/core"}],12:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var http_1 = require('@angular/http');
var core_1 = require('@angular/core');
var SettingsProxy = (function () {
    function SettingsProxy(_http) {
        this._http = _http;
    }
    SettingsProxy.prototype.get = function () {
        return this._http.get("/api/settings", null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    SettingsProxy = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [http_1.Http])
    ], SettingsProxy);
    return SettingsProxy;
}());
exports.SettingsProxy = SettingsProxy;



},{"@angular/core":"@angular/core","@angular/http":"@angular/http"}],13:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var ajaxProxy_1 = require('./ajaxProxy');
var core_1 = require('@angular/core');
var UserProxy = (function () {
    function UserProxy(_http) {
        this._http = _http;
    }
    UserProxy.prototype.get = function () {
        return this._http.get("/api/user", null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    UserProxy.prototype.verify = function () {
        return this._http.get("/api/user/verify", null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    UserProxy.prototype.find = function (term) {
        return this._http.get("/api/user/find/" + term, null || {}).map(function (ret) { return ({ data: ret.json(), originalResponse: ret }); });
    };
    UserProxy = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [ajaxProxy_1.ProxyHttp])
    ], UserProxy);
    return UserProxy;
}());
exports.UserProxy = UserProxy;



},{"./ajaxProxy":14,"@angular/core":"@angular/core"}],14:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var rx_1 = require('rxjs');
var ProxyController_1 = require('./ProxyController');
var userService_1 = require('../services/userService');
var ProxyHttp = (function () {
    function ProxyHttp(_proxy, _userService) {
        this._proxy = _proxy;
        this._userService = _userService;
    }
    ProxyHttp.prototype.makeRequest = function (request) {
        var _this = this;
        var stream = this._proxy.proxy(request).map(function (ret) { return ret.originalResponse; }).catch(function (error) {
            if (error.status === 401) {
                _this._userService.unauthorized();
                return _this._userService.reauthorized.take(1).flatMap(function () { return _this.makeRequest(request); });
            }
            else
                return rx_1.Observable.throw(error);
        });
        ;
        return stream;
    };
    ProxyHttp.prototype.binaryRequest = function (body) {
        var _this = this;
        var stream = this._proxy.binaryUpload(body.binary, body.url).map(function (ret) { return ret.originalResponse; }).catch(function (error) {
            if (error.status === 401) {
                _this._userService.unauthorized();
                return _this._userService.reauthorized.take(1).flatMap(function () { return _this.binaryRequest(body); });
            }
            else
                return rx_1.Observable.throw(error);
        });
        ;
        return stream;
    };
    ProxyHttp.prototype.get = function (url, options) { return this.makeRequest({ data: null, url: url, verb: 'get', }); };
    ProxyHttp.prototype.post = function (url, body, options) {
        if (body instanceof ArrayBuffer) {
            return this.binaryRequest({ binary: body, url: url });
        }
        if (body instanceof BinaryTransferObject) {
            return this.binaryRequest({ binary: body.serialize(), url: url });
        }
        else
            return this.makeRequest({ data: body && JSON.stringify(body), url: url, verb: 'post', });
    };
    ProxyHttp.prototype.put = function (url, body, options) { return this.makeRequest({ data: body && JSON.stringify(body), url: url, verb: 'put', }); };
    ProxyHttp.prototype.delete = function (url, options) { return this.makeRequest({ data: null, url: url, verb: 'delete', }); };
    ProxyHttp = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [ProxyController_1.ProxyProxy, userService_1.UserService])
    ], ProxyHttp);
    return ProxyHttp;
}());
exports.ProxyHttp = ProxyHttp;
var utf8 = {};
utf8.toByteArray = function (str) {
    var byteArray = [];
    for (var i = 0; i < str.length; i++)
        if (str.charCodeAt(i) <= 0x7F)
            byteArray.push(str.charCodeAt(i));
        else {
            var h = encodeURIComponent(str.charAt(i)).substr(1).split('%');
            for (var j = 0; j < h.length; j++)
                byteArray.push(parseInt(h[j], 16));
        }
    return byteArray;
};
utf8.parse = function (byteArray) {
    var str = '';
    for (var i = 0; i < byteArray.length; i++)
        str += byteArray[i] <= 0x7F ?
            byteArray[i] === 0x25 ? "%25" :
                String.fromCharCode(byteArray[i]) :
            "%" + byteArray[i].toString(16).toUpperCase();
    return decodeURIComponent(str);
};
var BinaryTransferObject = (function () {
    function BinaryTransferObject(value, binaries) {
        this.value = value;
        if (binaries instanceof ArrayBuffer)
            this.contents = [binaries];
        else
            this.contents = binaries;
    }
    BinaryTransferObject.prototype.numToArr = function (num) {
        var lengthArr = [];
        while (num > 0) {
            if (num > 255) {
                lengthArr.push(255);
                num -= 255;
            }
            else {
                lengthArr.push(num);
                break;
            }
        }
        lengthArr.push(0);
        return lengthArr;
    };
    BinaryTransferObject.prototype.serialize = function () {
        var _this = this;
        var source = this.contents.map(function (o) { return new Uint8Array(o); });
        var lengths = source.map(function (o) { return _this.numToArr(o.length); });
        if (!!this.value) {
            var bytes = utf8.toByteArray(JSON.stringify(this.value, null, null));
            var dataLength = this.numToArr(bytes.length);
            source = [bytes].concat(source);
            lengths = [dataLength].concat(lengths);
        }
        var totalLength = source.reduce(function (acc, o) { return acc + o.length; }, 0) + lengths.reduce(function (acc, o) { return acc + o.length; }, 0);
        var data = new Uint8Array(totalLength);
        var offset = 0;
        source.forEach(function (item, index) {
            var prefix = lengths[index];
            data.set(prefix, offset);
            offset += prefix.length;
            data.set(item, offset);
            offset += item.length;
        });
        return data.buffer;
    };
    return BinaryTransferObject;
}());
exports.BinaryTransferObject = BinaryTransferObject;



},{"../services/userService":93,"./ProxyController":9,"@angular/core":"@angular/core","rxjs":"rxjs"}],15:[function(require,module,exports){
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./ModelDescription'));



},{"./ModelDescription":6}],16:[function(require,module,exports){
"use strict";
var PdfContext = (function () {
    function PdfContext(run, client, model, currencies, pdfIdentifier, ready) {
        this.run = run;
        this.client = client;
        this.model = model;
        this.currencies = currencies;
        this.pdfIdentifier = pdfIdentifier;
        this.ready = ready;
    }
    return PdfContext;
}());
exports.PdfContext = PdfContext;



},{}],17:[function(require,module,exports){
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var ModulesController_1 = require('./ModulesController');
var ClientsController_1 = require('./ClientsController');
var RunsController_1 = require('./RunsController');
var ProxyController_1 = require('./ProxyController');
var UserController_1 = require('./UserController');
var CurrencyController_1 = require('./CurrencyController');
var ErrorController_1 = require('./ErrorController');
var ReferenceTranslationController_1 = require('./ReferenceTranslationController');
var SettingsController_1 = require('./SettingsController');
var ajaxProxy_1 = require('./ajaxProxy');
var userService_1 = require('../services/userService');
__export(require('./ModulesController'));
__export(require('./ClientsController'));
__export(require('./RunsController'));
__export(require('./ProxyController'));
__export(require('./UserController'));
__export(require('./CurrencyController'));
__export(require('./ErrorController'));
__export(require('./ReferenceTranslationController'));
__export(require('./SettingsController'));
var Pdf = require('./PdfController');
exports.Pdf = Pdf;
exports.WEBAPI_PROVIDERS = [userService_1.UserService, ajaxProxy_1.ProxyHttp, ModulesController_1.ModulesProxy, ClientsController_1.ClientsProxy, RunsController_1.RunsProxy, ProxyController_1.ProxyProxy, ErrorController_1.ErrorProxy, UserController_1.UserProxy, Pdf.PdfProxy, CurrencyController_1.CurrencyProxy, ReferenceTranslationController_1.ReferenceTranslationProxy, SettingsController_1.SettingsProxy];



},{"../services/userService":93,"./ClientsController":3,"./CurrencyController":4,"./ErrorController":5,"./ModulesController":7,"./PdfController":8,"./ProxyController":9,"./ReferenceTranslationController":10,"./RunsController":11,"./SettingsController":12,"./UserController":13,"./ajaxProxy":14}],18:[function(require,module,exports){
"use strict";
var main_1 = require('./main');
var Rx = require('rxjs');
function TrackChanges(options) {
    return function (target, key) {
        if (!target.$$trackedObjects)
            target.$$trackedObjects = [];
        target.$$trackedObjects.push(Object.assign({ $key: key }, options || {}));
    };
}
exports.TrackChanges = TrackChanges;
function ChangeTracker(options) {
    return function (targetProto, key) {
        if (!targetProto.ngDoCheck)
            targetProto.ngDoCheck = function () { };
        Object.defineProperty(targetProto, key, {
            get: function () {
                if (this.$$changeTracker)
                    return this.$$changeTracker;
                var changes = new main_1.Changes(this);
                var original = function () { };
                if (this.ngDoCheck) {
                    original = this.ngDoCheck;
                }
                var interval = options && options.interval || 250;
                var subj = new Rx.Subject();
                subj.sampleTime(interval).subscribe(function () { return changes.performChecks(); });
                this.ngDoCheck = function () { original(); subj.next(null); };
                this.$$changeTracker = changes;
                return changes;
            }
        });
    };
}
exports.ChangeTracker = ChangeTracker;



},{"./main":19,"rxjs":"rxjs"}],19:[function(require,module,exports){
"use strict";
var diff = require('deep-diff');
function union_arrays(x, y) {
    var obj = {};
    for (var i = x.length - 1; i >= 0; --i)
        obj[x[i]] = x[i];
    for (var i = y.length - 1; i >= 0; --i)
        obj[y[i]] = y[i];
    var res = [];
    for (var k in obj) {
        if (obj.hasOwnProperty(k))
            res.push(obj[k]);
    }
    return res;
}
;
;
var Changes = (function () {
    function Changes(subject) {
        this.subject = subject;
        this._isChanged = false;
    }
    Changes.prototype.performChecks = function (ignoreTrackSet) {
        var _this = this;
        if (ignoreTrackSet === void 0) { ignoreTrackSet = false; }
        var changed = false;
        if (this.map && this.changes)
            this.subject.$$trackedObjects.forEach(function (obj) {
                var key = obj.$key;
                _this.updateChanges(obj, ignoreTrackSet);
                if (_this.changes[key] && _this.changes[key].active)
                    changed = true;
            });
        this._isChanged = changed;
    };
    Object.defineProperty(Changes.prototype, "isChanged", {
        get: function () { return this._isChanged; },
        enumerable: true,
        configurable: true
    });
    Changes.prototype.updateChanges = function (obj, ignoreTrackSet) {
        var key = obj.$key;
        if (obj.itemKey) {
            var left_1 = (this.map[key] || []);
            var right_1 = (this.subject[key] || []);
            var allKeys = union_arrays(left_1.map(function (o) { return o[obj.itemKey]; }), right_1.map(function (o) { return o[obj.itemKey]; }));
            var itemChanges_1 = {};
            var active_1 = false;
            allKeys.forEach(function (key) {
                var itemDiff = diff.diff(left_1.find(function (i) { return i[obj.itemKey] === key; }), right_1.find(function (i) { return i[obj.itemKey] === key; }));
                itemChanges_1[key.toString()] = itemDiff;
                if (itemDiff && itemDiff.length)
                    active_1 = true;
            });
            this.changes[key] = { items: itemChanges_1, active: active_1, hasDifference: active_1 };
        }
        else if (obj.trackSet && !ignoreTrackSet) {
            var changes = false;
            var directDiff_1 = diff.diff(this.map[key], this.subject[key]);
            if (directDiff_1) {
                obj.trackSet.forEach(function (item) {
                    var splitItem = item.split(".");
                    var className = splitItem[0], methodName = splitItem[1];
                    directDiff_1.forEach(function (obj) {
                        if (obj.path) {
                            if (obj.path.findIndex(function (x) { return x.toString().toLowerCase() === className.toLowerCase(); }) > -1 &&
                                obj.path.findIndex(function (x) { return x.toString().toLowerCase() === methodName.toLowerCase(); }) > -1)
                                changes = true;
                        }
                    });
                });
            }
            this.changes[key] = { direct: directDiff_1, active: changes, hasDifference: directDiff_1 && !!directDiff_1.length };
        }
        else {
            var directDiff = diff.diff(this.map[key], this.subject[key]);
            this.changes[key] = {
                direct: directDiff, active: directDiff && !!directDiff.length, hasDifference: directDiff && !!directDiff.length
            };
        }
    };
    Changes.prototype.getTokens = function (path) {
        var tokens;
        if (typeof path === 'string')
            tokens = path.split(/[[\].]/).filter(function (s) { return !!s; });
        else
            tokens = path;
        return tokens;
    };
    Changes.prototype.getAffectedDiffs = function (changes, tokens) {
        return changes.filter(function (change) { return tokens.every(function (item, index) {
            if (index === 0)
                return true;
            else
                return change.path[index] == item;
        }); });
    };
    Changes.prototype._doLogic = function (tokens, action, aggregation) {
        var changes = this.changes[tokens[0]];
        if (!changes || !changes.hasDifference)
            return action([], []);
        if (changes.direct)
            return action(changes.direct, tokens.slice(1), tokens.slice(0, 1));
        else if (changes.items) {
            if (tokens.length >= 2) {
                var item = changes.items[tokens[1]];
                return action(item, tokens.slice(2), tokens.slice(0, 2));
            }
            else {
                var results = Object.keys(changes.items).map(function (path) {
                    var item = changes.items[path];
                    return action(item, [], [tokens[0], path]);
                });
                if (aggregation)
                    return aggregation(results);
                return null;
            }
        }
    };
    Changes.prototype.isChangedAt = function (path) {
        var _this = this;
        if (!this.changes)
            return false;
        var tokens = this.getTokens(path);
        if (!tokens.length)
            return false;
        return this._doLogic(tokens, function (diffs, rpath) {
            if (!diffs || !diffs.length)
                return false;
            if (rpath.length === 0)
                return true;
            return !!_this.getAffectedDiffs(diffs, rpath).length;
        }, function (hits) { return hits.some(function (x) { return x; }); });
    };
    Object.defineProperty(Changes.prototype, "raw", {
        get: function () {
            return this.changes;
        },
        enumerable: true,
        configurable: true
    });
    Changes.prototype.commit = function (path) {
        var _this = this;
        if (!path || !path.length) {
            this.map = {};
            this.changes = {};
            this.subject.$$trackedObjects.forEach(function (obj) {
                var key = obj.$key;
                _this.map[key] = _this.subject[key] ? JSON.parse(JSON.stringify(_this.subject[key])) : undefined;
            });
        }
        else {
            var tokens_1 = this.getTokens(path);
            if (!tokens_1.length)
                return;
            var obj_1 = this.subject.$$trackedObjects.find(function (o) { return o.$key === tokens_1[0]; });
            var key = obj_1.$key;
            if (tokens_1.length === 1) {
                this.map[key] = this.subject[key] ? JSON.parse(JSON.stringify(this.subject[key])) : undefined;
                this.changes[key] = undefined;
            }
            else {
                this.updateChanges(obj_1, true);
                this._doLogic(tokens_1, function (diffs, rpath, ppath) {
                    if (diffs && rpath && ppath) {
                        if (ppath.length === 1) {
                            var patches = _this.getAffectedDiffs(diffs, rpath);
                            patches.forEach(function (p) { return diff.applyChange(_this.map[ppath[0]], _this.subject[ppath[0]], p); });
                        }
                        else if (ppath.length === 2) {
                            var lhs_1 = _this.map[ppath[0]].findIndex(function (o) { return o[obj_1.itemKey] == ppath[1]; });
                            var rhs_1 = _this.subject[ppath[0]].findIndex(function (o) { return o[obj_1.itemKey] == ppath[1]; });
                            if (lhs_1 === -1 && rhs_1 === -1)
                                return;
                            if (lhs_1 === -1)
                                _this.map[ppath[0]].push(JSON.parse(JSON.stringify(_this.subject[ppath[0]][rhs_1])));
                            else if (rhs_1 === -1)
                                _this.map[ppath[0]].splice(lhs_1, 1);
                            else {
                                var patches = _this.getAffectedDiffs(diffs, rpath);
                                patches.forEach(function (p) { return diff.applyChange(_this.map[ppath[0]][lhs_1], _this.subject[ppath[0]][rhs_1], p); });
                            }
                        }
                    }
                });
                this.updateChanges(obj_1, true);
            }
        }
    };
    Changes.prototype.undo = function (path) {
        var _this = this;
        if (!path || !path.length) {
            if (!this.isChanged)
                return;
            this.changes = {};
            this.subject.$$trackedObjects.forEach(function (obj) {
                var key = obj.$key;
                if (_this.map[key]) {
                    if (typeof _this.map[key] === 'object')
                        Object.assign(_this.subject[key], JSON.parse(JSON.stringify(_this.map[key])));
                    else
                        _this.subject[key] = JSON.parse(JSON.stringify(_this.map[key]));
                }
                else
                    _this.subject[key] = undefined;
            });
        }
        else {
            if (!this.isChangedAt(path))
                return;
            var tokens_2 = this.getTokens(path);
            if (!tokens_2.length)
                return;
            var obj_2 = this.subject.$$trackedObjects.find(function (o) { return o.$key === tokens_2[0]; });
            var key = obj_2.$key;
            if (tokens_2.length === 1) {
                if (this.map[key]) {
                    if (typeof this.map[key] === 'object')
                        Object.assign(this.subject[key], JSON.parse(JSON.stringify(this.map[key])));
                    else
                        this.subject[key] = JSON.parse(JSON.stringify(this.map[key]));
                }
                this.subject[key] = undefined;
                this.changes[key] = undefined;
            }
            else {
                this.updateChanges(obj_2, true);
                this._doLogic(tokens_2, function (diffs, rpath, ppath) {
                    if (ppath && diffs && rpath) {
                        if (ppath.length === 1) {
                            var patches = _this.getAffectedDiffs(diffs, rpath);
                            patches.forEach(function (p) { return diff.revertChange(_this.subject[ppath[0]], _this.map[ppath[0]], p); });
                        }
                        else if (ppath.length === 2) {
                            var lhs_2 = _this.map[ppath[0]].findIndex(function (o) { return o[obj_2.itemKey] == ppath[1]; });
                            var rhs_2 = _this.subject[ppath[0]].findIndex(function (o) { return o[obj_2.itemKey] == ppath[1]; });
                            if (lhs_2 === -1 && rhs_2 === -1)
                                return;
                            if (lhs_2 === -1)
                                _this.subject[ppath[0]].splice(rhs_2, 1);
                            else if (rhs_2 === -1)
                                _this.subject[ppath[0]].push(JSON.parse(JSON.stringify(_this.map[ppath[0]][lhs_2])));
                            else {
                                var patches = _this.getAffectedDiffs(diffs, rpath);
                                patches.forEach(function (p) { return diff.revertChange(_this.subject[ppath[0]][rhs_2], _this.map[ppath[0]][lhs_2], p); });
                            }
                        }
                    }
                });
                this.updateChanges(obj_2, true);
            }
        }
    };
    return Changes;
}());
exports.Changes = Changes;



},{"deep-diff":"deep-diff"}],20:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var angular2_modal_1 = require('angular2-modal');
var backend_1 = require("../../backend");
var services_1 = require('../../../@toolkit/services');
var FinalRunModalDeselect = (function () {
    function FinalRunModalDeselect(dialog, _runs, _sharedDataService, _translate) {
        this.dialog = dialog;
        this._runs = _runs;
        this._sharedDataService = _sharedDataService;
        this._translate = _translate;
    }
    FinalRunModalDeselect.prototype.ngOnInit = function () {
        this.currentRunId = this._sharedDataService.getOption("runId");
        this.getLobsForSelectedRun(this.currentRunId);
    };
    FinalRunModalDeselect.prototype.close = function (value) {
        this.deSelectFinalRun();
        this.flag = true;
        this.dialog.context.defaultResult = true;
        this.dialog.close();
    };
    FinalRunModalDeselect.prototype.cancel = function () {
        this.flag = false;
        this.dialog.context.defaultResult = false;
        this.dialog.dismiss();
    };
    FinalRunModalDeselect.prototype.beforeDismiss = function () {
        return this.flag;
    };
    FinalRunModalDeselect.prototype.beforeClose = function () {
        return false;
    };
    FinalRunModalDeselect.prototype.getLobsForSelectedRun = function (runId) {
        var _this = this;
        this._runs.getLobsFromFinalRun(runId).subscribe(function (x) {
            _this.lobs = x.data;
            _this.currentLob = _this.lobs[0];
        });
    };
    FinalRunModalDeselect.prototype.onLobSelectionChange = function (selectedLob) {
        this.currentLob = selectedLob;
    };
    FinalRunModalDeselect.prototype.deSelectFinalRun = function () {
        this._runs.deselectFinalRunWithLob(this.currentRunId, this.currentLob).subscribe(function (x) { });
    };
    FinalRunModalDeselect = __decorate([
        core_1.Component({
            selector: 'final-run-deselectmodal-content',
            template: require('./finalRunModalDeselect.html'),
            moduleId: module.id
        }), 
        __metadata('design:paramtypes', [angular2_modal_1.DialogRef, backend_1.Api.RunsProxy, services_1.SharedDataService, services_1.TranslateService])
    ], FinalRunModalDeselect);
    return FinalRunModalDeselect;
}());
exports.FinalRunModalDeselect = FinalRunModalDeselect;



},{"../../../@toolkit/services":"@toolkit/services","../../backend":"@toolkit/backend","./finalRunModalDeselect.html":30,"@angular/core":"@angular/core","angular2-modal":"angular2-modal"}],21:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var angular2_modal_1 = require('angular2-modal');
var backend_1 = require("../../backend");
var configService_1 = require("../services/configService");
var services_1 = require('../../../@toolkit/services');
var loadingIndicator_1 = require("./loadingIndicator");
var applicationInsightsService_1 = require("../services/applicationInsightsService");
var FinalRunModalSelect = (function () {
    function FinalRunModalSelect(dialog, _runs, _config, _sharedDataService, _translate, _applicationInsightsService) {
        this.dialog = dialog;
        this._runs = _runs;
        this._config = _config;
        this._sharedDataService = _sharedDataService;
        this._translate = _translate;
        this._applicationInsightsService = _applicationInsightsService;
    }
    FinalRunModalSelect.prototype.ngOnInit = function () {
        this.currentYear = new Date().getFullYear();
        this.currentRunId = this._sharedDataService.getOption("runId");
        this.currentModelId = this._sharedDataService.getOption("modelId");
        this.runName = this._sharedDataService.getOption("name");
        this.clientId = this._sharedDataService.getOption("clientId");
        this.policyYearArr = this.getPolicyYear();
        this.getLobsForSelectedRun(this.currentRunId);
    };
    FinalRunModalSelect.prototype.close = function (value) {
        this.markRunAsFinal();
        this.flag = true;
        this.dialog.context.defaultResult = true;
        this.dialog.close(this.currentYear);
    };
    FinalRunModalSelect.prototype.cancel = function () {
        this.flag = false;
        this.dialog.context.defaultResult = false;
        this.dialog.dismiss();
    };
    FinalRunModalSelect.prototype.beforeDismiss = function () {
        return this.flag;
    };
    FinalRunModalSelect.prototype.beforeClose = function () {
        return false;
    };
    FinalRunModalSelect.prototype.getPolicyYear = function () {
        var currentYear = new Date().getFullYear();
        var i = 0;
        var arraySize = currentYear - 2015;
        var arrYears = new Array(arraySize);
        for (i = 0; i <= arraySize; i++) {
            arrYears[i] = (currentYear - i);
        }
        return arrYears;
    };
    FinalRunModalSelect.prototype.getLobsForSelectedRun = function (runId) {
        var _this = this;
        this._runs.getLobsFromRun(runId).subscribe(function (x) {
            _this.lobs = x.data;
            _this.currentLob = _this.lobs[0];
            _this._runs.getFinalRunsForYear(_this.currentModelId, _this.currentYear, _this.clientId)
                .subscribe(function (x) {
                _this.existingFinalRuns = x.data;
                _this.filteredExistingFinalRuns = _this.existingFinalRuns.filter(function (x) { return x.lob === _this.currentLob && x.runId !== runId; });
                _this.copyExistingRuns = _this.filteredExistingFinalRuns;
            });
        });
    };
    FinalRunModalSelect.prototype.onLobSelectionChange = function (selectedLob) {
        var _this = this;
        this.currentLob = selectedLob;
        this.filteredExistingFinalRuns = this.existingFinalRuns.filter(function (x) { return x.lob === _this.currentLob && x.runId !== _this.currentRunId; });
        this.copyExistingRuns = this.filteredExistingFinalRuns;
    };
    FinalRunModalSelect.prototype.getFinalRunsforYear = function () {
        var _this = this;
        this._runs.getFinalRunsForYear(this.currentModelId, this.currentYear, this.clientId)
            .subscribe(function (x) {
            _this.existingFinalRuns = x.data;
            _this.copyExistingRuns = _this.existingFinalRuns;
        });
    };
    FinalRunModalSelect.prototype.changeExistingFinalRun = function (finalrun, isfinal) {
        this.copyExistingRuns.find(function (x) { return x.runId === finalrun.runId; }).isFinalized = isfinal;
    };
    FinalRunModalSelect.prototype.markRunAsFinal = function () {
        var _this = this;
        var selectedRun = {
            runId: this.currentRunId,
            lob: this.currentLob,
            clientId: this.clientId,
            year: this.currentYear,
            modelId: this.currentModelId,
            name: this.runName,
            isFinalized: true
        };
        if (this.copyExistingRuns.find(function (x) { return x.runId !== _this.currentRunId; }) || this.copyExistingRuns.length < 1)
            this.copyExistingRuns.push(selectedRun);
        this._runs.setMultipleRunAsFinal(this.copyExistingRuns).subscribe(function (x) {
        });
        this.copyExistingRuns.filter(function (x) { return x.isFinalized === false; }).forEach(function (y) {
            _this._applicationInsightsService.send({
                eventCategory: 'Client - Runs', eventAction: "Run unmarked Final",
                runId: y.runId
            });
        });
    };
    FinalRunModalSelect.prototype.onPolicyYearChange = function (policyYear) {
        var _this = this;
        this.currentYear = policyYear;
        this._runs.getFinalRunsForYear(this.currentModelId, policyYear, this.clientId)
            .subscribe(function (x) {
            _this.existingFinalRuns = x.data;
            _this.filteredExistingFinalRuns = _this.existingFinalRuns.filter(function (x) { return x.lob === _this.currentLob && x.runId !== _this.currentRunId; });
            _this.copyExistingRuns = _this.filteredExistingFinalRuns;
        });
    };
    FinalRunModalSelect = __decorate([
        core_1.Component({
            selector: 'final-run-modal-content',
            template: require('./finalRunModalSelect.html'),
            directives: [loadingIndicator_1.LoadingIndicator],
            moduleId: module.id
        }), 
        __metadata('design:paramtypes', [angular2_modal_1.DialogRef, backend_1.Api.RunsProxy, configService_1.ConfigService, services_1.SharedDataService, services_1.TranslateService, applicationInsightsService_1.ApplicationInsightsService])
    ], FinalRunModalSelect);
    return FinalRunModalSelect;
}());
exports.FinalRunModalSelect = FinalRunModalSelect;



},{"../../../@toolkit/services":"@toolkit/services","../../backend":"@toolkit/backend","../services/applicationInsightsService":83,"../services/configService":85,"./finalRunModalSelect.html":31,"./loadingIndicator":36,"@angular/core":"@angular/core","angular2-modal":"angular2-modal"}],22:[function(require,module,exports){
module.exports = '<div class="right">\n    <!--<div class="columns-selector-table-holder" style="border: 1px solid #ccc;">-->\n    <template [ngIf]="configError">\n        {{\'COMPONENTS.COLUMN_SELECTOR_TABLE.MIN_COLUMNS_ERROR\'|translate:{count: minimumColumns} }}\n    </template>\n    <template [ngIf]="!configError">\n        <!--   <div class="columns-selector" style="position: relative; background-color: #ccc; min-height: 30px;" (click)="columnSelectorClicked($event)">-->\n\n        <template [ngIf]="!isOpen">\n            <button class="mini-button" type="button" (click)="columnSelectorClicked($event)">\n                <span class="icon-pencil2"></span>\n            </button>\n        </template>\n\n        <div class="mask" *ngIf="isOpen">\n            <div class="modal">\n\n                <template ngFor [ngForOf]="selectorColumns" let-column>\n                    <div *ngIf="!column.sticky" class="col-dt-1-2 col-ipl-1-2 col-ipp-1">\n                        <label (click)="rbClicked($event,column)" style="display: inline-block">\n                            <input type="radio" class="circle-check" [checked]="column.visible" [disabled]="oneSelected && column.visible">\n                            <span [innerHtml]="column.displayName"></span>\n                        </label>\n                    </div>\n                </template>\n                <div class="clear"></div>\n                \n                <br/>\n                <button class="metro-button right" type="button" (click)="columnSelectorClicked($event)">\n                    <!--<span class="icon-cancel-circle"></span>-->\n                    {{\'GLOBAL.BTN.CLOSE\'|translate}}\n                </button>\n                <div class="clear"></div>\n            </div>\n        </div>\n\n\n\n\n\n        <!--</div>-->\n\n    </template>\n    <!--</div>-->\n</div>\n<div class="table-holder" style="width:calc(100% - 30px)" #tableHolder>\n    <ng-content></ng-content>\n</div>\n<span style="clear:both;"></span>';
},{}],23:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var directives_1 = require('../../directives');
var Rx = require('rxjs');
var ng2_toastr_1 = require('ng2-toastr');
var translation_1 = require('../services/translation');
var ColumnSelectorHandle = (function () {
    function ColumnSelectorHandle(reference) {
        this.reference = reference;
    }
    ColumnSelectorHandle = __decorate([
        core_1.Directive({ selector: 'table' }), 
        __metadata('design:paramtypes', [core_1.ElementRef])
    ], ColumnSelectorHandle);
    return ColumnSelectorHandle;
}());
exports.ColumnSelectorHandle = ColumnSelectorHandle;
var ColumnSelectorImplementation = (function () {
    function ColumnSelectorImplementation(renderer, _toastr, _translate) {
        this.renderer = renderer;
        this._toastr = _toastr;
        this._translate = _translate;
        this.minimumColumns = 2;
        this.columnsChanged = new core_1.EventEmitter();
        this.isOpen = false;
        this.configError = false;
    }
    ColumnSelectorImplementation.prototype.ngOnInit = function () {
    };
    ColumnSelectorImplementation.prototype.ngAfterViewInit = function () {
        var _this = this;
        Rx.Observable.interval(100)
            .take(1)
            .subscribe(function () {
            _this.init();
        });
    };
    ColumnSelectorImplementation.prototype.init = function () {
        this.initTable(this.table.reference.nativeElement);
        this.rerenderColumns();
    };
    ColumnSelectorImplementation.prototype.columnSelectorClicked = function (event) {
        event.stopPropagation();
        this.isOpen = !this.isOpen;
    };
    ColumnSelectorImplementation.prototype.rbClicked = function (event, column) {
        var _this = this;
        if (event)
            event.stopPropagation();
        if (column.visible && this.hasMinimumColumnCountError()) {
            this._translate.get('COMPONENTS.COLUMN_SELECTOR_TABLE.MIN_COLUMNS_ERROR', { count: this.minimumColumns })
                .subscribe(function (o) {
                return _this._toastr.error(o);
            });
            return;
        }
        column.visible = !column.visible;
        this.showOrHideColumn(column);
        this.columns.find(function (x) { return x.key === column.key; }).visible = column.visible;
    };
    ColumnSelectorImplementation.prototype.rebuild = function () {
        this.init();
    };
    ColumnSelectorImplementation.prototype.hasMinimumColumnCountError = function () {
        var visibleCount = this.columns.filter(function (x) { return x.visible; }).length;
        var visibleOrStickyCount = this.columns.filter(function (x) { return x.visible || x.sticky; }).length;
        return false;
    };
    ColumnSelectorImplementation.prototype.rerenderColumns = function () {
        var _this = this;
        this.selectorColumns.map(function (x) {
            _this.showOrHideColumn(x);
        });
    };
    ColumnSelectorImplementation.prototype.showOrHideColumn = function (column) {
        var _this = this;
        var hide = !(column.visible || column.sticky);
        this.renderer.setElementClass(column.thEl, "hide", hide);
        column.tdEls.map(function (x) { return _this.renderer.setElementClass(x, "hide", hide); });
        this.columnsChanged.emit('');
    };
    ColumnSelectorImplementation.prototype.initTable = function (nativeElement) {
        var _this = this;
        this.selectorColumns = [];
        this.columns.map(function (column, k) {
            _this.selectorColumns.push({
                key: column.key,
                displayName: '',
                visible: column.visible,
                sticky: column.sticky,
                thEl: '',
                tdEls: [],
                index: k
            });
        });
        for (var i = 0; i < nativeElement.children.length; i++) {
            var child = nativeElement.children[i];
            if (child.tagName === "THEAD") {
                for (var j = 0; j < child.children.length; j++) {
                    var grandChild = child.children[j];
                    if (grandChild.tagName === "TR") {
                        for (var k = 0; k < grandChild.children.length; k++) {
                            var greatgrandChild = grandChild.children[k];
                            if (greatgrandChild.tagName === "TH") {
                                var _loop_1 = function(l) {
                                    var attr = greatgrandChild.attributes[l];
                                    if (attr.name === "key") {
                                        var sc = this_1.selectorColumns.find(function (x) { return x.key === attr.value; });
                                        sc.displayName = greatgrandChild.innerHTML.replace(/<br>/g, ' ');
                                        sc.thEl = greatgrandChild;
                                        sc.index = k;
                                    }
                                };
                                var this_1 = this;
                                for (var l = 0; l < greatgrandChild.attributes.length; l++) {
                                    _loop_1(l);
                                }
                            }
                        }
                    }
                }
            }
            else if (child.tagName === "TBODY") {
                for (var j = 0; j < child.children.length; j++) {
                    var grandChild = child.children[j];
                    if (grandChild.tagName === "TR") {
                        var _loop_2 = function(k) {
                            var greatgrandChild = grandChild.children[k];
                            if (greatgrandChild.tagName === "TD" && !greatgrandChild.classList.contains("sticky")) {
                                this_2.selectorColumns.find(function (x) { return x.index === k; }).tdEls.push(greatgrandChild);
                            }
                        };
                        var this_2 = this;
                        for (var k = 0; k < grandChild.children.length; k++) {
                            _loop_2(k);
                        }
                    }
                }
            }
        }
    };
    Object.defineProperty(ColumnSelectorImplementation.prototype, "oneSelected", {
        get: function () { return this.columns.filter(function (o) { return o.visible; }).length == 1; },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Array)
    ], ColumnSelectorImplementation.prototype, "columns", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Number)
    ], ColumnSelectorImplementation.prototype, "minimumColumns", void 0);
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], ColumnSelectorImplementation.prototype, "columnsChanged", void 0);
    __decorate([
        core_1.ContentChild(ColumnSelectorHandle), 
        __metadata('design:type', ColumnSelectorHandle)
    ], ColumnSelectorImplementation.prototype, "table", void 0);
    ColumnSelectorImplementation = __decorate([
        core_1.Component({
            selector: 'column-selector',
            directives: [directives_1.ExpanderComponent],
            template: require('./columnSelector.html'),
            styles: [
                "div.table-holder >>> th.hide, div.table-holder >>> td.hide {\n            display:none;\n        }"
            ],
            moduleId: module.id
        }), 
        __metadata('design:paramtypes', [core_1.Renderer, ng2_toastr_1.ToastsManager, translation_1.TranslateService])
    ], ColumnSelectorImplementation);
    return ColumnSelectorImplementation;
}());
exports.ColumnSelectorImplementation = ColumnSelectorImplementation;
exports.ColumnSelectorComponent = [ColumnSelectorHandle, ColumnSelectorImplementation];
var Column = (function () {
    function Column() {
    }
    return Column;
}());
exports.Column = Column;



},{"../../directives":"@toolkit/directives","../services/translation":92,"./columnSelector.html":22,"@angular/core":"@angular/core","ng2-toastr":"ng2-toastr","rxjs":"rxjs"}],24:[function(require,module,exports){
module.exports = '<div *ngIf="_runModel?.info?.isReadonly === false" class="sand-box" style="padding-left: 20px; padding-right:20px">\n    <table class="pretty" *ngIf="currencyInfo && selectedCurrency" >\n        <tbody>\n            <tr style="height: 32px;">\n                <td style="width: 42px;">\n                    <img style="float:left" [src]="selectedCurrency.data.flag" *ngIf="selectedCurrency.data.flag">\n                </td>\n                <td class="snug">\n\n                    <select [ngModel]="currencyInfo.currentSelectedCurrency" (ngModelChange)="changeCurrency($event)" [disabled]="disabled">\n\n                        <option *ngFor="let item of preferredCurrencies" [value]="item.code">{{item.code}} - {{item.name}}</option>\n                        <option *ngIf="preferredCurrencies.length" disabled>&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;</option>\n                            <option *ngFor="let item of currencies" [value]="item.code">{{item.code}} - {{item.name}}</option>\n                    </select>\n                </td>\n\n                <td class="snug">\n                    <span class="help" [tooltip]="\'SITE_HEADER.CURRENCY.TOOLTIP_TEMPLATE\'|translate:{currencyto: selectedCurrency.data.code, currencyfrom: currencyInfo.baseCurrency, asat: selectedCurrency.exchange.asAtDate|date:\'dd MMM y\', rate: selectedCurrency.exchange.rate|number:\'.4-4\'}" style="float:none; display:inline-block; padding-right:10px;"></span>\n                    &nbsp;\n                </td>\n                <td class="snug" *ngIf="selectedCurrency.exchange">\n                    &nbsp;\n                </td>\n                <td *ngIf="_runModel.info.isReadonly === true"><i>{{\'SITE_HEADER.CURRENCY.READONLY\'|translate}}</i></td>\n                <td *ngIf="error && _runModel.info.isReadonly === false"><i>{{\'SITE_HEADER.CURRENCY.UNKNOWN\'|translate}}</i></td>\n\n                <td style="text-align:right;" *ngIf="selectedCurrency.exchange">\n                    &nbsp;\n                </td>\n                <td class="snug" *ngIf="selectedCurrency.exchange">\n                    &nbsp;\n                </td>\n            </tr>\n\n        </tbody>\n    </table>\n</div>\n<div *ngIf="_runModel?.info?.isReadonly === true" class="sand-box" style="height: 32px;padding-left: 20px; padding-right: 20px">\n    &nbsp;\n</div>';
},{}],25:[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var Api = require('../backend/webapis');
var services = require('../../services');
var directives_1 = require('../../directives');
var reactiveComponent_1 = require('../../reactiveComponent');
var CurrencySelectorComponent = (function (_super) {
    __extends(CurrencySelectorComponent, _super);
    function CurrencySelectorComponent(_api, _config, _translate, _runService) {
        _super.call(this);
        this._api = _api;
        this._config = _config;
        this._translate = _translate;
        this._runService = _runService;
        this.currencies = [];
        this.preferredCurrencies = [];
        this.selectedCurrencyChange = new core_1.EventEmitter();
    }
    Object.defineProperty(CurrencySelectorComponent.prototype, "disabled", {
        get: function () { return !this._runModel || this._runModel.info.isReadonly; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CurrencySelectorComponent.prototype, "currencyInfo", {
        get: function () {
            if (!this._runModel)
                return null;
            return this._runModel.currencyInfo;
        },
        enumerable: true,
        configurable: true
    });
    CurrencySelectorComponent.prototype.changeCurrency = function (code) {
        var _this = this;
        if (!code)
            return;
        var currency = this.currencies.concat(this.preferredCurrencies).find(function (o) { return o.code === code; });
        var exchange = this._runModel.currencyInfo.rates[code.toLowerCase()];
        if (!currency) {
            return;
        }
        this.error = false;
        this.selectedCurrency = { data: currency, exchange: exchange };
        if (!exchange) {
            this.error = true;
            return;
        }
        if (code !== this.originalCurrency) {
            var change_1 = {
                oldCode: this.originalCurrency,
                oldRate: this._runModel.currencyInfo.rates[this.originalCurrency.toLowerCase()].rate,
                newCode: code,
                newRate: exchange.rate,
                modelId: this._config.currentModel.modelId,
                run: this._runModel.data
            };
            this._api.changeCurrency(change_1).uiSignal({ debugInfo: 'converting currency', uiLabel: this._translate.instant('SITE_HEADER.CURRENCY.CONVERTING') }).subscribe(function (o) {
                _this._runModel.data = o.data;
                change_1.run = o.data;
                _this.originalCurrency = code;
                _this._runModel.currencyInfo.currentSelectedCurrency = code;
                _this.selectedCurrencyChange.emit(change_1);
                _this._runService.currencyConverted.next(_this._runModel);
            });
        }
    };
    CurrencySelectorComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._api.list(this._config.currentModel.modelName).subscribe(function (o) {
            var preferred = _this._config.currentModel.currencySettings.preferredCodes;
            if (preferred && preferred.length) {
                _this.currencies = o.data.filter(function (curr) { return preferred.indexOf(curr.code) === -1; });
                _this.preferredCurrencies = o.data.filter(function (curr) { return preferred.indexOf(curr.code) !== -1; });
            }
            else {
                _this.currencies = o.data;
                _this.preferredCurrencies = [];
            }
            _this._runModel && _this._runModel.currencyInfo && _this.changeCurrency(_this._runModel.currencyInfo.currentSelectedCurrency);
        });
        this._subscriptions = [
            this._runService.activeRun.subscribe(function (rm) {
                _this._runModel = rm;
                _this.originalCurrency = rm.currencyInfo && rm.currencyInfo.currentSelectedCurrency;
                _this.changeCurrency(_this.originalCurrency);
            })];
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], CurrencySelectorComponent.prototype, "selectedCurrencyChange", void 0);
    CurrencySelectorComponent = __decorate([
        core_1.Component({ selector: 'currency-selector', directives: [directives_1.TOOLTIP], template: require('./currencySelector.html'), moduleId: module.id }), 
        __metadata('design:paramtypes', [Api.CurrencyProxy, services.ConfigService, services.TranslateService, services.RunService])
    ], CurrencySelectorComponent);
    return CurrencySelectorComponent;
}(reactiveComponent_1.ReactiveComponent));
exports.CurrencySelectorComponent = CurrencySelectorComponent;



},{"../../directives":"@toolkit/directives","../../reactiveComponent":"@toolkit/reactiveComponent","../../services":"@toolkit/services","../backend/webapis":17,"./currencySelector.html":24,"@angular/core":"@angular/core"}],26:[function(require,module,exports){
module.exports = '<div>\n	<table class="pretty">\n		<tbody>\n			<tr><td><h2>{{\'RUN.FINAL.TITLE.DESELECT\'|translate}}</h2></td></tr>\n			<tr><td>{{\'RUN.FINAL.MESSAGE.DESELECT\'|translate}}</td></tr>\n			<tr>\n				<td>\n					<button class="vex-dialog-button-primary vex-dialog-button" type="button" (click)="close()">{{\'RUN.FINAL.BTN.DESELECT\'|translate}}</button>\n					<button class="vex-dialog-button-secondary vex-dialog-button" type="button" (click)="cancel()">{{\'RUN.FINAL.BTN.SELECT_CANCEL\'|translate}}</button>\n				</td>\n			</tr>\n		</tbody>\n	</table>\n</div>';
},{}],27:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var angular2_modal_1 = require('angular2-modal');
var CustomModalDeselect = (function () {
    function CustomModalDeselect(dialog) {
        this.dialog = dialog;
    }
    CustomModalDeselect.prototype.ngOnInit = function () {
    };
    CustomModalDeselect.prototype.close = function (value) {
        this.flag = true;
        this.dialog.context.defaultResult = true;
        this.dialog.close();
    };
    CustomModalDeselect.prototype.cancel = function () {
        this.flag = false;
        this.dialog.context.defaultResult = false;
        this.dialog.dismiss();
    };
    CustomModalDeselect.prototype.beforeDismiss = function () {
        return this.flag;
    };
    CustomModalDeselect.prototype.beforeClose = function () {
        return false;
    };
    CustomModalDeselect = __decorate([
        core_1.Component({
            selector: 'deselectmodal-content',
            template: require('./customModalDeselect.html'),
            moduleId: module.id
        }), 
        __metadata('design:paramtypes', [angular2_modal_1.DialogRef])
    ], CustomModalDeselect);
    return CustomModalDeselect;
}());
exports.CustomModalDeselect = CustomModalDeselect;



},{"./customModalDeselect.html":26,"@angular/core":"@angular/core","angular2-modal":"angular2-modal"}],28:[function(require,module,exports){
module.exports = '<div>\n	<table class="pretty">\n		<tbody>\n			<tr><td><h2>{{\'RUN.FINAL.TITLE.SELECT\'|translate}}</h2></td></tr>\n			<tr><td>{{\'RUN.FINAL.MESSAGE.SELECT\'|translate}}</td></tr>\n			<tr><td>{{\'RUN.FINAL.MESSAGE.SELECT_TEXT\'|translate}}</td></tr>\n			<tr>\n				<td class="snug">\n					<select style="width: 50%" [(ngModel)]="currentYear" name="policyYear" class="select-wrapper">\n						<option *ngFor="let policyYear of policyYearArr" [value]="policyYear" class="theme--option--default">{{policyYear}}</option>\n					</select>\n				</td>\n			</tr>\n			<tr><td>{{\'RUN.FINAL.MESSAGE.SELECT_NOTE\'|translate}}</td></tr>\n			<tr>\n				<td>\n					<button class="vex-dialog-button-primary vex-dialog-button" type="button" (click)="close()">{{\'RUN.FINAL.BTN.SELECT_OK\'|translate}}</button>\n					<button class="vex-dialog-button-secondary vex-dialog-button" type="button" (click)="cancel()">{{\'RUN.FINAL.BTN.SELECT_CANCEL\'|translate}}</button>\n				</td>\n			</tr>\n		</tbody>\n	</table>\n</div>';
},{}],29:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var angular2_modal_1 = require('angular2-modal');
var CustomModal = (function () {
    function CustomModal(dialog) {
        this.dialog = dialog;
    }
    CustomModal.prototype.ngOnInit = function () {
        this.currentYear = new Date().getFullYear();
        this.policyYearArr = this.getPolicyYear();
    };
    CustomModal.prototype.close = function (value) {
        this.flag = true;
        this.dialog.context.defaultResult = true;
        this.dialog.close(this.currentYear);
    };
    CustomModal.prototype.cancel = function () {
        this.flag = false;
        this.dialog.context.defaultResult = false;
        this.dialog.dismiss();
    };
    CustomModal.prototype.beforeDismiss = function () {
        return this.flag;
    };
    CustomModal.prototype.beforeClose = function () {
        return false;
    };
    CustomModal.prototype.getPolicyYear = function () {
        var currentYear = new Date().getFullYear();
        var i = 0;
        var arraySize = currentYear - 2015;
        var arrYears = new Array(arraySize);
        for (i = 0; i <= arraySize; i++) {
            arrYears[i] = (currentYear - i);
        }
        return arrYears;
    };
    CustomModal = __decorate([
        core_1.Component({
            selector: 'modal-content',
            template: require('./customModel.html'),
            moduleId: module.id
        }), 
        __metadata('design:paramtypes', [angular2_modal_1.DialogRef])
    ], CustomModal);
    return CustomModal;
}());
exports.CustomModal = CustomModal;



},{"./customModel.html":28,"@angular/core":"@angular/core","angular2-modal":"angular2-modal"}],30:[function(require,module,exports){
module.exports = '<div>\n	<table class="pretty">\n		<tbody>\n			<tr><td><h2>{{\'RUN.FINAL.TITLE.DESELECT\'|translate}}</h2></td></tr>\n			<tr><td>{{\'RUN.FINAL.MESSAGE.DESELECT\'|translate}}</td></tr>\n        <tr><td colspan="6" *ngIf="lobs !==undefined && lobs?.length > 0">{{\'RUN.FINAL.TITLE.SELECT_LOB\'|translate}}</td></tr>\n        <tr><td colspan="6"><label *ngFor="let lob of lobs;let idx = index"><input type="radio" class="circle-check" name="radiogroup" (change)="onLobSelectionChange(lob)" [checked]="(idx === 0)" />{{lob}}</label></td></tr>\n       \n        <tr><td colspan="6" *ngIf="lobs ==undefined || lobs?.length < 0"> <h4>{{\'RUN.FINAL.TITLE.LOADING\'|translate}}</h4></td></tr>\n        <tr>\n				<td>\n					<button [ngClass]="lobs !==undefined && lobs?.length > 0 ? \'vex-dialog-button-primary vex-dialog-button\' : \'vex-dialog-button\'"  type="button" *ngIf="lobs !==undefined && lobs?.length > 0" (click)="close()">{{\'RUN.FINAL.BTN.DESELECT\'|translate}}</button>\n					<button class="vex-dialog-button-secondary vex-dialog-button" type="button" (click)="cancel()">{{\'RUN.FINAL.BTN.SELECT_CANCEL\'|translate}}</button>\n				</td>\n			</tr>\n		</tbody>\n	</table>\n</div>';
},{}],31:[function(require,module,exports){
module.exports = '<div>\n    <table class="pretty">\n        <tbody>\n            <tr><td colspan="6"><h2>{{\'RUN.FINAL.TITLE.SELECT\'|translate}}</h2></td></tr>\n            <tr><td colspan="6">{{\'RUN.FINAL.MESSAGE.SELECT\'|translate}}</td></tr>\n            <tr><td colspan="6">{{\'RUN.FINAL.MESSAGE.SELECT_TEXT\'|translate}}</td></tr>\n            <tr>\n                <td colspan="6" class="snug"*ngIf="lobs !==undefined && lobs?.length > 0">\n                    <select (ngModelChange)="onPolicyYearChange($event)" style="width: 50%" [ngModel]="currentYear" name="policyYear" class="select-wrapper">\n                        <option *ngFor="let policyYear of policyYearArr" [value]="policyYear" class="theme--option--default">{{policyYear}}</option>\n                    </select>\n                </td>\n            </tr>\n\n            <tr><td colspan="6" *ngIf="lobs !==undefined && lobs?.length > 0">{{\'RUN.FINAL.TITLE.SELECT_LOB\'|translate}}</td></tr>\n            <tr><td colspan="6"><label *ngFor="let lob of lobs;let idx = index"><input type="radio" class="circle-check" name="radiogroup" (change)="onLobSelectionChange(lob)" [checked]="(idx === 0)" />{{lob}}</label></td></tr>\n            <tr><td colspan="6" *ngIf="lobs ==undefined || lobs?.length < 0"><h4>{{\'RUN.FINAL.TITLE.LOADING\'|translate}}</h4></td></tr>\n            <tr><td colspan="6" *ngIf="filteredExistingFinalRuns !==undefined && filteredExistingFinalRuns?.length > 0">{{\'RUN.FINAL.TITLE.SELECTED_YEAR\'|translate}}</td></tr>\n           \n            <table style="border: black solid 1px;" *ngIf="filteredExistingFinalRuns !==undefined && filteredExistingFinalRuns?.length > 0">\n                <tr style="border: black solid 1px;"><td>{{\'RUN.FINAL.TITLE.RUN_ID\'|translate}}</td><td>{{\'RUN.FINAL.TITLE.NAME\'|translate}}</td><td>{{\'RUN.FINAL.TITLE.COVERAGE\'|translate}}</td><td>{{\'RUN.FINAL.TITLE.IS_FINALIZED\'|translate}}</td></tr>\n                <tr *ngFor="let run of filteredExistingFinalRuns" style="border: black solid 1px;">\n                    <td>{{run.runId}}</td>\n                    <td>{{run.name}}</td>\n                    <td>{{run.lob}}</td>\n                    <td><input type="checkbox" name="IsFinalized" value="run.isFinalized" [(ngModel)]="run.isFinalized" [checked]="run.isFinalized" (change)="changeExistingFinalRun(run,run.isFinalized)" /></td>\n                </tr>\n            </table>\n            <tr><td colspan="6"></td></tr>\n            <tr>\n                <td colspan="6">\n                    <button [ngClass]="lobs !==undefined && lobs?.length > 0 ? \'vex-dialog-button-primary vex-dialog-button\' : \'vex-dialog-button\'" type="button" *ngIf="lobs !==undefined && lobs?.length > 0" (click)="close()">{{\'RUN.FINAL.BTN.SELECT_OK\'|translate}}</button>\n                    <button class="vex-dialog-button-secondary vex-dialog-button" type="button" (click)="cancel()">{{\'RUN.FINAL.BTN.SELECT_CANCEL\'|translate}}</button>\n                </td>\n            </tr>\n\n        </tbody>\n    </table>\n   \n</div>\n\n\n\n';
},{}],32:[function(require,module,exports){
module.exports = '<div id="industryMix" style="display:inline">\n    <div *ngIf="showBaselineSector">\n        <h3>\n            {{\'COMPONENTS.INDUSTRY_MIX.BASELINE_SECTOR\'|translate}}: {{baselineSector}}\n            <span class="help" [tooltip]="\'COMPONENTS.INDUSTRY_MIX.BASELINE_SECTOR_TOOLTIP\'|translate:{baselineIndustrySectors: baselineSectorTooltipSectors }"\n                  style="float:none; display:inline-block; padding-right:10px;"></span>\n        </h3>\n    </div>\n    <table class="pretty" ngModelGroup #industryGroup="ngModelGroup" [validate-using]="validateIndustries">\n        <tr>\n            <th width="70%"></th>\n            <th width="25%"></th>\n            <th width="5%"></th>\n        </tr>\n        <tr *ngFor="let industry of selectedIndustries; let i = index">\n            <td>\n                <select style="width: 100%" [(ngModel)]="industry.id" name="platform.industry.{{industry|uniqueId}}.ind.code"\n                        [class.ng-invalid]="industryGroup.errors?.duplicateIndustry && (industryGroup.errors?.duplicateIndustry.indexOf(industry.id) > -1)" class="redOnInvalid" (ngModelChange)="onIndustryChange($event)">\n                    <optgroup *ngFor="let igl of industryGroupList " label="{{igl.name}}">\n                        <option *ngFor="let ind of igl.industries" [ngValue]="ind.id">\n                            {{ind.name}}\n                        </option>\n                    </optgroup>\n                </select>\n            </td>\n            <td>\n                <input  localeNumberFormat="intPercent:.0-0" min="1" max="100"\n                       [(ngModel)]="industry.percentage" name="platform.industry.{{industry|uniqueId}}.ind.percentage"\n                       required\n                       class="redOnInvalid" style="width: 74%;text-align:right" />\n            </td>\n            <td>\n                <span class="icon-minus" [hidden]="selectedIndustries.length<2" (click)="remove(i)" title="Remove Industry"></span>\n            </td>\n        </tr>\n        <tr style="height: 40px;">\n            <td></td>\n            <td class="right-align" style="padding-right:40px">\n                <span [class.ng-invalid]="industryGroup.errors?.industry100" class="redOnInvalid">{{calculateTotalIndustryPercent() | intPercent}}</span>\n            </td>\n            <td>\n                <span class="icon-plus redOnInvalid quick-button" (click)="add()" [hidden]="selectedIndustries.length > 2" title="{{\'RUN.ADD_INDUSTRY\'|translate}}" [class.ng-invalid]="industryGroup.errors?.industryMissing"></span>\n            </td>\n        </tr>\n    </table>\n</div>';
},{}],33:[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var forms_1 = require('@angular/forms');
var reactiveComponent_1 = require('../../reactiveComponent');
var directives = require('../../directives');
var IndustryMixComponent = (function (_super) {
    __extends(IndustryMixComponent, _super);
    function IndustryMixComponent(form) {
        _super.call(this, form);
        this.selectedIndustriesChange = new core_1.EventEmitter();
        this.showBaselineSector = false;
        this.baselineSectorChange = new core_1.EventEmitter();
        this.industryList = [];
    }
    IndustryMixComponent.prototype.ngAfterViewInit = function () {
        this.industryList = this.flatIntoIndustries(this.industryGroupList);
    };
    IndustryMixComponent.prototype.validateIndustries = function (mg) {
        var ret = {};
        var perckeys = Object.keys(mg.value).filter(function (o) { return o.endsWith('.ind.percentage'); });
        if (perckeys.length > 0) {
            var sum = perckeys.filter(function (key) { return !!mg.value[key]; }).reduce(function (acc, key) { return acc + mg.value[key]; }, 0);
            if (sum !== 100)
                ret.industry100 = { value: sum };
        }
        if (perckeys.length === 0)
            ret.industryMissing = true;
        var industries = Object.keys(mg.value).filter(function (o) { return o.endsWith('.ind.code'); }).map(function (k) { return mg.value[k]; });
        var uniq = industries.reduce(function (acc, item) {
            acc[item] = (acc[item] || 0) + 1;
            return acc;
        }, {});
        var duplicates = Object.keys(uniq).filter(function (k) { return uniq[k] > 1; }).map(function (k) { return parseInt(k); });
        if (duplicates.length)
            ret.duplicateIndustry = duplicates;
        return ret;
    };
    IndustryMixComponent.prototype.add = function () {
        var _this = this;
        var total = this.calculateTotalIndustryPercent();
        var percentage = 0;
        percentage = total >= 100 ? 0 : 100 - total;
        var defaultIndustryGroup = this.industryGroupList.find(function (i) { return i.name === _this.baselineSector; }) || this.industryGroupList[0];
        this.selectedIndustries.push({
            id: defaultIndustryGroup.industries[0].id,
            name: defaultIndustryGroup.industries[0].name,
            percentage: percentage,
            parentId: defaultIndustryGroup.industries[0].parentId
        });
        this.updateBaselineSector();
        this.selectedIndustriesChange.emit(this.selectedIndustries);
    };
    IndustryMixComponent.prototype.remove = function (index) {
        this.selectedIndustries = this.selectedIndustries.filter(function (o, itemIndex) { return itemIndex !== index; });
        var totalPercentage = this.calculateTotalIndustryPercent();
        var remainingPercentage = 100 - totalPercentage;
        if (remainingPercentage > 0) {
            this.selectedIndustries[0].percentage = this.selectedIndustries[0].percentage + remainingPercentage;
        }
        this.updateBaselineSector();
        this.selectedIndustriesChange.emit(this.selectedIndustries);
    };
    IndustryMixComponent.prototype.onIndustryChange = function (newIndustryId) {
        var updatedIndustry = this.selectedIndustries[this.selectedIndustries.findIndex(function (item) { return (item.id === newIndustryId); })];
        updatedIndustry.id = this.industryList.filter(function (x) { return x.id === updatedIndustry.id; })[0].id;
        updatedIndustry.name = this.industryList.filter(function (x) { return x.id === updatedIndustry.id; })[0].name;
        this.updateBaselineSector();
        this.selectedIndustriesChange.emit(this.selectedIndustries);
    };
    IndustryMixComponent.prototype.updateBaselineSector = function () {
        var _this = this;
        if (!this.showBaselineSector)
            return;
        var hist = {};
        this.selectedIndustries.map(function (reg) {
            var parentId = _this.industryList.filter(function (x) { return x.id == reg.id; })[0].parentId;
            if (parentId in hist)
                hist[parentId]++;
            else
                hist[parentId] = 1;
        });
        var sortable = [];
        Object.keys(hist).forEach(function (x) { return sortable.push([x, hist[x]]); });
        sortable.sort(function (a, b) {
            return a[1] - b[1];
        })
            .reverse();
        var prevalentSectorId = sortable[0][Object.keys(sortable[0])[0]];
        var prevalentSectorCount = hist[prevalentSectorId];
        if (prevalentSectorCount === 1) {
            prevalentSectorId = this.industryList.filter(function (x) { return x.id == _this.selectedIndustries[0].id; })[0].parentId;
        }
        var previousBaselineSector = this.baselineSector;
        var currentBaselineSector = this.industryGroupList.filter(function (x) { return x.id == prevalentSectorId; })[0].name;
        if (previousBaselineSector === currentBaselineSector)
            return;
        this.baselineSector = currentBaselineSector;
        this.baselineSectorChange.emit(this.baselineSector);
    };
    IndustryMixComponent.prototype.calculateTotalIndustryPercent = function () {
        var total = 0;
        if (!this.selectedIndustries)
            return 0;
        for (var _i = 0, _a = this.selectedIndustries; _i < _a.length; _i++) {
            var ind = _a[_i];
            if (!!ind.percentage)
                total += ind.percentage;
        }
        return total;
    };
    IndustryMixComponent.prototype.flatIntoIndustries = function (industryGroupArray) {
        var industryArray = [];
        for (var i = 0; i < industryGroupArray.length; i++) {
            for (var j = 0; j < industryGroupArray[i].industries.length; j++) {
                var industry = Object.assign({}, industryGroupArray[i].industries[j]);
                industry.parentId = industryGroupArray[i].id;
                industryArray.push(industry);
            }
        }
        return industryArray;
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Array)
    ], IndustryMixComponent.prototype, "industryGroupList", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Array)
    ], IndustryMixComponent.prototype, "selectedIndustries", void 0);
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], IndustryMixComponent.prototype, "selectedIndustriesChange", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], IndustryMixComponent.prototype, "baselineSectorTooltipSectors", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], IndustryMixComponent.prototype, "baselineSector", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Boolean)
    ], IndustryMixComponent.prototype, "showBaselineSector", void 0);
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], IndustryMixComponent.prototype, "baselineSectorChange", void 0);
    IndustryMixComponent = __decorate([
        core_1.Component({
            selector: 'industry-mix',
            directives: [directives.CUSTOM_VALUE_ACCESSORS, directives.VALIDATORS, directives.READONLY_DIRECTIVES, directives.TOOLTIP],
            viewProviders: [reactiveComponent_1.dynamicFormDirectiveProvider(function () { return IndustryMixComponent; })],
            template: require('./industryMix.html'),
            moduleId: module.id
        }), 
        __metadata('design:paramtypes', [forms_1.NgForm])
    ], IndustryMixComponent);
    return IndustryMixComponent;
}(reactiveComponent_1.DynamicFormComponent));
exports.IndustryMixComponent = IndustryMixComponent;



},{"../../directives":"@toolkit/directives","../../reactiveComponent":"@toolkit/reactiveComponent","./industryMix.html":32,"@angular/core":"@angular/core","@angular/forms":"@angular/forms"}],34:[function(require,module,exports){
module.exports = '    <select [(ngModel)]="userLanguage">\n        <option *ngFor="let language of languages" [value]="language.code">{{language.displayName}}</option>\n    </select>  \n';
},{}],35:[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var services_1 = require('../../services');
var reactiveComponent_1 = require('../../reactiveComponent');
var LanguageSelectorComponent = (function (_super) {
    __extends(LanguageSelectorComponent, _super);
    function LanguageSelectorComponent(_translation, _config) {
        _super.call(this);
        this._translation = _translation;
        this._config = _config;
    }
    Object.defineProperty(LanguageSelectorComponent.prototype, "userLanguage", {
        get: function () {
            return this._userLanguage;
        },
        set: function (val) {
            this._userLanguage = val;
            this._translation.use(val);
        },
        enumerable: true,
        configurable: true
    });
    LanguageSelectorComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._subscriptions = [
            this._translation.languages.subscribe(function (langs) { return _this.languages = langs; }),
            this._translation.userLanguage.subscribe(function (lang) { return _this._userLanguage = lang; })
        ];
        this._translation.setLocale(this._userLanguage);
    };
    Object.defineProperty(LanguageSelectorComponent.prototype, "hide", {
        get: function () {
            if (this.languages || this.languages.length > 2) {
                return !this._config.currentModel.useMultilingualFeature;
            }
            else
                return true;
        },
        enumerable: true,
        configurable: true
    });
    LanguageSelectorComponent = __decorate([
        core_1.Component({ selector: 'language-selector', template: require('./languageSelector.html'), moduleId: module.id, host: { '[hidden]': 'hide' } }), 
        __metadata('design:paramtypes', [services_1.ExtendedTranslateService, services_1.ConfigService])
    ], LanguageSelectorComponent);
    return LanguageSelectorComponent;
}(reactiveComponent_1.ReactiveComponent));
exports.LanguageSelectorComponent = LanguageSelectorComponent;



},{"../../reactiveComponent":"@toolkit/reactiveComponent","../../services":"@toolkit/services","./languageSelector.html":34,"@angular/core":"@angular/core"}],36:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var vex_1 = require('angular2-modal/plugins/vex');
var rx_1 = require('rxjs');
var services_1 = require('../../services');
var LoadingIndicator = (function () {
    function LoadingIndicator(modal, translate) {
        this.modal = modal;
        this.translate = translate;
        this.counter = [];
    }
    LoadingIndicator.prototype.ngOnInit = function () {
        if (rx_1.Observable.prototype.uiSignal)
            throw "Cannot register multiple Loading Indicators";
        else {
            var _this_1 = this;
            rx_1.Observable.prototype.uiSignal = function (label) { return _this_1.signal(this, label); };
        }
    };
    Object.defineProperty(LoadingIndicator.prototype, "message", {
        get: function () { return this.counter && this.counter.length && this.counter[this.counter.length - 1].uiLabel; },
        enumerable: true,
        configurable: true
    });
    LoadingIndicator.prototype.signal = function (observable, information) {
        var _this = this;
        var data;
        if (typeof information === 'string') {
            var label = this.translate.instant('GLOBAL.BUSY.LOADING');
            if (label === 'GLOBAL.BUSY.LOADING')
                label = "";
            data = { uiLabel: label, debugInfo: information };
        }
        else {
            data = information;
        }
        this.counter.push(data);
        return observable.do(null, function (err) {
            _this.counter = _this.counter.filter(function (o) { return o.debugInfo !== data.debugInfo; });
            if (typeof err.status === 'number' && 400 <= err.status && err.status < 405)
                return;
            var msg = _this.translate.instant('RUN.ERROR_MSG');
            _this.modal.alert().okBtn(_this.translate.instant("GLOBAL.BTN.OK")).message(msg + data.debugInfo).open();
        }, function () {
            _this.counter = _this.counter.filter(function (o) { return o.debugInfo !== data.debugInfo; });
        });
    };
    ;
    LoadingIndicator = __decorate([
        core_1.Component({
            selector: 'loading', template: "\n<div *ngIf=\"counter.length>0\">\n   <div class=\"overlay\">\n      <div class=\"popup\">\n            <table>\n                <tr>\n                    <td><img src=\"/app/assets/img/ajax-loader.gif\" /></td>\n                    <td><span>{{message}}</span></td>\n                </tr>\n            </table>\n      </div>\n   </div>\n</div>\n", styles: ["\ndiv.overlay { position:fixed;top:0;bottom:0;left:0;right:0; background-color: rgba(100,100,100,.7); z-index:999; }\ndiv.popup {\n   width: 350px;\n    background: white;\n    position: relative;\n    top: 200px;\n    margin: 0 auto;\n    padding: 20px;\n}\n\n.popup table tr td {\n    vertical-align: middle;\n}\n\n.popup table {\n    width: 100%;\n}\n\n.popup span {\n    padding-left: 5px;\n}\n"]
        }), 
        __metadata('design:paramtypes', [vex_1.Modal, services_1.TranslateService])
    ], LoadingIndicator);
    return LoadingIndicator;
}());
exports.LoadingIndicator = LoadingIndicator;
rx_1.Observable.prototype.fireAndForget = function () {
    var obs = this;
    return obs.subscribe(function () { }, function () { }, function () { });
};



},{"../../services":"@toolkit/services","@angular/core":"@angular/core","angular2-modal/plugins/vex":"angular2-modal/plugins/vex","rxjs":"rxjs"}],37:[function(require,module,exports){
module.exports = '<div id="multi-level-menu">\n    <ul>\n        <li>\n            <div [style.width]="calculateWidth(pages)" [routerLink]="[homeUrl]">\n                <span class="menu-item-label" >\n                    {{\'SITE_HEADER.HOME\'|translate}}\n                </span>\n            </div>\n        </li>\n        <template [ngTemplateOutlet]="recursive" [ngOutletContext]="{$implicit: pages}">\n        </template>\n    </ul>\n</div>\n<template #recursive let-itemList>\n    <li *ngFor="let pageItem of itemList">\n        <div [style.width]="calculateWidth(itemList)" [class.disabled]="!pageItem.canNavigate" [class.selected]="pageItem.current || pageItem.ancestorOfCurrent">\n          \n\n            <!--<a class="menu-item-label" *ngIf="pageItem.canNavigate" (click)="navigateTo(pageItem.url)">\n                <span *ngIf="pageItem.current" class="icon-checkmark"></span>\n                <span *ngIf="!pageItem.current" style="padding-left: 10px;">&nbsp;</span>\n                {{pageItem.displayTitle}}\n            </a>-->\n\n            <span class="menu-item-label" (click)="pageItem.canNavigate && navigateTo(pageItem)" \n                  [style.width]="!pageItem.children || pageItem.children.length === 0 ? \'100%\':\'\'">\n                {{pageItem.displayTitle}}\n            </span>\n\n            <span *ngIf="pageItem.children && pageItem.children.length>0&& pageItem.canNavigate" class="icon-play3" (click)="makeChildrenVisible(pageItem)"></span>\n        </div>\n        <ul *ngIf="pageItem.children && pageItem.children.length>0&& pageItem.canNavigate" [class.hover]="pageItem.visible">\n            <template [ngTemplateOutlet]="recursive" [ngOutletContext]="{$implicit: pageItem.children}">\n            </template>\n        </ul>\n    </li>\n</template>';
},{}],38:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var router_1 = require('@angular/router');
var services_1 = require('../../services');
require('rxjs');
var MultiLevelMenuComponent = (function () {
    function MultiLevelMenuComponent(_clientService, _pageService, _runService, _navigationService, _router) {
        this._clientService = _clientService;
        this._pageService = _pageService;
        this._runService = _runService;
        this._navigationService = _navigationService;
        this._router = _router;
        this.pages = [];
        this.homeUrl = '/';
    }
    MultiLevelMenuComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        var runSnapshot = this._runService.getSnapshot();
        if (runSnapshot)
            this.homeUrl = runSnapshot.info ? "/runs/" + runSnapshot.info.clientId : '/';
        this._router.events.filter(function (o) { return o instanceof router_1.NavigationEnd; })
            .sampleTime(500)
            .subscribe(function (e) {
            _this._clientService.currentClientChanged
                .subscribe(function (c) {
                _this.homeUrl = c && "/runs/" + c.clientId || '/';
            });
        });
        this._pageService.pageStateChanged.subscribe(function (runPages) {
            _this.pages = runPages;
        });
    };
    MultiLevelMenuComponent.prototype.calculateWidth = function (itemList, pageItem) {
        var longestPageTitleLength = this.getLongestPageTitleLength(itemList);
        return (longestPageTitleLength * 0.715) + "em";
    };
    MultiLevelMenuComponent.prototype.navigateTo = function (pageItem) {
        this._navigationService.navigateByUrl(pageItem.url);
    };
    MultiLevelMenuComponent.prototype.makeChildrenVisible = function (pagetItem) {
        var currentPageItemVisible = pagetItem.visible;
        this.makeMenuInvisible(this.pages, pagetItem);
        pagetItem.visible = !currentPageItemVisible;
    };
    MultiLevelMenuComponent.prototype.makeMenuInvisible = function (pages, currentPageItem) {
        for (var i in pages) {
            if (pages[i].level >= currentPageItem.level)
                pages[i].visible = false;
            if (pages[i].children && pages[i].children.length > 0)
                this.makeMenuInvisible(pages[i].children, currentPageItem);
        }
    };
    MultiLevelMenuComponent.prototype.getLongestPageTitleLength = function (itemList) {
        if (!itemList || itemList.length === 0)
            return 7;
        return itemList.reduce(function (a, b) {
            return a.displayTitle.length > b.displayTitle.length ? a : b;
        }).displayTitle.length;
    };
    MultiLevelMenuComponent = __decorate([
        core_1.Component({
            selector: 'multi-level-menu',
            template: require('./multiLevelMenu.html'),
            directives: [router_1.ROUTER_DIRECTIVES],
            moduleId: module.id
        }), 
        __metadata('design:paramtypes', [services_1.ClientService, services_1.PageService, services_1.RunService, services_1.NavigationService, router_1.Router])
    ], MultiLevelMenuComponent);
    return MultiLevelMenuComponent;
}());
exports.MultiLevelMenuComponent = MultiLevelMenuComponent;



},{"../../services":"@toolkit/services","./multiLevelMenu.html":37,"@angular/core":"@angular/core","@angular/router":"@angular/router","rxjs":"rxjs"}],39:[function(require,module,exports){
module.exports = '<div id="progress-indicator">\n    <ul>\n        <li *ngFor="let page of pages;let i = index;" (click)="navigateTo(page.url,page.canNavigate)" [class.canNavigate]="page.canNavigate">\n            <span *ngIf="i!==0" class="icon-play3"></span>\n            <a *ngIf="page.canNavigate" [class.canNavigate]="page.canNavigate" [class.current]="page.current||page.ancestorOfCurrent">\n                {{page.displayResourceKey|translate}}\n            </a>\n            <span *ngIf="!page.canNavigate">\n                {{page.displayResourceKey|translate}}\n            </span>\n        </li>\n    </ul>\n</div>';
},{}],40:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var router_1 = require('@angular/router');
var services_1 = require('../../services');
var backend_1 = require('../../backend');
var ProgressIndicatorComponent = (function () {
    function ProgressIndicatorComponent(_pageService, _router) {
        var _this = this;
        this._pageService = _pageService;
        this._router = _router;
        this.pages = [];
        this._pageService.pageStateChanged.subscribe(function (runPages) {
            if (!_this.explicitRun)
                _this.pages = runPages;
        });
    }
    Object.defineProperty(ProgressIndicatorComponent.prototype, "explicitRun", {
        get: function () {
            return this._explicitRun;
        },
        set: function (v) {
            this._explicitRun = v;
            if (!!v)
                this.pages = this._pageService.buildRunPages(this.explicitRun);
        },
        enumerable: true,
        configurable: true
    });
    ProgressIndicatorComponent.prototype.navigateTo = function (url, canNavigate) {
        if (canNavigate)
            this._router.navigateByUrl(url);
    };
    __decorate([
        core_1.Input('run'), 
        __metadata('design:type', Object)
    ], ProgressIndicatorComponent.prototype, "explicitRun", null);
    ProgressIndicatorComponent = __decorate([
        core_1.Component({
            selector: 'progress-indicator',
            template: require('./progressIndicator.html'),
            directives: [router_1.ROUTER_DIRECTIVES],
            moduleId: module.id
        }), 
        __metadata('design:paramtypes', [services_1.PageService, router_1.Router])
    ], ProgressIndicatorComponent);
    return ProgressIndicatorComponent;
}());
exports.ProgressIndicatorComponent = ProgressIndicatorComponent;



},{"../../backend":"@toolkit/backend","../../services":"@toolkit/services","./progressIndicator.html":39,"@angular/core":"@angular/core","@angular/router":"@angular/router"}],41:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var Rx = require('rxjs');
var StickyHandle = (function () {
    function StickyHandle(reference) {
        this.reference = reference;
    }
    StickyHandle = __decorate([
        core_1.Directive({ selector: 'th.sticky, td.sticky' }), 
        __metadata('design:paramtypes', [core_1.ElementRef])
    ], StickyHandle);
    return StickyHandle;
}());
exports.StickyHandle = StickyHandle;
var QuickStickyComponent = (function () {
    function QuickStickyComponent(renderer, element) {
        this.renderer = renderer;
        this.element = element;
        this.scrolling = new Rx.Subject();
    }
    QuickStickyComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        if (this.headerRefs) {
            this.headerRefs.notifyOnChanges();
            this.headerRefs.changes.subscribe(function () { return _this.recalculate(); });
            this.recalculate();
        }
    };
    QuickStickyComponent.prototype.ngDoCheck = function () {
        var currentWidth = this.element.nativeElement.lastChild.clientWidth;
        if (currentWidth != this.lastWidth) {
            if (this.lastWidth !== null)
                this.recalculate();
            this.lastWidth = currentWidth;
        }
    };
    QuickStickyComponent.prototype.ngOnChanges = function () {
        var _this = this;
        if (this.sync) {
            this.sync.filter(function (o) { return o.owner !== _this; }).subscribe(function (event) {
                if (event.width != null) {
                    _this.syncedWidth = event.width;
                    _this.recalculate();
                }
                if (event.scroll != null) {
                    _this.scrollHandle.nativeElement.scrollLeft = Math.round(event.scroll * _this.scrollHandle.nativeElement.scrollWidth / 5) * 5;
                }
            });
            this.scrolling.debounceTime(500).subscribe(function () {
                _this.sync.next({ owner: _this, scroll: _this.scrollHandle.nativeElement.scrollLeft / _this.scrollHandle.nativeElement.scrollWidth });
            });
        }
    };
    QuickStickyComponent.prototype.recalculate = function () {
        var _this = this;
        setTimeout(function () {
            if (!_this.headerRefs)
                return;
            var calculated = _this.headerRefs.reduce(function (acc, item) { return item.reference.nativeElement.clientWidth > acc ? item.reference.nativeElement.clientWidth : acc; }, 0);
            _this.maxWidth = Math.max(calculated, _this.syncedWidth || 0);
            if (_this.maxWidth) {
                _this.stickyWidth = _this.maxWidth;
                _this.headerRefs.forEach(function (i) { return _this.renderer.setElementStyle(i.reference.nativeElement, "min-width", _this.maxWidth + "px"); });
                if (_this.sync && _this.maxWidth !== _this.syncedWidth)
                    _this.sync.next({ width: _this.maxWidth, owner: _this });
            }
        }, 2);
    };
    QuickStickyComponent.prototype.onResize = function (event) {
        this.recalculate();
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Number)
    ], QuickStickyComponent.prototype, "stickyWidth", void 0);
    __decorate([
        core_1.ViewChild('handle'), 
        __metadata('design:type', core_1.ElementRef)
    ], QuickStickyComponent.prototype, "scrollHandle", void 0);
    __decorate([
        core_1.ContentChildren(StickyHandle, { descendants: true }), 
        __metadata('design:type', core_1.QueryList)
    ], QuickStickyComponent.prototype, "headerRefs", void 0);
    __decorate([
        core_1.HostListener('window:resize', ['$event']), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', [Object]), 
        __metadata('design:returntype', void 0)
    ], QuickStickyComponent.prototype, "onResize", null);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Rx.Subject)
    ], QuickStickyComponent.prototype, "sync", void 0);
    QuickStickyComponent = __decorate([
        core_1.Component({
            selector: 'sticky-table', template: " <div class=\"sticky-wrapper\">\n                    <div class=\"sticky-scroller\" (scroll)=\"scrolling.next()\" #handle [style.margin-left.px]=\"stickyWidth\">\n<ng-content></ng-content>\n</div></div>",
            styles: ["sticky-table /deep/ table {\n        border-spacing: 0;\n    }\n sticky-table /deep/ table thead th {\n            white-space: nowrap;\n        }\nsticky-table /deep/ table tbody td {\n            white-space: nowrap;\n        }\n            .sticky-wrapper {\n                position: relative;\n            }\n                .sticky-scroller {\n            overflow-x: auto;\n            overflow-y: visible;\n        }\n/deep/ th.sticky,/deep/ td.sticky {\n            left: 0;\n            position: absolute;\n            top: auto;\n            background-color:white; \n            display: table-cell;\n        }\n /deep/ td.sticky > *{\n            position: relative;\n            top: 50%;\n            transform: translateY(-50%);\n            display: block;\n        }"]
        }), 
        __metadata('design:paramtypes', [core_1.Renderer, core_1.ElementRef])
    ], QuickStickyComponent);
    return QuickStickyComponent;
}());
exports.QuickStickyComponent = QuickStickyComponent;
exports.StickyTableComponent = [StickyHandle, QuickStickyComponent];



},{"@angular/core":"@angular/core","rxjs":"rxjs"}],42:[function(require,module,exports){
module.exports = '<div class="strategySelector">\n    <ul class="strategyOptions" ngModelGroup="strategy" [validate-using]="areNamesUnique" #group="ngModelGroup" \n        style="width: inherit;" [style.max-height.px]="height">\n        <li class="option" [class.arrow]="s.selected" [style.height.px]="s.selected ? selectedStrategyHeight : strategyHeight"\n            *ngFor="let s of strategies;let i = index" (click)="select($event,s)">\n            <table class="pretty">\n                <tr>\n                    <td style="width: 30px; padding: 0 0 0 0">\n                        <div class="rotate90 option-label" [style.top.px]="s.selected ? selectedStrategyHeight * 0.4342 : strategyHeight * 0.4111">\n                            {{\'COMPONENTS.STRATEGY_SELECTOR.PREFIX\'|translate}} {{i+1}}\n                        </div>\n                        <div class="option-label-container"></div>\n                    </td>\n                    <td *ngIf="!collapse" style="vertical-align:top">\n                        <table style="margin-top:3px">\n                            <tr>\n                                <td>\n                                    <div class="module-content border">\n                                        <table class="pretty">\n                                            <tbody [style.display]="s.selected?\'\':\'none\'">\n                                                <tr>\n                                                    <td class="ellipsis-cell" style="font-size: 12pt;width: 180px">\n                                                        <click-input [disabled]="!s.selected" [forceInvalid]="group.errors?.areNamesUnique && group.errors.areNamesUnique.trim()==s.name.trim()">\n                                                            <input maxlength="20" style="width:100%; padding: 0 0 0 0; font-size: 12pt;"\n                                                                   [(ngModel)]="s.name" name="item.{{s|uniqueId}}.strategyName" trim class="redOnInvalid" required not-blank />\n                                                        </click-input>\n                                                    </td>\n                                                    <td style="text-align:right;width: 120px">\n                                                        <span class="option-clone quick-button icon-copy" title="{{\'COMPONENTS.STRATEGY_SELECTOR.CLONE\'|translate}}"\n                                                              [class.disabled]="!canAdd()" (click)="clone($event, s)"></span>\n                                                        &nbsp;\n                                                        <span class="option-remove quick-button icon-cancel-circle" title="{{\'COMPONENTS.STRATEGY_SELECTOR.REMOVE\'|translate}}"\n                                                              [class.disabled]="strategies.length <= minimumStrategies" (click)="remove($event, s,i)"></span>\n                                                    </td>\n                                                </tr>\n                                                <template [ngTemplateOutlet]="selectedDetails" [ngOutletContext]="{$implicit:s}">\n                                                </template>\n                                            </tbody>\n                                            <tbody [style.display]="!s.selected?\'\':\'none\'">\n                                                <tr>\n                                                    <td class="ellipsis-cell" style="font-size: 12pt;width: 50%">\n                                                        {{s.name}}\n                                                    </td>\n                                                    <td style="text-align: right">\n                                                        <span class="option-clone quick-button icon-copy" [class.disabled]="!canAdd()"\n                                                              title="{{\'COMPONENTS.STRATEGY_SELECTOR.CLONE\'|translate}}"></span>\n                                                        &nbsp;\n                                                        <span class="option-remove quick-button icon-cancel-circle" [class.disabled]="strategies.length <= minimumStrategies"\n                                                               title="{{\'COMPONENTS.STRATEGY_SELECTOR.REMOVE\'|translate}}"></span>\n                                                    </td>\n                                                </tr>\n                                                <template ngIf="!s.selected" [ngTemplateOutlet]="unselectedDetails" [ngOutletContext]="{$implicit:s}">\n                                                </template>\n                                            </tbody>\n                                        </table>\n                                    </div>\n                                </td>\n                            </tr>\n                        </table>\n                    </td>\n            </table>\n        </li>\n        <li *ngIf="!collapse" class="new-strategy quick-button" (click)="add($event)" [hidden]="!canAdd()">\n            {{\'COMPONENTS.STRATEGY_SELECTOR.AddStrategy\'|translate}}\n        </li>\n    </ul>\n</div>\n';
},{}],43:[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var router_1 = require('@angular/router');
var directives_1 = require('../../directives');
var forms_1 = require('@angular/forms');
var reactiveComponent_1 = require('../../reactiveComponent');
var services_1 = require('../../services');
var vex_1 = require('angular2-modal/plugins/vex');
var StrategySelectorComponent = (function (_super) {
    __extends(StrategySelectorComponent, _super);
    function StrategySelectorComponent(form, _translate, _user, _modal) {
        _super.call(this, form);
        this.form = form;
        this._translate = _translate;
        this._user = _user;
        this._modal = _modal;
        this.maximumStrategies = 5;
        this.minimumStrategies = 2;
        this.collapse = false;
        this.strategiesChanged = new core_1.EventEmitter();
        this.strategySelected = new core_1.EventEmitter();
        this.strategyAdded = new core_1.EventEmitter();
        this.strategyRemoved = new core_1.EventEmitter();
        this.strategyCloned = new core_1.EventEmitter();
        this.height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) - 140;
    }
    StrategySelectorComponent.prototype.ngAfterViewInit = function () {
    };
    StrategySelectorComponent.prototype.onResize = function (event) {
        this.height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) - 140;
    };
    StrategySelectorComponent.prototype.add = function (event) {
        if (event)
            event.stopPropagation();
        if (!this.form.valid)
            return false;
        var s = JSON.parse(JSON.stringify(this.newStrategyInput));
        s.name = this.getNewStrategyName();
        s.strategyId = Math.max.apply(Math, this.strategies.map(function (x) { return x.strategyId; })) + 1;
        this.strategies.push(s);
        this.strategyAdded.emit({
            data: s
        });
        this.strategiesChanged.emit({
            data: this.strategies
        });
        this.selectStrategy(s, true, true);
    };
    StrategySelectorComponent.prototype.remove = function (event, structure, index) {
        var _this = this;
        if (event)
            event.stopPropagation();
        if (this.beforeRemove) {
            var retResult = this.beforeRemove(index);
            if (retResult === false || retResult === null) {
                return false;
            }
        }
        this._modal.confirm().message(this._translate.instant('COMPONENTS.STRATEGY_SELECTOR.CONFIRM_OPTION_DELETE')).okBtn(this._translate.instant('GLOBAL.YES'))
            .cancelBtn(this._translate.instant('GLOBAL.NO')).open().then(function (dialog) { return dialog.result.then(function () { return true; }, function () { return false; }); })
            .then(function (ret) {
            if (ret) {
                var deletedStructure = _this.strategies.splice(index, 1);
                if (deletedStructure[0].selected)
                    _this.selectStrategy(_this.strategies[_this.strategies.length - 1], false);
                _this.strategyRemoved.emit({
                    data: deletedStructure[0]
                });
                _this.strategiesChanged.emit({
                    data: _this.strategies
                });
            }
        });
    };
    StrategySelectorComponent.prototype.clone = function (event, strategy) {
        if (event)
            event.stopPropagation();
        if (!this.form.valid)
            return false;
        var s = JSON.parse(JSON.stringify(strategy));
        s.name = this.getNewStrategyName();
        s.strategyId = Math.max.apply(Math, this.strategies.map(function (x) { return x.strategyId; })) + 1;
        s.selected = false;
        this.strategies.push(s);
        this.strategiesChanged.emit({
            data: this.strategies
        });
        this.selectStrategy(s);
        this.strategyCloned.emit({
            data: {
                from: strategy,
                to: s
            }
        });
    };
    StrategySelectorComponent.prototype.canAdd = function () {
        return this._user.currentUserInfo.role === 'User' ? this.strategies.length < this.maximumStrategies : true;
    };
    StrategySelectorComponent.prototype.areNamesUnique = function (option) {
        var optionNames = Object.keys(option.value).filter(function (o) { return o.endsWith('.strategyName'); }).map(function (k) { return option.value[k]; });
        var _loop_1 = function(s) {
            if (optionNames.filter(function (x) { return String(x).trim().toLowerCase() === String(s).trim().toLowerCase(); }).length > 1) {
                return { value: { "areNamesUnique": s } };
            }
        };
        for (var _i = 0, optionNames_1 = optionNames; _i < optionNames_1.length; _i++) {
            var s = optionNames_1[_i];
            var state_1 = _loop_1(s);
            if (typeof state_1 === "object") return state_1.value;
        }
        return {};
    };
    StrategySelectorComponent.prototype.select = function (event, strategy) {
        event.stopPropagation();
        if (strategy.selected)
            return;
        var cloneClass = 'option-clone';
        var removeClass = 'option-remove';
        var srcElClass = event.srcElement.className;
        if (srcElClass.indexOf(cloneClass) === -1 && srcElClass.indexOf(removeClass) === -1)
            this.selectStrategy(strategy);
        else if (srcElClass.indexOf(cloneClass) > -1)
            this.clone(null, strategy);
        else if (srcElClass.indexOf(removeClass) > -1)
            this.remove(null, strategy, this.strategies.indexOf(strategy));
    };
    StrategySelectorComponent.prototype.getNewStrategyName = function () {
        return this._translate.instant('COMPONENTS.STRATEGY_SELECTOR.PREFIX') + ' ' + (this.strategies.length + 1);
    };
    StrategySelectorComponent.prototype.selectStrategy = function (stategy, formValidCheck, isChangedDueToAdd) {
        if (formValidCheck === void 0) { formValidCheck = true; }
        if (isChangedDueToAdd === void 0) { isChangedDueToAdd = false; }
        if (formValidCheck && !this.form.valid)
            return false;
        for (var _i = 0, _a = this.strategies; _i < _a.length; _i++) {
            var s = _a[_i];
            s.selected = s === stategy;
        }
        this.strategySelected.emit({
            data: stategy,
            isChangedDueToAdd: isChangedDueToAdd
        });
        return true;
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Array)
    ], StrategySelectorComponent.prototype, "strategies", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], StrategySelectorComponent.prototype, "newStrategyInput", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Number)
    ], StrategySelectorComponent.prototype, "maximumStrategies", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Number)
    ], StrategySelectorComponent.prototype, "minimumStrategies", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Number)
    ], StrategySelectorComponent.prototype, "strategyHeight", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Number)
    ], StrategySelectorComponent.prototype, "selectedStrategyHeight", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Boolean)
    ], StrategySelectorComponent.prototype, "collapse", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Function)
    ], StrategySelectorComponent.prototype, "beforeRemove", void 0);
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], StrategySelectorComponent.prototype, "strategiesChanged", void 0);
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], StrategySelectorComponent.prototype, "strategySelected", void 0);
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], StrategySelectorComponent.prototype, "strategyAdded", void 0);
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], StrategySelectorComponent.prototype, "strategyRemoved", void 0);
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], StrategySelectorComponent.prototype, "strategyCloned", void 0);
    __decorate([
        core_1.HostListener('window:resize', ['$event']), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', [Object]), 
        __metadata('design:returntype', void 0)
    ], StrategySelectorComponent.prototype, "onResize", null);
    __decorate([
        core_1.ContentChild('unselectedDetails', { read: core_1.TemplateRef }), 
        __metadata('design:type', core_1.TemplateRef)
    ], StrategySelectorComponent.prototype, "unselectedDetails", void 0);
    __decorate([
        core_1.ContentChild('selectedDetails', { read: core_1.TemplateRef }), 
        __metadata('design:type', core_1.TemplateRef)
    ], StrategySelectorComponent.prototype, "selectedDetails", void 0);
    StrategySelectorComponent = __decorate([
        core_1.Component({
            selector: 'strategy-selector',
            directives: [directives_1.VALIDATORS, router_1.ROUTER_DIRECTIVES, directives_1.TOOLTIP, directives_1.READONLY_DIRECTIVES, directives_1.CUSTOM_VALUE_ACCESSORS, directives_1.CLICK_INPUT_DIRECTIVE],
            viewProviders: [reactiveComponent_1.dynamicFormDirectiveProvider(function () { return StrategySelectorComponent; })],
            template: require('./strategySelector.html'),
            moduleId: module.id
        }), 
        __metadata('design:paramtypes', [forms_1.NgForm, services_1.TranslateService, services_1.UserService, vex_1.Modal])
    ], StrategySelectorComponent);
    return StrategySelectorComponent;
}(reactiveComponent_1.DynamicFormComponent));
exports.StrategySelectorComponent = StrategySelectorComponent;



},{"../../directives":"@toolkit/directives","../../reactiveComponent":"@toolkit/reactiveComponent","../../services":"@toolkit/services","./strategySelector.html":42,"@angular/core":"@angular/core","@angular/forms":"@angular/forms","@angular/router":"@angular/router","angular2-modal/plugins/vex":"angular2-modal/plugins/vex"}],44:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var rx_1 = require('rxjs');
var clickOutside_1 = require('./clickOutside');
var AutocompleteComponent = (function () {
    function AutocompleteComponent() {
        this.throttle = new rx_1.Subject();
        this.resultsChange = new core_1.EventEmitter();
        this.autoClear = true;
        this.busy = false;
        this._selectionIndex = -1;
        this.enterPressed = new core_1.EventEmitter();
    }
    AutocompleteComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.throttle
            .debounceTime(700)
            .filter(function (v) { return !!v && v.trim().length > 2; })
            .do(function () { return _this.busy = true; })
            .map(function (v) {
            return _this.dataSource(v)
                .catch(function (err) { return rx_1.Observable.of({ data: [] }); });
        })
            .concatAll()
            .subscribe(function (result) {
            _this.busy = false;
            _this.results = _this.map ? _this.map(result.data) : result.data;
            _this.resultsChange.emit(_this.results);
            _this._selectionIndex = -1;
        });
    };
    AutocompleteComponent.prototype.handleSelection = function (move) {
        if (this.results) {
            var next = move !== 0 ? this._selectionIndex + move : -1;
            this.changeSelection(next);
        }
    };
    AutocompleteComponent.prototype.activate = function (item) {
        if (item || this.selected) {
            this.enterPressed.emit(item || this.selected);
            if (this.autoClear)
                this.clear();
        }
    };
    Object.defineProperty(AutocompleteComponent.prototype, "selected", {
        get: function () {
            return this.results && this._selectionIndex > -1 && this.results[this._selectionIndex];
        },
        set: function (item) {
            if (this.results) {
                if (item !== this.selected) {
                    var next = this.results.indexOf(item);
                    this.changeSelection(next);
                }
            }
            else
                this._selectionIndex = -1;
        },
        enumerable: true,
        configurable: true
    });
    AutocompleteComponent.prototype.changeSelection = function (next) {
        var old = this._selectionIndex;
        this._selectionIndex = next = Math.max(-1, Math.min((this.results || []).length - 1, next));
        if (old !== next) {
            if (old > -1 && this.results.length)
                this.results[old].$selected = false;
            if (next > -1)
                this.results[next].$selected = true;
        }
    };
    AutocompleteComponent.prototype.clear = function () {
        this.handleSelection(-1);
        this.results = [];
        this.resultsChange.emit([]);
        this.term = null;
    };
    AutocompleteComponent.prototype.focus = function () {
        if (this.inputRef)
            this.inputRef.nativeElement.focus();
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Array)
    ], AutocompleteComponent.prototype, "results", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Function)
    ], AutocompleteComponent.prototype, "dataSource", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Function)
    ], AutocompleteComponent.prototype, "map", void 0);
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], AutocompleteComponent.prototype, "resultsChange", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], AutocompleteComponent.prototype, "autoClear", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], AutocompleteComponent.prototype, "notFoundMessage", void 0);
    __decorate([
        core_1.Output('enter'), 
        __metadata('design:type', Object)
    ], AutocompleteComponent.prototype, "enterPressed", void 0);
    __decorate([
        core_1.ContentChild(core_1.TemplateRef), 
        __metadata('design:type', core_1.TemplateRef)
    ], AutocompleteComponent.prototype, "itemTemplate", void 0);
    __decorate([
        core_1.ViewChild('input'), 
        __metadata('design:type', core_1.ElementRef)
    ], AutocompleteComponent.prototype, "inputRef", void 0);
    AutocompleteComponent = __decorate([
        core_1.Component({
            selector: 'autocomplete', template: "\n <div class=\"autocomplete\" (clickOutside)=\"clear()\">\n\n<input [(ngModel)]=\"term\" (ngModelChange)=\"throttle.next($event)\" #input style='vertical-align:initial;'\n        (keyup.arrowdown)=\"handleSelection(+1)\"\n        (keyup.arrowup)=\"handleSelection(-1)\"\n        (keyup.enter)=\"activate()\"\n        (keyup.escape)=\"clear()\" />\n    <ul [hidden]=\"!results || !(results.length || notFoundMessage)\">\n        <li *ngFor=\"let rowData of results\" [class.selected]=\"rowData.$selected\" (mouseenter)=\"selected = rowData\" (click)=\"activate(rowData)\">\n<template [ngTemplateOutlet]=\"itemTemplate\" [ngOutletContext]=\"{item: rowData}\"></template>\n    </li>\n  <li *ngIf=\"results && !results.length &&notFoundMessage\">\n                                    <span class=\"muted\">{{notFoundMessage}}</span>\n                                </li>\n  </ul>\n</div>", moduleId: module.id, directives: [clickOutside_1.ClickOutsideDirective]
        }), 
        __metadata('design:paramtypes', [])
    ], AutocompleteComponent);
    return AutocompleteComponent;
}());
exports.AutocompleteComponent = AutocompleteComponent;
exports.AUTOCOMPLETE = [AutocompleteComponent];



},{"./clickOutside":49,"@angular/core":"@angular/core","rxjs":"rxjs"}],45:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var angular2_highcharts_1 = require('angular2-highcharts');
function measure(chartHandler) {
    var native = chartHandler.element.nativeElement;
    var base = native.getBoundingClientRect();
    var elements = Array.from(native.querySelectorAll('g.highcharts-axis'));
    if (!elements)
        return;
    var boxes = elements.map(function (e) { return e.getBoundingClientRect(); });
    if (boxes.length == 0)
        return;
    var xAxis = boxes.reduce(function (acc, item) { return acc.width < item.width ? item : acc; });
    var yAxis = boxes.reduce(function (acc, item) { return acc.width > item.width ? item : acc; });
    console.log("xWidth: " + xAxis.width + ", baseWidth: " + base.width);
    if (xAxis.width > base.width) {
        return;
    }
    if (yAxis.height > base.height) {
        return;
    }
    var measurements = {
        xAxis: {
            left: xAxis.left - base.left, width: xAxis.width
        },
        yAxis: {
            top: yAxis.top - base.top, height: yAxis.height
        }
    };
    return measurements;
}
var AlignToXAxis = (function () {
    function AlignToXAxis() {
    }
    AlignToXAxis.prototype.ngOnChanges = function () {
        var _this = this;
        if (!this.chartHandler)
            return;
        this.chartHandler.redraw.subscribe(function () {
            _this.update();
        });
        this.update();
    };
    AlignToXAxis.prototype.update = function () {
        var ret = measure(this.chartHandler);
        if (!ret)
            return;
        this.left = ret.xAxis.left;
        this.width = ret.xAxis.width;
    };
    AlignToXAxis.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () { return _this.update(); }, 10);
    };
    __decorate([
        core_1.Input('alignToXAxis'), 
        __metadata('design:type', angular2_highcharts_1.ChartComponent)
    ], AlignToXAxis.prototype, "chartHandler", void 0);
    __decorate([
        core_1.HostBinding('style.margin-left.px'), 
        __metadata('design:type', Number)
    ], AlignToXAxis.prototype, "left", void 0);
    __decorate([
        core_1.HostBinding('style.width.px'), 
        __metadata('design:type', Number)
    ], AlignToXAxis.prototype, "width", void 0);
    AlignToXAxis = __decorate([
        core_1.Directive({ selector: '[alignToXAxis]' }), 
        __metadata('design:paramtypes', [])
    ], AlignToXAxis);
    return AlignToXAxis;
}());
exports.AlignToXAxis = AlignToXAxis;
var AlignToYAxis = (function () {
    function AlignToYAxis() {
    }
    AlignToYAxis.prototype.ngOnChanges = function () {
        var _this = this;
        if (!this.chartHandler)
            return;
        this.chartHandler.redraw.subscribe(function () {
            _this.update();
        });
        this.update();
    };
    AlignToYAxis.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () { return _this.update(); }, 10);
    };
    AlignToYAxis.prototype.update = function () {
        var ret = measure(this.chartHandler);
        if (!ret)
            return;
        this.top = ret.yAxis.top;
        this.height = ret.yAxis.height;
    };
    __decorate([
        core_1.Input('alignToYAxis'), 
        __metadata('design:type', angular2_highcharts_1.ChartComponent)
    ], AlignToYAxis.prototype, "chartHandler", void 0);
    __decorate([
        core_1.HostBinding('style.margin-top.px'), 
        __metadata('design:type', Number)
    ], AlignToYAxis.prototype, "top", void 0);
    __decorate([
        core_1.HostBinding('style.height.px'), 
        __metadata('design:type', Number)
    ], AlignToYAxis.prototype, "height", void 0);
    AlignToYAxis = __decorate([
        core_1.Directive({ selector: '[alignToYAxis]' }), 
        __metadata('design:paramtypes', [])
    ], AlignToYAxis);
    return AlignToYAxis;
}());
exports.AlignToYAxis = AlignToYAxis;
exports.ALIGN_TO_AXIS = [AlignToXAxis, AlignToYAxis];



},{"@angular/core":"@angular/core","angular2-highcharts":"angular2-highcharts"}],46:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = require('@angular/core');
var forms_1 = require('@angular/forms');
function equalityByKey(left, right, keyName) {
    var equality = left === right;
    if (keyName) {
        if (typeof keyName === 'string')
            equality = (!left === !right) && (!left || left[keyName] === right[keyName]);
        else {
            equality = (!left === !right) && (!left || keyName.every(function (kn) { return left[kn] === right[kn]; }));
        }
    }
    return equality;
}
function sort(list, keyName) {
    if (keyName)
        if (typeof keyName === 'string')
            return list.sort(function (a, b) {
                if (a[keyName] > b[keyName]) {
                    return 1;
                }
                if (a[keyName] < b[keyName]) {
                    return -1;
                }
                return 0;
            });
        else {
            var sorter_1 = function (a, b, index) {
                if (a[keyName[index]] > b[keyName[index]]) {
                    return 1;
                }
                if (a[keyName[index]] < b[keyName[index]]) {
                    return -1;
                }
                if (index === keyName.length - 1)
                    return 0;
                else
                    return sorter_1(a, b, index + 1);
            };
            return list.sort(function (a, b) { return sorter_1(a, b, 0); });
        }
    else
        return list.sort();
}
exports.CHECKED_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(function () { return CheckedValueAccessor; }),
    multi: true
};
var CheckedValueAccessor = (function () {
    function CheckedValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (v) { };
        this.onTouched = function () { };
    }
    CheckedValueAccessor.prototype.writeValue = function (value) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', equalityByKey(value, this.objectValue, this.keyName));
    };
    CheckedValueAccessor.prototype.clicked = function (checked) {
        if (checked) {
            this.onChange(this.objectValue);
        }
        else {
            this.onChange(undefined);
        }
        this.onTouched();
    };
    CheckedValueAccessor.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    CheckedValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    __decorate([
        core_1.Input('ngValue'), 
        __metadata('design:type', Object)
    ], CheckedValueAccessor.prototype, "objectValue", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], CheckedValueAccessor.prototype, "keyName", void 0);
    __decorate([
        core_1.HostListener('change', ['$event.target.checked']), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', [Boolean]), 
        __metadata('design:returntype', void 0)
    ], CheckedValueAccessor.prototype, "clicked", null);
    CheckedValueAccessor = __decorate([
        core_1.Directive({
            selector: 'input[type=radio][ngValue][ngModel]',
            providers: [exports.CHECKED_VALUE_ACCESSOR]
        }), 
        __metadata('design:paramtypes', [core_1.Renderer, core_1.ElementRef])
    ], CheckedValueAccessor);
    return CheckedValueAccessor;
}());
exports.CheckedValueAccessor = CheckedValueAccessor;
exports.MULTICHECKED_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(function () { return MultiCheckedValueAccessor; }),
    multi: true
};
var MultiCheckedValueAccessor = (function () {
    function MultiCheckedValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (v) { };
        this.onTouched = function () { };
    }
    MultiCheckedValueAccessor.prototype.writeValue = function (value) {
        var _this = this;
        var contained = value && value.findIndex(function (item) { return equalityByKey(item, _this.objectValue, _this.keyName); }) > -1;
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', contained);
    };
    MultiCheckedValueAccessor.prototype.clicked = function (checked) {
        var _this = this;
        var existing = this.arrayValue || [];
        var without = existing.filter(function (o) { return o !== _this.objectValue; });
        var result = without;
        if (checked)
            result = without.concat([this.objectValue]);
        result = sort(result, this.keyName);
        this.onChange(result);
        this.onTouched();
    };
    MultiCheckedValueAccessor.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    MultiCheckedValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    __decorate([
        core_1.Input('ngValue'), 
        __metadata('design:type', Object)
    ], MultiCheckedValueAccessor.prototype, "objectValue", void 0);
    __decorate([
        core_1.Input('ngModel'), 
        __metadata('design:type', Array)
    ], MultiCheckedValueAccessor.prototype, "arrayValue", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], MultiCheckedValueAccessor.prototype, "keyName", void 0);
    __decorate([
        core_1.HostListener('change', ['$event.target.checked']), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', [Boolean]), 
        __metadata('design:returntype', void 0)
    ], MultiCheckedValueAccessor.prototype, "clicked", null);
    MultiCheckedValueAccessor = __decorate([
        core_1.Directive({
            selector: 'input[type=checkbox][ngValue][ngModel]',
            providers: [exports.MULTICHECKED_VALUE_ACCESSOR]
        }), 
        __metadata('design:paramtypes', [core_1.Renderer, core_1.ElementRef])
    ], MultiCheckedValueAccessor);
    return MultiCheckedValueAccessor;
}());
exports.MultiCheckedValueAccessor = MultiCheckedValueAccessor;
exports.SELECT_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(function () { return SelectValueAccessor; }),
    multi: true
};
var SelectValueAccessor = (function () {
    function SelectValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.cnt = 0;
        this.onChange = function (v) { };
        this.onTouched = function () { };
        this.$$options = [];
    }
    SelectValueAccessor.prototype.selection = function (value) {
        var option = this.$$options.find(function (o) { return o.index == value; });
        if (option)
            this.onChange(option.objectValue);
        else
            this.onChange(undefined);
    };
    SelectValueAccessor.prototype.writeValue = function (value) {
        var _this = this;
        this.value = value;
        var index = this.$$options.findIndex(function (o) { return equalityByKey(value, o.objectValue, _this.keyName); });
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'selectedIndex', index);
    };
    SelectValueAccessor.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    SelectValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    SelectValueAccessor.prototype.register = function (option) {
        this.$$options.push(option);
        return (this.cnt++).toString();
    };
    SelectValueAccessor.prototype.unregister = function (option) {
        this.$$options = this.$$options.filter(function (o) { return o !== option; });
        this.writeValue(this.value);
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], SelectValueAccessor.prototype, "keyName", void 0);
    __decorate([
        core_1.HostListener('blur'), 
        __metadata('design:type', Object)
    ], SelectValueAccessor.prototype, "onTouched", void 0);
    __decorate([
        core_1.HostListener('change', ['$event.target.value']), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', [String]), 
        __metadata('design:returntype', void 0)
    ], SelectValueAccessor.prototype, "selection", null);
    SelectValueAccessor = __decorate([
        core_1.Directive({
            selector: 'select:not([multiple])[ngModel][keyName]',
            providers: [exports.SELECT_VALUE_ACCESSOR]
        }), 
        __metadata('design:paramtypes', [core_1.Renderer, core_1.ElementRef])
    ], SelectValueAccessor);
    return SelectValueAccessor;
}());
exports.SelectValueAccessor = SelectValueAccessor;
var SelectOption = (function () {
    function SelectOption(_element, _renderer, _select, _other) {
        this._element = _element;
        this._renderer = _renderer;
        this._select = _select;
        this._other = _other;
        if (this._select) {
            this.index = this._select.register(this);
        }
    }
    SelectOption.prototype.ngOnChanges = function () {
        if (this.index != null && this._other.value != this.index)
            this._other.value = this.index;
    };
    SelectOption.prototype.ngOnDestroy = function () {
        if (this._select) {
            this._select.unregister(this);
        }
    };
    __decorate([
        core_1.Input('ngValue'), 
        __metadata('design:type', Object)
    ], SelectOption.prototype, "objectValue", void 0);
    SelectOption = __decorate([
        core_1.Directive({
            selector: 'option[ngValue]'
        }),
        __param(2, core_1.Optional()),
        __param(2, core_1.Host()), 
        __metadata('design:paramtypes', [core_1.ElementRef, core_1.Renderer, SelectValueAccessor, forms_1.NgSelectOption])
    ], SelectOption);
    return SelectOption;
}());
exports.SelectOption = SelectOption;



},{"@angular/core":"@angular/core","@angular/forms":"@angular/forms"}],47:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var Rx = require('rxjs');
var ClickAndHoldDirective = (function () {
    function ClickAndHoldDirective() {
        this.period = 200;
        this.output = new core_1.EventEmitter();
        this.mouseUp = new Rx.Subject();
        this.mouseDown = new Rx.Subject();
    }
    ClickAndHoldDirective.prototype.onMouseUp = function () { this.mouseUp.next(null); };
    ClickAndHoldDirective.prototype.onMouseDown = function () { this.mouseDown.next(null); };
    ClickAndHoldDirective.prototype.ngOnInit = function () {
        this.setup();
    };
    ClickAndHoldDirective.prototype.setup = function () {
        var _this = this;
        if (!!this.subscription)
            this.subscription.unsubscribe();
        this.subscription = this.mouseDown.do(function () { return _this.output.emit(null); }).flatMap(function () { return Rx.Observable.interval(_this.period).skip(3).takeUntil(_this.mouseUp); }).subscribe(function (i) { return _this.output.emit(null); });
    };
    ClickAndHoldDirective.prototype.ngOnChanges = function () {
        this.setup();
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], ClickAndHoldDirective.prototype, "period", void 0);
    __decorate([
        core_1.Output('clickAndHold'), 
        __metadata('design:type', Object)
    ], ClickAndHoldDirective.prototype, "output", void 0);
    __decorate([
        core_1.HostListener('mouseup'), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], ClickAndHoldDirective.prototype, "onMouseUp", null);
    __decorate([
        core_1.HostListener('mousedown'), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], ClickAndHoldDirective.prototype, "onMouseDown", null);
    ClickAndHoldDirective = __decorate([
        core_1.Directive({ selector: '[clickAndHold]' }), 
        __metadata('design:paramtypes', [])
    ], ClickAndHoldDirective);
    return ClickAndHoldDirective;
}());
exports.ClickAndHoldDirective = ClickAndHoldDirective;



},{"@angular/core":"@angular/core","rxjs":"rxjs"}],48:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = require('@angular/core');
var forms_1 = require('@angular/forms');
var Rx = require('rxjs');
var BlurJacker = (function () {
    function BlurJacker(_renderer, _element, parent) {
        this._renderer = _renderer;
        this._element = _element;
        this.parent = parent;
        this.blurred = new Rx.Subject();
        this.clicked = new Rx.Subject();
        this.modelChange = new Rx.ReplaySubject(1);
        this.hide = true;
        if (!this.parent)
            this.hide = false;
    }
    BlurJacker.prototype.focus = function () {
        var _this = this;
        setTimeout(function () {
            try {
                _this._renderer.invokeElementMethod(_this._element.nativeElement, 'focus');
                _this._renderer.invokeElementMethod(_this._element.nativeElement, 'select');
            }
            catch (x) { }
        }, 0);
    };
    BlurJacker = __decorate([
        core_1.Directive({
            selector: '[ngModel]', host: { '(blur)': 'blurred.next()', '[hidden]': 'hide', '(click)': 'clicked.next()' }
        }),
        __param(2, core_1.Optional()),
        __param(2, core_1.Inject(core_1.forwardRef(function () { return ClickInputDirective; }))), 
        __metadata('design:paramtypes', [core_1.Renderer, core_1.ElementRef, ClickInputDirective])
    ], BlurJacker);
    return BlurJacker;
}());
exports.BlurJacker = BlurJacker;
var ClickInputDirective = (function () {
    function ClickInputDirective() {
        this.noop = function (value) { return (value != null ? value : '').toString(); };
        this.format = false;
        this.opened = new core_1.EventEmitter();
        this._initialized = false;
        this._hasFocus = false;
        this.text = '';
        this.hide = true;
    }
    Object.defineProperty(ClickInputDirective.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (v) {
            this._value = v;
            this.text = v;
        },
        enumerable: true,
        configurable: true
    });
    ClickInputDirective.prototype.ngDoCheck = function () {
        this.recalculate(false);
    };
    ClickInputDirective.prototype.ngOnChanges = function () {
        this.recalculate(true);
    };
    ClickInputDirective.prototype.recalculate = function (force) {
        var _this = this;
        if (this._initialized) {
            var old = this._lastVm;
            var now = this._lastVm = this.model.viewModel;
            if (this._value)
                this.text = this._value;
            else if (old != now || force) {
                var accessor_1 = this.model.valueAccessor;
                var transformation = this.transformation || (this.displayPropertyName ? (function (o) { return o[_this.displayPropertyName]; }) : null);
                this.text = (transformation || accessor_1.formatToString && (function (s) { return accessor_1.formatToString(s); }) || this.noop)(this.model.viewModel) || this._placeholder;
            }
            if (!this._hasFocus && this.model.valid && !this.forceInvalid) {
                this.hide = true;
                this.blurJacker.hide = true;
            }
            else if (!this.model.valid) {
                this.hide = false;
                this.blurJacker.hide = false;
            }
        }
    };
    ClickInputDirective.prototype.ngAfterViewInit = function () {
        var _this = this;
        this._initialized = true;
        this.blurJacker.blurred.subscribe(function () {
            if (_this.model.valid && !_this.forceInvalid) {
                _this.hide = true;
                _this.blurJacker.hide = true;
            }
            _this._hasFocus = false;
        });
        this.blurJacker.clicked.subscribe(function () { _this._hasFocus = true; });
    };
    ClickInputDirective.prototype.show = function () {
        if (this.disabled)
            return;
        this.hide = false;
        this.blurJacker.hide = false;
        this.blurJacker.focus();
        this._hasFocus = true;
        this.opened.emit(null);
    };
    Object.defineProperty(ClickInputDirective.prototype, "forceInvalid", {
        get: function () { return this._forceInvalid; },
        set: function (v) {
            this._forceInvalid = v;
            if (v) {
                this.hide = false;
                this.blurJacker.hide = false;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClickInputDirective.prototype, "placeholder", {
        get: function () {
            return this._placeholder;
        },
        set: function (value) {
            this._placeholder = value;
            if (!this.text)
                this.text = value;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Boolean)
    ], ClickInputDirective.prototype, "disabled", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Function)
    ], ClickInputDirective.prototype, "transformation", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], ClickInputDirective.prototype, "displayPropertyName", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Boolean)
    ], ClickInputDirective.prototype, "format", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], ClickInputDirective.prototype, "value", null);
    __decorate([
        core_1.ContentChild(BlurJacker), 
        __metadata('design:type', BlurJacker)
    ], ClickInputDirective.prototype, "blurJacker", void 0);
    __decorate([
        core_1.ContentChild(forms_1.NgModel), 
        __metadata('design:type', forms_1.NgModel)
    ], ClickInputDirective.prototype, "model", void 0);
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], ClickInputDirective.prototype, "opened", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Boolean), 
        __metadata('design:paramtypes', [Boolean])
    ], ClickInputDirective.prototype, "forceInvalid", null);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], ClickInputDirective.prototype, "placeholder", null);
    ClickInputDirective = __decorate([
        core_1.Component({
            selector: 'click-input', template: "\n            <ng-content></ng-content>\n            <span [style.display]=\"!hide?'none':'inline-block'\" (click)=\"show()\" style=\"white-space: pre-line;min-width:50px\" [style.cursor]=\"disabled?'inherit':'pointer'\">{{format ? (text | localeNumber:'.0-2') : text }}</span>\n            ", styles: [":host{ display:inline}"], host: {
                '[class.invalid]': 'forceInvalid'
            }
        }), 
        __metadata('design:paramtypes', [])
    ], ClickInputDirective);
    return ClickInputDirective;
}());
exports.ClickInputDirective = ClickInputDirective;
exports.CLICK_INPUT_DIRECTIVE = [ClickInputDirective, BlurJacker];



},{"@angular/core":"@angular/core","@angular/forms":"@angular/forms","rxjs":"rxjs"}],49:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var ClickOutsideDirective = (function () {
    function ClickOutsideDirective() {
        this.clickOutside = new core_1.EventEmitter();
    }
    ClickOutsideDirective.prototype.localClick = function (event) {
        this.reference = event;
    };
    ClickOutsideDirective.prototype.globalClick = function (event) {
        if (this.reference !== event)
            this.clickOutside.emit(event);
    };
    __decorate([
        core_1.Output('clickOutside'), 
        __metadata('design:type', Object)
    ], ClickOutsideDirective.prototype, "clickOutside", void 0);
    ClickOutsideDirective = __decorate([
        core_1.Directive({ selector: 'clickOutside', host: {
                '(click)': 'localClick($event)', '(document:click)': 'globalClick($event)'
            } }), 
        __metadata('design:paramtypes', [])
    ], ClickOutsideDirective);
    return ClickOutsideDirective;
}());
exports.ClickOutsideDirective = ClickOutsideDirective;



},{"@angular/core":"@angular/core"}],50:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var forms_1 = require('@angular/forms');
var pipes_1 = require('../../pipes');
var moment = require('moment/moment');
exports.DATE_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(function () { return DateValueAccessor; }),
    multi: true
};
var DateValueAccessor = (function () {
    function DateValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
        this.datePipe = new pipes_1.SafeDatePipe();
        var fake = 'asdf';
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', fake);
        var real = this._elementRef.nativeElement.value;
        this.isHtml5Supported = fake !== real;
        if (!this.isHtml5Supported) {
            this._renderer.setElementProperty(this._elementRef.nativeElement, 'placeholder', moment.localeData().longDateFormat('L').toLowerCase());
            this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', '');
        }
    }
    DateValueAccessor.prototype.writeValue = function (value) {
        value = moment.utc(value).toDate();
        if (this.isHtml5Supported)
            this._renderer.setElementProperty(this._elementRef.nativeElement, 'valueAsDate', value);
        else {
            if (value === null)
                this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', '');
            else
                this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', moment.utc(value).format('L'));
        }
    };
    DateValueAccessor.prototype.compatibility = function (value) {
        if (this.isHtml5Supported)
            return;
        var instance = moment.utc(value, 'L');
        if (instance.isValid()) {
            this.onChange(instance.toDate());
        }
        else {
            this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', '');
            this.onChange(null);
        }
    };
    DateValueAccessor.prototype.formatToString = function (value) {
        if (value)
            return moment.utc(value).format("DD MMM YYYY");
        return null;
    };
    DateValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this.onChange = function (d) {
            if (_this.writeAsString != null && !!d)
                fn(d.toJSON());
            else
                fn(d);
        };
    };
    DateValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    DateValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    __decorate([
        core_1.HostListener('input', ['$event.target.valueAsDate']), 
        __metadata('design:type', Object)
    ], DateValueAccessor.prototype, "onChange", void 0);
    __decorate([
        core_1.HostListener('blur', []), 
        __metadata('design:type', Object)
    ], DateValueAccessor.prototype, "onTouched", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], DateValueAccessor.prototype, "writeAsString", void 0);
    __decorate([
        core_1.HostListener('blur', ['$event.target.value']), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', [String]), 
        __metadata('design:returntype', void 0)
    ], DateValueAccessor.prototype, "compatibility", null);
    DateValueAccessor = __decorate([
        core_1.Directive({
            selector: 'input[type=date][formControlName],input[type=date][formControl],input[type=date][ngModel]',
            providers: [exports.DATE_VALUE_ACCESSOR]
        }), 
        __metadata('design:paramtypes', [core_1.Renderer, core_1.ElementRef])
    ], DateValueAccessor);
    return DateValueAccessor;
}());
exports.DateValueAccessor = DateValueAccessor;



},{"../../pipes":"@toolkit/pipes","@angular/core":"@angular/core","@angular/forms":"@angular/forms","moment/moment":1}],51:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var ExpanderComponent = (function () {
    function ExpanderComponent() {
        this.initialized = false;
        this.isOpen = false;
        this.isFloaty = false;
        this.clickable = false;
    }
    ExpanderComponent.prototype.open = function () {
        var wasOpen = this.isOpen;
        this.isOpen = true;
        return !wasOpen;
    };
    ExpanderComponent.prototype.close = function () {
        var wasOpen = this.isOpen;
        this.isOpen = false;
        return wasOpen;
    };
    ExpanderComponent.prototype.ngOnInit = function () {
        var _this = this;
        setTimeout(function () { return _this.initialized = true; }, 30);
    };
    ExpanderComponent.prototype.headerClick = function () { if (this.clickable)
        this.open(); };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], ExpanderComponent.prototype, "isOpen", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], ExpanderComponent.prototype, "isFloaty", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], ExpanderComponent.prototype, "clickable", void 0);
    ExpanderComponent = __decorate([
        core_1.Component({
            selector: 'expander', template: "<div class=\"expander-header\" [style.cursor]=\"clickable&&'pointer'\" (click)=\"headerClick()\"><ng-content select=\"header\"></ng-content></div>\n<div *ngIf=\"initialized\" class=\"expander-content closed\" [class.floater]=\"isFloaty\" [class.closed]=\"!isOpen\" ><ng-content></ng-content></div>",
        }), 
        __metadata('design:paramtypes', [])
    ], ExpanderComponent);
    return ExpanderComponent;
}());
exports.ExpanderComponent = ExpanderComponent;



},{"@angular/core":"@angular/core"}],52:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var forms_1 = require('@angular/forms');
var common_1 = require('@angular/common');
var intPercentPipe_1 = require('../pipes/intPercentPipe');
var translation_1 = require('../services/translation');
var LanguageFormatterService_1 = require('../services/LanguageFormatterService');
var CUSTOM_VALUE_ACCESSOR = new core_1.Provider(forms_1.NG_VALUE_ACCESSOR, { useExisting: core_1.forwardRef(function () { return FormattedLocaleNumbersAccessor; }), multi: true });
var _NUMBER_FORMAT_REGEXP = /^(\d+)?\.((\d+)(\-(\d+))?)?$/;
var _NUMBER_MATCH_REGEXP = /-?.?\d+(\.\d+)?/;
function precision(a) {
    if (!isFinite(a))
        return 0;
    var e = 1, p = 0;
    while (Math.round(a * e) / e !== a) {
        e *= 10;
        p++;
    }
    return p;
}
function round_number(num, decimals) {
    return Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals);
}
var FormattedLocaleNumbersAccessor = (function () {
    function FormattedLocaleNumbersAccessor(_renderer, _elementRef, _translation, _numberHelper) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._translation = _translation;
        this._numberHelper = _numberHelper;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    FormattedLocaleNumbersAccessor.prototype.blurred = function (value) {
        this.onChange(value);
        this.onTouched();
    };
    FormattedLocaleNumbersAccessor.prototype.parseFormat = function () {
        if (!this.format)
            throw "format string not set";
        var split = this.format.split(':');
        var getPipe = function (input) {
            if (input === 'number')
                return { instance: new common_1.DecimalPipe() };
            if (input === 'percent')
                return { instance: new common_1.PercentPipe(), map: function (x) { return parseFloat((x / 100).toFixed(precision(x) + 2)); } };
            if (input === 'intPercent')
                return { instance: new intPercentPipe_1.IntPercentPipe() };
            throw "unknown formatter pipe: " + input;
        };
        var digits = split[1];
        var minInt = 1, minFraction = 0, maxFraction = 3;
        if (!!digits) {
            var parts = _NUMBER_FORMAT_REGEXP.exec(digits);
            if (!(parts)) {
                throw digits + " is not a valid digit info for number pipes";
            }
            if (!!parts[1]) {
                minInt = parseInt(parts[1]);
            }
            if (!!parts[3]) {
                minFraction = parseInt(parts[3]);
            }
            if (!!parts[5]) {
                maxFraction = parseInt(parts[5]);
            }
        }
        this._parsedFormat = {
            pipe: getPipe(split[0]), numbers: {
                minimumIntegerDigits: minInt,
                minimumFractionDigits: minFraction,
                maximumFractionDigits: maxFraction
            }, raw: digits
        };
    };
    FormattedLocaleNumbersAccessor.prototype.formatToString = function (value) {
        if (value === 0)
            return "0";
        if (value) {
            if (!this._parsedFormat)
                this.parseFormat();
            var pipe = this._parsedFormat.pipe;
            var displayText = pipe.instance.transform(value, this._parsedFormat.raw);
            return this._numberHelper.removeFormatting(displayText);
        }
        return "";
    };
    FormattedLocaleNumbersAccessor.prototype.parseToNumber = function (value) {
        this.locale = this._translation.getLocale();
        if (this.locale === null || this.locale === undefined)
            this.locale = 'en';
        if (!this._parsedFormat)
            this.parseFormat();
        value = this._numberHelper.formatDisplayValue(value, this.locale);
        var match = _NUMBER_MATCH_REGEXP.exec(value);
        if (!match) {
            this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', "");
            return undefined;
        }
        var number = parseFloat(match[0]);
        if (isNaN(number)) {
            this.writeValue(null);
            return null;
        }
        if (this._parsedFormat.numbers.maximumFractionDigits !== undefined) {
            number = round_number(number, this._parsedFormat.numbers.maximumFractionDigits);
        }
        var pipe = this._parsedFormat.pipe;
        if (pipe.map)
            number = pipe.map(number);
        this.writeValue(number);
        return number;
    };
    FormattedLocaleNumbersAccessor.prototype.writeValue = function (value) {
        var localeNumber;
        if (this.inputType === "number")
            this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', value);
        else {
            this.locale = this._translation.getLocale();
            var text = this.formatToString(value);
            localeNumber = this._numberHelper.getFormattedNumber(text, this.locale);
            this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', localeNumber);
            if (this._elementRef.nativeElement.parentElement.lastElementChild !== undefined) {
                this._elementRef.nativeElement.parentElement.lastElementChild.innerHtml = localeNumber;
            }
        }
    };
    FormattedLocaleNumbersAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this.onChange = function (value) {
            var defaultValue = _this.inputType === 'number' ? 0 : null;
            if (value == '') {
                setTimeout(function () { return _this.writeValue(defaultValue); }, 1);
                fn(defaultValue);
            }
            else {
                fn(_this.parseToNumber(value));
            }
        };
    };
    FormattedLocaleNumbersAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    __decorate([
        core_1.Input("type"), 
        __metadata('design:type', String)
    ], FormattedLocaleNumbersAccessor.prototype, "inputType", void 0);
    __decorate([
        core_1.Input('localeNumberFormat'), 
        __metadata('design:type', String)
    ], FormattedLocaleNumbersAccessor.prototype, "format", void 0);
    FormattedLocaleNumbersAccessor = __decorate([
        core_1.Directive({
            selector: 'input[localeNumberFormat]',
            host: {
                '(blur)': 'blurred($event.target.value)'
            },
            providers: [CUSTOM_VALUE_ACCESSOR, LanguageFormatterService_1.LanguageFormatterService]
        }), 
        __metadata('design:paramtypes', [core_1.Renderer, core_1.ElementRef, translation_1.ExtendedTranslateService, LanguageFormatterService_1.LanguageFormatterService])
    ], FormattedLocaleNumbersAccessor);
    return FormattedLocaleNumbersAccessor;
}());
exports.FormattedLocaleNumbersAccessor = FormattedLocaleNumbersAccessor;



},{"../pipes/intPercentPipe":72,"../services/LanguageFormatterService":82,"../services/translation":92,"@angular/common":"@angular/common","@angular/core":"@angular/core","@angular/forms":"@angular/forms"}],53:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var router_1 = require('@angular/router');
var services_1 = require('../../services');
var interfaces_1 = require('../../interfaces');
require('rxjs');
var NavigationChevronDirective = (function () {
    function NavigationChevronDirective(router, activated, config, translate, headerService, navigation) {
        var _this = this;
        this.router = router;
        this.activated = activated;
        this.config = config;
        this.translate = translate;
        this.headerService = headerService;
        this.navigation = navigation;
        this.path = [];
        this.currentIndex = 0;
        this.disabled = false;
        router.events.filter(function (s) { return s instanceof router_1.NavigationEnd; }).subscribe(function (o) {
            var current = activated.snapshot.url[0].path;
            var full = _this.router.url.split('/').slice(3);
            var level = full.indexOf(current);
            if (level == -1) {
                _this.disabled = true;
                _this.title = null;
                return;
            }
            var runPage = null;
            _this.path = [];
            var list = config.currentModel.runPages;
            _this.navigationLevel = level + 1;
            var _loop_1 = function(i) {
                var index = list.findIndex(function (r) { return r.identifier == full[i]; });
                if (index === -1)
                    throw full[i] + " not found in run page hierarchy";
                runPage = list[index];
                _this.path.push(index);
                list = runPage.children || [];
            };
            for (var i = 0; i < _this.navigationLevel; i++) {
                _loop_1(i);
            }
            _this.currentIndex = 0;
            if (full[_this.navigationLevel])
                _this.currentIndex = list.findIndex(function (rp) { return rp.identifier === full[_this.navigationLevel]; });
            else {
                _this.disabled = true;
                _this.title = null;
                return;
            }
            _this.pageList = list;
            _this.reeval();
        });
    }
    NavigationChevronDirective.prototype.reeval = function () {
        if (!this.pageList || !this.pageList.length) {
            this.disabled = true;
            this.title = null;
            return;
        }
        this.disabled = false;
        if (this.mode === interfaces_1.NavigationDirection.forward) {
            if (this.currentIndex == this.pageList.length - 1) {
                this.disabled = true;
                this.title = null;
            }
            else
                this.title = this.translate.instant("CURRENT_MODEL.RUN_PAGES.PAGE_" + this.path.join('_') + "_" + (this.currentIndex + 1));
        }
        else if (this.mode === interfaces_1.NavigationDirection.backward) {
            if (this.currentIndex == 0) {
                this.disabled = true;
                this.title = null;
            }
            else
                this.title = this.translate.instant("CURRENT_MODEL.RUN_PAGES.PAGE_" + this.path.join('_') + "_" + (this.currentIndex - 1));
        }
    };
    Object.defineProperty(NavigationChevronDirective.prototype, "isNext", {
        set: function (val) { if (val !== undefined)
            this.mode = interfaces_1.NavigationDirection.forward; this.reeval(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavigationChevronDirective.prototype, "isPrev", {
        set: function (val) { if (val !== undefined)
            this.mode = interfaces_1.NavigationDirection.backward; this.reeval(); },
        enumerable: true,
        configurable: true
    });
    NavigationChevronDirective.prototype.onClick = function () {
        if (this.disabled)
            return;
        this.navigation.navigate({
            offset: this.mode,
            originalIndex: this.currentIndex,
            pageList: this.pageList,
            relativeTo: this.activated,
            router: this.router,
            level: this.navigationLevel
        });
    };
    __decorate([
        core_1.Input('nav-next'), 
        __metadata('design:type', Object), 
        __metadata('design:paramtypes', [Object])
    ], NavigationChevronDirective.prototype, "isNext", null);
    __decorate([
        core_1.Input('nav-prev'), 
        __metadata('design:type', Object), 
        __metadata('design:paramtypes', [Object])
    ], NavigationChevronDirective.prototype, "isPrev", null);
    __decorate([
        core_1.HostBinding('class.disabled'),
        core_1.Input(), 
        __metadata('design:type', Object)
    ], NavigationChevronDirective.prototype, "disabled", void 0);
    __decorate([
        core_1.HostBinding('attr.title'), 
        __metadata('design:type', String)
    ], NavigationChevronDirective.prototype, "title", void 0);
    __decorate([
        core_1.HostListener('click'), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], NavigationChevronDirective.prototype, "onClick", null);
    NavigationChevronDirective = __decorate([
        core_1.Directive({ selector: '[nav-next],[nav-prev]', host: { '[class.quick-button]': 'true' } }), 
        __metadata('design:paramtypes', [router_1.Router, router_1.ActivatedRoute, services_1.ConfigService, services_1.TranslateService, services_1.SiteHeaderService, services_1.NavigationService])
    ], NavigationChevronDirective);
    return NavigationChevronDirective;
}());
exports.NavigationChevronDirective = NavigationChevronDirective;



},{"../../interfaces":"@toolkit/interfaces","../../services":"@toolkit/services","@angular/core":"@angular/core","@angular/router":"@angular/router","rxjs":"rxjs"}],54:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var forms_1 = require('@angular/forms');
var common_1 = require('@angular/common');
var intPercentPipe_1 = require('../pipes/intPercentPipe');
var CUSTOM_VALUE_ACCESSOR = new core_1.Provider(forms_1.NG_VALUE_ACCESSOR, { useExisting: core_1.forwardRef(function () { return FormattedNumbersAccessor; }), multi: true });
var _NUMBER_FORMAT_REGEXP = /^(\d+)?\.((\d+)(\-(\d+))?)?$/;
var _NUMBER_MATCH_REGEXP = /-?.?\d+(\.\d+)?/;
function precision(a) {
    if (!isFinite(a))
        return 0;
    var e = 1, p = 0;
    while (Math.round(a * e) / e !== a) {
        e *= 10;
        p++;
    }
    return p;
}
function round_number(num, decimals) {
    return Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals);
}
var FormattedNumbersAccessor = (function () {
    function FormattedNumbersAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    FormattedNumbersAccessor.prototype.blurred = function (value) {
        this.onChange(value);
        this.onTouched();
    };
    FormattedNumbersAccessor.prototype.parseFormat = function () {
        if (!this.format)
            throw "format string not set";
        var split = this.format.split(':');
        var getPipe = function (input) {
            if (input === 'number')
                return { instance: new common_1.DecimalPipe() };
            if (input === 'percent')
                return { instance: new common_1.PercentPipe(), map: function (x) { return parseFloat((x / 100).toFixed(precision(x) + 2)); } };
            if (input === 'intPercent')
                return { instance: new intPercentPipe_1.IntPercentPipe() };
            throw "unknown formatter pipe: " + input;
        };
        var digits = split[1];
        var minInt = 1, minFraction = 0, maxFraction = 3;
        if (!!digits) {
            var parts = _NUMBER_FORMAT_REGEXP.exec(digits);
            if (!(parts)) {
                throw digits + " is not a valid digit info for number pipes";
            }
            if (!!parts[1]) {
                minInt = parseInt(parts[1]);
            }
            if (!!parts[3]) {
                minFraction = parseInt(parts[3]);
            }
            if (!!parts[5]) {
                maxFraction = parseInt(parts[5]);
            }
        }
        this._parsedFormat = {
            pipe: getPipe(split[0]), numbers: {
                minimumIntegerDigits: minInt,
                minimumFractionDigits: minFraction,
                maximumFractionDigits: maxFraction,
            }, raw: digits
        };
    };
    FormattedNumbersAccessor.prototype.formatToString = function (value) {
        if (!this._parsedFormat)
            this.parseFormat();
        var pipe = this._parsedFormat.pipe;
        return pipe.instance.transform(value, this._parsedFormat.raw);
    };
    FormattedNumbersAccessor.prototype.parseToNumber = function (value) {
        if (!this._parsedFormat)
            this.parseFormat();
        value = value.replace(/,| /g, "");
        var match = _NUMBER_MATCH_REGEXP.exec(value);
        if (!match) {
            this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', "");
            return undefined;
        }
        var number = parseFloat(match[0]);
        if (isNaN(number)) {
            this.writeValue(null);
            return null;
        }
        if (this._parsedFormat.numbers.maximumFractionDigits !== undefined) {
            number = round_number(number, this._parsedFormat.numbers.maximumFractionDigits);
        }
        var pipe = this._parsedFormat.pipe;
        if (pipe.map)
            number = pipe.map(number);
        this.writeValue(number);
        return number;
    };
    FormattedNumbersAccessor.prototype.writeValue = function (value) {
        if (this.inputType === "number")
            this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', value);
        else {
            var text = this.formatToString(value);
            this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', text);
        }
    };
    FormattedNumbersAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this.onChange = function (value) {
            var defaultValue = _this.inputType === 'number' ? 0 : null;
            if (value == '') {
                setTimeout(function () { return _this.writeValue(defaultValue); }, 1);
                fn(defaultValue);
            }
            else {
                fn(_this.parseToNumber(value));
            }
        };
    };
    FormattedNumbersAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    __decorate([
        core_1.Input("type"), 
        __metadata('design:type', String)
    ], FormattedNumbersAccessor.prototype, "inputType", void 0);
    __decorate([
        core_1.Input('numberFormat'), 
        __metadata('design:type', String)
    ], FormattedNumbersAccessor.prototype, "format", void 0);
    FormattedNumbersAccessor = __decorate([
        core_1.Directive({
            selector: 'input[numberFormat]',
            host: { '(blur)': 'blurred($event.target.value)' },
            providers: [CUSTOM_VALUE_ACCESSOR]
        }), 
        __metadata('design:paramtypes', [core_1.Renderer, core_1.ElementRef])
    ], FormattedNumbersAccessor);
    return FormattedNumbersAccessor;
}());
exports.FormattedNumbersAccessor = FormattedNumbersAccessor;



},{"../pipes/intPercentPipe":72,"@angular/common":"@angular/common","@angular/core":"@angular/core","@angular/forms":"@angular/forms"}],55:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var services_1 = require('../../services');
var webapis_1 = require('../backend/webapis');
function has(x, test) {
    return x && test(x);
}
var PdfLinkDirective = (function () {
    function PdfLinkDirective(window, translate) {
        this.window = window;
        this.translate = translate;
    }
    Object.defineProperty(PdfLinkDirective.prototype, "getTooltip", {
        get: function () {
            return this.translate.instant('RUN.DOWNLOAD_PDF');
        },
        enumerable: true,
        configurable: true
    });
    PdfLinkDirective.prototype.onClick = function (event) {
        var _this = this;
        event.preventDefault();
        if (this.beforeGenerate) {
            var ret = this.beforeGenerate();
            if (ret === false || ret === null) {
            }
            else if (ret === true || ret === undefined) {
                this.goToPdfUrl(this.parameter);
            }
            else if (has(ret, function (c) { return c.then; })) {
                ret.then(function (result) {
                    if (result === false || result === null) {
                    }
                    else if (result === true || result === undefined) {
                        _this.goToPdfUrl(_this.parameter);
                    }
                    else if (result) {
                        _this.goToPdfUrl(result);
                    }
                });
            }
            else if (ret) {
                this.goToPdfUrl(ret);
            }
        }
        else {
            this.goToPdfUrl(this.parameter);
        }
    };
    PdfLinkDirective.prototype.encode = function (obj) {
        return encodeURIComponent(JSON.stringify(obj));
    };
    PdfLinkDirective.prototype.goToPdfUrl = function (parameter) {
        parameter = parameter && this.encode(parameter);
        var language = this.translate.currentLang;
        this.window.nativeElement.open(webapis_1.Pdf.PdfProxy.downloadReport_url(this.runId, this.pdfName, language, parameter).url);
    };
    __decorate([
        core_1.Input('pdf-link'), 
        __metadata('design:type', String)
    ], PdfLinkDirective.prototype, "pdfName", void 0);
    __decorate([
        core_1.Input('runId'), 
        __metadata('design:type', Number)
    ], PdfLinkDirective.prototype, "runId", void 0);
    __decorate([
        core_1.Input('parameter'), 
        __metadata('design:type', Object)
    ], PdfLinkDirective.prototype, "parameter", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Function)
    ], PdfLinkDirective.prototype, "beforeGenerate", void 0);
    PdfLinkDirective = __decorate([
        core_1.Directive({
            selector: '[pdf-link]',
            host: { '[class.pdf-button]': 'true', '[title]': 'getTooltip', '(click)': 'onClick($event)' }
        }), 
        __metadata('design:paramtypes', [services_1.WindowRef, services_1.TranslateService])
    ], PdfLinkDirective);
    return PdfLinkDirective;
}());
exports.PdfLinkDirective = PdfLinkDirective;



},{"../../services":"@toolkit/services","../backend/webapis":17,"@angular/core":"@angular/core"}],56:[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = require('@angular/core');
var slider_1 = require('./slider');
var clickInput_1 = require('./clickInput');
exports.READONLY_PROVIDER = new core_1.OpaqueToken("readonlyprovider");
var ReadOnlyInputsDirective = (function () {
    function ReadOnlyInputsDirective(provider) {
        if (provider && provider.isReadonly != undefined) {
            this.provider = provider;
        }
    }
    __decorate([
        core_1.Input('always-enabled'), 
        __metadata('design:type', Boolean)
    ], ReadOnlyInputsDirective.prototype, "alwaysEnabled", void 0);
    __decorate([
        core_1.Input('disabled'), 
        __metadata('design:type', Boolean)
    ], ReadOnlyInputsDirective.prototype, "alwaysDisabled", void 0);
    ReadOnlyInputsDirective = __decorate([
        core_1.Directive({ selector: 'input,textarea,select', host: { '[disabled]': 'provider?.isReadonly && !alwaysEnabled || alwaysDisabled' } }),
        __param(0, core_1.Optional()),
        __param(0, core_1.Inject(exports.READONLY_PROVIDER)), 
        __metadata('design:paramtypes', [Object])
    ], ReadOnlyInputsDirective);
    return ReadOnlyInputsDirective;
}());
exports.ReadOnlyInputsDirective = ReadOnlyInputsDirective;
var ReadOnlyElementsDirective = (function (_super) {
    __extends(ReadOnlyElementsDirective, _super);
    function ReadOnlyElementsDirective(provider, element) {
        var _this = this;
        _super.call(this, provider);
        element.nativeElement.addEventListener('click', function (event) {
            if (_this.provider && _this.provider.isReadonly && !_this.alwaysEnabled || _this.alwaysDisabled || _this.alwaysDisabled2)
                event.stopImmediatePropagation();
        }, true);
    }
    __decorate([
        core_1.Input('class.disabled'), 
        __metadata('design:type', Boolean)
    ], ReadOnlyElementsDirective.prototype, "alwaysDisabled2", void 0);
    ReadOnlyElementsDirective = __decorate([
        core_1.Directive({ selector: '.quick-button,button', host: { '[class.disabled]': '(provider?.isReadonly && !alwaysEnabled) || alwaysDisabled||alwaysDisabled2', } }),
        __param(0, core_1.Optional()),
        __param(0, core_1.Inject(exports.READONLY_PROVIDER)), 
        __metadata('design:paramtypes', [Object, core_1.ElementRef])
    ], ReadOnlyElementsDirective);
    return ReadOnlyElementsDirective;
}(ReadOnlyInputsDirective));
exports.ReadOnlyElementsDirective = ReadOnlyElementsDirective;
var ReadOnlyCustomComponentsDirective = (function (_super) {
    __extends(ReadOnlyCustomComponentsDirective, _super);
    function ReadOnlyCustomComponentsDirective(provider, component) {
        _super.call(this, provider);
        this.component = component;
    }
    ReadOnlyCustomComponentsDirective.prototype.ngDoCheck = function () {
        this.component.disabled = this.provider && this.provider.isReadonly && !this.alwaysEnabled || this.alwaysDisabled;
    };
    ReadOnlyCustomComponentsDirective = __decorate([
        __param(0, core_1.Optional()),
        __param(0, core_1.Inject(exports.READONLY_PROVIDER)), 
        __metadata('design:paramtypes', [Object, Object])
    ], ReadOnlyCustomComponentsDirective);
    return ReadOnlyCustomComponentsDirective;
}(ReadOnlyInputsDirective));
exports.ReadOnlyCustomComponentsDirective = ReadOnlyCustomComponentsDirective;
var ReadOnlySliderDirective = (function (_super) {
    __extends(ReadOnlySliderDirective, _super);
    function ReadOnlySliderDirective(provider, component) {
        _super.call(this, provider, component);
    }
    ReadOnlySliderDirective = __decorate([
        core_1.Directive({ selector: 'slider' }),
        __param(0, core_1.Optional()),
        __param(0, core_1.Inject(exports.READONLY_PROVIDER)), 
        __metadata('design:paramtypes', [Object, slider_1.SliderComponent])
    ], ReadOnlySliderDirective);
    return ReadOnlySliderDirective;
}(ReadOnlyCustomComponentsDirective));
exports.ReadOnlySliderDirective = ReadOnlySliderDirective;
var ReadOnlyClickInputDirective = (function (_super) {
    __extends(ReadOnlyClickInputDirective, _super);
    function ReadOnlyClickInputDirective(provider, component) {
        _super.call(this, provider, component);
    }
    ReadOnlyClickInputDirective = __decorate([
        core_1.Directive({ selector: 'click-input' }),
        __param(0, core_1.Optional()),
        __param(0, core_1.Inject(exports.READONLY_PROVIDER)), 
        __metadata('design:paramtypes', [Object, clickInput_1.ClickInputDirective])
    ], ReadOnlyClickInputDirective);
    return ReadOnlyClickInputDirective;
}(ReadOnlyCustomComponentsDirective));
exports.ReadOnlyClickInputDirective = ReadOnlyClickInputDirective;
exports.READONLY_DIRECTIVES = [ReadOnlyInputsDirective, ReadOnlyElementsDirective, ReadOnlySliderDirective, ReadOnlyClickInputDirective];



},{"./clickInput":48,"./slider":58,"@angular/core":"@angular/core"}],57:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = require('@angular/core');
var platform_browser_1 = require('@angular/platform-browser');
var ScrollDirective = (function () {
    function ScrollDirective(document) {
        this.document = document;
    }
    ScrollDirective.prototype.handleClick = function () {
        var element = this.document.getElementById(this.target);
        var action = function (target) { return target.scrollIntoViewIfNeeded ? target.scrollIntoViewIfNeeded() : target.scrollIntoView(); };
        if (element) {
            if (!this.delay)
                action(element);
            else {
                var ms = parseInt(this.delay);
                setTimeout(function () { return action(element); }, ms);
            }
        }
    };
    __decorate([
        core_1.Input('scrollTo'), 
        __metadata('design:type', String)
    ], ScrollDirective.prototype, "target", void 0);
    __decorate([
        core_1.Input('delay'), 
        __metadata('design:type', String)
    ], ScrollDirective.prototype, "delay", void 0);
    ScrollDirective = __decorate([
        core_1.Directive({
            selector: '[scrollTo]', host: { '(click)': 'handleClick()' }
        }),
        __param(0, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [Document])
    ], ScrollDirective);
    return ScrollDirective;
}());
exports.ScrollDirective = ScrollDirective;



},{"@angular/core":"@angular/core","@angular/platform-browser":"@angular/platform-browser"}],58:[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var forms_1 = require('@angular/forms');
var platform_browser_1 = require('@angular/platform-browser');
var Rx = require('rxjs');
var CUSTOM_VALUE_ACCESSOR = new core_1.Provider(forms_1.NG_VALUE_ACCESSOR, {
    useExisting: core_1.forwardRef(function () { return SliderAccessor; }), multi: true
});
var SliderComponent = (function () {
    function SliderComponent(sanitizer) {
        var _this = this;
        this.sanitizer = sanitizer;
        this.disabled = false;
        this.relativeValue = 0;
        this._sampler = new Rx.Subject();
        this._held = false;
        this._lastKnownWidth = 0;
        this._stops = [];
        this._max = 1;
        this._step = 1;
        this._min = 1;
        this.valueChanged = new core_1.EventEmitter();
        this._sampler.sampleTime(1000).subscribe(function () { return _this.calculateValue(false); });
    }
    SliderComponent.prototype.hold = function (event) {
        if (this.disabled)
            return;
        if (event.button === 0) {
            this._held = true;
            event.preventDefault();
        }
    };
    SliderComponent.prototype.ngDoCheck = function () {
        if (this.$$container) {
            var prev = this._lastKnownWidth;
            var now = this._lastKnownWidth = this.getSizePixel();
            if (now !== prev && now > 0) {
                this.calculateView();
            }
        }
    };
    SliderComponent.prototype.release = function () {
        if (this.disabled)
            return;
        var wasHeld = this._held;
        this._held = false;
        if (wasHeld)
            this.calculateValue();
    };
    SliderComponent.prototype.move = function (event) {
        if (this.disabled)
            return;
        if (this._held) {
            this.relativeValue = this.mouseEventToRelative(event);
            this.$$viewPosition = this.sanitizer.bypassSecurityTrustStyle("calc(" + this.relativeValue + "px - 50%)");
            this._sampler.next(this.relativeValue);
        }
    };
    SliderComponent.prototype.mouseEventToRelative = function (event) {
        return Math.max(Math.min(this.getEventPixel(event) - this.getGlobalOffsetPixel(this.$$container.nativeElement), this.getSizePixel()), 0);
    };
    SliderComponent.prototype.jump = function (event) {
        if (this.disabled)
            return;
        if (event.button === 0 && !this._held) {
            this.relativeValue = this.mouseEventToRelative(event);
            this.$$viewPosition = this.sanitizer.bypassSecurityTrustStyle("calc(" + this.relativeValue + "px - 50%)");
            this._held = true;
            event.preventDefault();
        }
    };
    SliderComponent.prototype.calculateValue = function (snap) {
        if (snap === void 0) { snap = true; }
        var percent = this.relativeValue / this.getSizePixel();
        var relativeValueReal = percent * (this._max - this._min);
        var stepReal = relativeValueReal / (this._step || 1);
        var stepExact = Math.round(stepReal);
        this._value = this._min + this._step * stepExact;
        if (snap) {
            this.relativeValue = stepExact * this.getSizePixel() / ((this._max - this._min) / this._step || 1);
            this.$$viewPosition = this.sanitizer.bypassSecurityTrustStyle("calc(" + this.relativeValue + "px - 50%)");
        }
        this.valueChanged.emit(this._value);
    };
    SliderComponent.prototype.calculateView = function () {
        var offset = Math.max(Math.min(this.value, this._max), this._min) - this._min;
        var stepReal = offset / (this._step || 1);
        var stepExact = Math.round(stepReal);
        this.relativeValue = stepExact * this.getSizePixel() / ((this._max - this._min) / this._step || 1);
        this.$$viewPosition = this.sanitizer.bypassSecurityTrustStyle("calc(" + this.relativeValue + "px - 50%)");
        this.calculateStops();
    };
    SliderComponent.prototype.calculateStops = function () {
        var _this = this;
        this.stops.forEach(function (x) {
            var offset = Math.max(Math.min(x.value, _this._max), _this._min) - _this._min;
            var stepReal = offset / (_this._step || 1);
            x.relativeValue = stepReal * _this.getSizePixel() / ((_this._max - _this._min) / _this._step || 1);
        });
    };
    Object.defineProperty(SliderComponent.prototype, "stops", {
        get: function () { return this._stops; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "stopValues", {
        get: function () { return this._stops.map(function (s) { return s.value; }); },
        set: function (v) {
            if (v) {
                this._stops = v.map(function (x) {
                    return { value: x, relativeValue: 0 };
                });
                this.calculateStops();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (val) {
            this._value = val;
            this.calculateView();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "max", {
        get: function () {
            return this._max;
        },
        set: function (v) {
            if (typeof v === 'string') {
                this._max = parseFloat(v);
            }
            else
                this._max = v != null ? v : 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "step", {
        get: function () {
            return this._step;
        },
        set: function (v) {
            if (typeof v === 'string') {
                this._step = parseFloat(v);
            }
            else
                this._step = v != null ? v : 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "min", {
        get: function () {
            return this._min;
        },
        set: function (v) {
            if (typeof v === 'string') {
                this._min = parseFloat(v);
            }
            else
                this._min = v != null ? v : 0;
        },
        enumerable: true,
        configurable: true
    });
    SliderComponent.prototype.getGlobalOffsetPixel = function (el) {
        var offset = el.offsetLeft;
        if (el.offsetParent)
            offset += this.getGlobalOffsetPixel(el.offsetParent);
        return offset;
    };
    SliderComponent.prototype.getSizePixel = function () {
        return this.$$container.nativeElement.offsetWidth;
    };
    SliderComponent.prototype.getEventPixel = function (event) { return event.pageX; };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Boolean)
    ], SliderComponent.prototype, "disabled", void 0);
    __decorate([
        core_1.ViewChild('container', { read: core_1.ElementRef }), 
        __metadata('design:type', core_1.ElementRef)
    ], SliderComponent.prototype, "$$container", void 0);
    __decorate([
        core_1.ViewChild('handle', { read: core_1.ElementRef }), 
        __metadata('design:type', core_1.ElementRef)
    ], SliderComponent.prototype, "$$handle", void 0);
    __decorate([
        core_1.Input('stops'), 
        __metadata('design:type', Object)
    ], SliderComponent.prototype, "stopValues", null);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], SliderComponent.prototype, "value", null);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], SliderComponent.prototype, "max", null);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], SliderComponent.prototype, "step", null);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], SliderComponent.prototype, "min", null);
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], SliderComponent.prototype, "valueChanged", void 0);
    SliderComponent = __decorate([
        core_1.Component({
            selector: 'slider:not([vertical])', template: "\n<div class=\"slider-container\" #container >\n<div class=\"slider-bar\" #bar  (mousedown)=\"jump($event)\">\n    <div class=\"slider-overlay\" (mousedown)=\"jump($event)\"  [style.width.px]=\"relativeValue\"> </div>\n    <span *ngFor=\"let stop of stops\" class=\"slider-stop\" [style.left.px]=\"stop.relativeValue\"></span>\n</div>\n\n\n<div class=\"slider-handle\" *ngIf=\"!disabled\" [style.left]=\"$$viewPosition\" (document:mouseup)=\"release()\" (mousedown)=\"hold($event)\" (document:mousemove)=\"move($event)\" #handle>\n<ng-content></ng-content></div></div>", host: { '[attr.disabled]': 'disabled?"disabled":null' }
        }), 
        __metadata('design:paramtypes', [platform_browser_1.DomSanitizationService])
    ], SliderComponent);
    return SliderComponent;
}());
exports.SliderComponent = SliderComponent;
var VerticalSliderComponent = (function (_super) {
    __extends(VerticalSliderComponent, _super);
    function VerticalSliderComponent(sanitizer) {
        _super.call(this, sanitizer);
    }
    VerticalSliderComponent.prototype.getGlobalOffsetPixel = function (el) {
        var offset = el.offsetTop;
        if (el.offsetParent)
            offset += this.getGlobalOffsetPixel(el.offsetParent);
        return offset;
    };
    VerticalSliderComponent.prototype.getSizePixel = function () {
        return this.$$container.nativeElement.offsetHeight;
    };
    VerticalSliderComponent.prototype.getEventPixel = function (event) { return event.pageY; };
    VerticalSliderComponent.prototype.mouseEventToRelative = function (event) {
        return this.getSizePixel() - _super.prototype.mouseEventToRelative.call(this, event);
    };
    VerticalSliderComponent = __decorate([
        core_1.Component({
            selector: 'slider[vertical]', template: "\n<div class=\"slider-container\" #container >\n<div class=\"slider-bar\" #bar  (mousedown)=\"jump($event)\">\n    <div class=\"slider-overlay\" (mousedown)=\"jump($event)\"  [style.height.px]=\"relativeValue\"> </div>\n    <span *ngFor=\"let stop of stops\" class=\"slider-stop\" [style.top.px]=\"stop.relativeValue\"></span>\n</div>\n\n\n<div class=\"slider-handle\" *ngIf=\"!disabled\" [style.top.px]=\"relativeValue\" (document:mouseup)=\"release()\" (mousedown)=\"hold($event)\" (document:mousemove)=\"move($event)\" #handle>\n<div class=\"projection\"><ng-content></ng-content></div></div></div>", host: { '[attr.disabled]': 'disabled?"disabled":null' }, providers: [{
                    provide: SliderComponent,
                    useExisting: core_1.forwardRef(function () { return VerticalSliderComponent; })
                }]
        }), 
        __metadata('design:paramtypes', [platform_browser_1.DomSanitizationService])
    ], VerticalSliderComponent);
    return VerticalSliderComponent;
}(SliderComponent));
exports.VerticalSliderComponent = VerticalSliderComponent;
var SliderAccessor = (function () {
    function SliderAccessor(_slider) {
        this._slider = _slider;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    SliderAccessor.prototype.changing = function () {
        this.onChange(this._slider.value);
        this.onTouched();
    };
    SliderAccessor.prototype.writeValue = function (value) {
        this._slider.value = value;
    };
    SliderAccessor.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    SliderAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    SliderAccessor = __decorate([
        core_1.Directive({
            selector: 'slider[ngModel],wtw-slider[ngModel]', host: { '(mouseup)': 'onTouched()', '(valueChanged)': 'changing()' },
            providers: [CUSTOM_VALUE_ACCESSOR],
        }), 
        __metadata('design:paramtypes', [SliderComponent])
    ], SliderAccessor);
    return SliderAccessor;
}());
exports.SliderAccessor = SliderAccessor;
exports.SLIDER = [SliderComponent, SliderAccessor, VerticalSliderComponent];



},{"@angular/core":"@angular/core","@angular/forms":"@angular/forms","@angular/platform-browser":"@angular/platform-browser","rxjs":"rxjs"}],59:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = require('@angular/core');
var angular2_highcharts_1 = require('angular2-highcharts');
var Tab = (function () {
    function Tab() {
        this._active = false;
        this.activating = new core_1.EventEmitter(true);
        this.appearing = new core_1.EventEmitter(true);
    }
    Object.defineProperty(Tab.prototype, "invisible", {
        get: function () { return this._invisible; },
        set: function (v) {
            var old = this._invisible;
            this._invisible = v;
            if (!!old && !v)
                this.appearing.emit(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tab.prototype, "active", {
        get: function () { return this._active; },
        set: function (value) {
            this._active = value;
            if (value)
                this.activating.emit(this);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input('tabTitle'), 
        __metadata('design:type', String)
    ], Tab.prototype, "title", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Boolean)
    ], Tab.prototype, "disabled", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Boolean), 
        __metadata('design:paramtypes', [Boolean])
    ], Tab.prototype, "invisible", null);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Boolean), 
        __metadata('design:paramtypes', [Boolean])
    ], Tab.prototype, "active", null);
    __decorate([
        core_1.ContentChildren(angular2_highcharts_1.ChartComponent), 
        __metadata('design:type', core_1.QueryList)
    ], Tab.prototype, "charts", void 0);
    Tab = __decorate([
        core_1.Component({
            selector: 'tab',
            template: "<ng-content *ngIf=\"!invisible\"></ng-content>",
            host: { '[hidden]': '!active' }
        }), 
        __metadata('design:paramtypes', [])
    ], Tab);
    return Tab;
}());
exports.Tab = Tab;
var TabChartResizer = (function () {
    function TabChartResizer(tab, chartComponent) {
        if (tab)
            tab.activating.subscribe(function (r) { return chartComponent.chart && chartComponent.chart.reflow(); });
    }
    TabChartResizer = __decorate([
        core_1.Directive({ selector: 'chart' }),
        __param(0, core_1.Optional()), 
        __metadata('design:paramtypes', [Tab, angular2_highcharts_1.ChartComponent])
    ], TabChartResizer);
    return TabChartResizer;
}());
exports.TabChartResizer = TabChartResizer;



},{"@angular/core":"@angular/core","angular2-highcharts":"angular2-highcharts"}],60:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var tab_1 = require('./tab');
var Rx = require('rxjs');
var TabsControl = (function () {
    function TabsControl() {
        this.tabSelection = new core_1.EventEmitter();
        this.initialised = false;
    }
    TabsControl.prototype.ngAfterContentInit = function () {
        var _this = this;
        var activeTabs = this.tabs.filter(function (tab) { return tab.active; });
        var first = this.tabs.filter(function (tab) { return !tab.invisible && !tab.disabled; })[0];
        if (activeTabs.length === 0 && !!first) {
            this.selectTab(first);
        }
        this.initialised = true;
        var array = this.tabs.toArray();
        Rx.Observable.from(array).flatMap(function (o) { return o.appearing; }).subscribe(function (tab) {
            if (!_this._activeTab || array.indexOf(tab) < array.indexOf(_this._activeTab)) {
                _this.selectTab(tab);
            }
        });
    };
    TabsControl.prototype.selectTab = function (tab) {
        this.tabs.toArray().forEach(function (tab) { return tab.active = false; });
        tab.active = true;
        this._activeTab = tab;
        this.tabSelection.emit("" + tab.title);
    };
    TabsControl.prototype.ngDoCheck = function () {
        var _this = this;
        if (!this.initialised)
            return;
        if (this._activeTab && (this._activeTab.invisible || this._activeTab.disabled)) {
            var all = this.tabs.map(function (item, index) { return ({ item: item, index: index }); });
            var currentIndex_1 = all.find(function (x) { return x.item === _this._activeTab; }).index;
            var next = all.find(function (o) { return !o.item.disabled && !o.item.invisible && o.index > currentIndex_1; }) ||
                all.find(function (o) { return !o.item.disabled && !o.item.invisible; });
            if (next)
                this.selectTab(next.item);
            else
                this.tabs.toArray().forEach(function (tab) { return tab.active = false; });
        }
        else if (!this._activeTab) {
            var first = this.tabs.filter(function (tab) { return !tab.invisible && !tab.disabled; })[0];
            if (!!first) {
                this.selectTab(first);
            }
        }
    };
    __decorate([
        core_1.ContentChildren(tab_1.Tab), 
        __metadata('design:type', core_1.QueryList)
    ], TabsControl.prototype, "tabs", void 0);
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], TabsControl.prototype, "tabSelection", void 0);
    TabsControl = __decorate([
        core_1.Component({
            selector: 'tabs',
            template: "\n<div class=\"page-tabs-header\">\n<div class=\"tabs-menu\">\n    <ng-content select=\"header-content\"></ng-content>\n    <ul>\n      <template ngFor let-tab [ngForOf]=\"tabs\">\n      <li (click)=\"selectTab(tab)\" [class.current]=\"tab.active\" [class.disabled]=\"tab.disabled\" *ngIf=\"!tab.invisible\">\n        <a>{{tab.title}}</a>\n      </li>\n      </template>\n    </ul>\n    <ng-content select=\"tabs-header\"></ng-content> \n</div>\n <div class=\"clear\"></div>\n</div>\n<ng-content></ng-content>\n\n  "
        }), 
        __metadata('design:paramtypes', [])
    ], TabsControl);
    return TabsControl;
}());
exports.TabsControl = TabsControl;



},{"./tab":59,"@angular/core":"@angular/core","rxjs":"rxjs"}],61:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var INTERACTIVE_TAGS = ['select', 'input', 'button', 'textarea'];
var Toggle = (function () {
    function Toggle(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.toggle = false;
    }
    Toggle.prototype.clicked = function (event) {
        if (event.target !== event.currentTarget) {
            if (!this.checkEventTarget(event.target, event.currentTarget))
                return;
        }
        var el = this.toogleFor || this._elementRef.nativeElement;
        this.toggle = !el.classList.contains('open');
        this._renderer.setElementClass(el, 'open', this.toggle);
        event.stopPropagation();
    };
    Toggle.prototype.checkEventTarget = function (current, final) {
        if (INTERACTIVE_TAGS.indexOf(current.tagName.toLowerCase()) > -1)
            return false;
        if (final === current)
            return true;
        if (!current)
            return false;
        if (current.style.backgroundColor)
            return false;
        else
            return this.checkEventTarget(current.parentElement, final);
    };
    __decorate([
        core_1.Input('toggleFor'), 
        __metadata('design:type', core_1.ElementRef)
    ], Toggle.prototype, "toogleFor", void 0);
    __decorate([
        core_1.Input('toggleSelf'), 
        __metadata('design:type', Object)
    ], Toggle.prototype, "toggleSelf", void 0);
    __decorate([
        core_1.HostListener('click', ['$event']), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', [MouseEvent]), 
        __metadata('design:returntype', void 0)
    ], Toggle.prototype, "clicked", null);
    Toggle = __decorate([
        core_1.Directive({
            selector: '[toggleFor],[toggleSelf]'
        }), 
        __metadata('design:paramtypes', [core_1.Renderer, core_1.ElementRef])
    ], Toggle);
    return Toggle;
}());
exports.Toggle = Toggle;



},{"@angular/core":"@angular/core"}],62:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var clickOutside_1 = require('./clickOutside');
var services_1 = require('../../services');
var defaultSettings = { ratio: 1.6, topSpacing: 2, bottomSpacing: 5 };
var rx_1 = require('rxjs');
var TooltipDirective = (function () {
    function TooltipDirective(container, resolver, host) {
        var _this = this;
        this.container = container;
        this.host = host;
        resolver.resolveComponent(TooltipContainer).then(function (o) { return _this.factory = o; });
    }
    TooltipDirective.prototype.show = function (stick) {
        var _this = this;
        if (stick === void 0) { stick = false; }
        if (!this.content || !this.factory)
            return;
        if (stick)
            this._stuck = true;
        if (stick) {
            TooltipDirective.SomebodyClicked.filter(function (ref) { return ref !== _this; }).take(1).subscribe(function () {
                _this.hide(true);
            });
        }
        if (this._visible)
            return;
        this._reference = this.container.createComponent(this.factory);
        var settings = Object.assign({}, defaultSettings, this.settings || {});
        this._reference.instance.show(this.content, this.host, settings);
        this._visible = true;
        TooltipDirective.SomebodyClicked.next(this);
    };
    TooltipDirective.prototype.hide = function (unstick) {
        var _this = this;
        if (unstick === void 0) { unstick = false; }
        if (!this._visible)
            return;
        if (this._stuck && !unstick) {
            setTimeout(function () { _this._stuck = false; _this.hide(); }, 5000);
        }
        else {
            this._reference.destroy();
            this._visible = false;
            this._stuck = false;
        }
    };
    TooltipDirective.SomebodyClicked = new rx_1.Subject();
    __decorate([
        core_1.Input('tooltip'), 
        __metadata('design:type', Object)
    ], TooltipDirective.prototype, "content", void 0);
    __decorate([
        core_1.Input('tooltip-settings'), 
        __metadata('design:type', Object)
    ], TooltipDirective.prototype, "settings", void 0);
    TooltipDirective = __decorate([
        core_1.Directive({ selector: '[tooltip]', host: { '(mouseenter)': 'show()', '(mouseleave)': 'hide()', '(click)': 'show(true)', '(window:scroll)': 'hide(true)', '[style.cursor]': 'pointer' } }), 
        __metadata('design:paramtypes', [core_1.ViewContainerRef, core_1.ComponentResolver, core_1.ElementRef])
    ], TooltipDirective);
    return TooltipDirective;
}());
exports.TooltipDirective = TooltipDirective;
exports.TOOLTIP = [TooltipDirective, clickOutside_1.ClickOutsideDirective];
var TooltipContainer = (function () {
    function TooltipContainer(window) {
        this.window = window;
        this.styleObj = { opacity: 0.01 };
    }
    TooltipContainer.prototype.show = function (content, host, settings) {
        if (typeof content === 'string') {
            this.textContent = content;
            this._reference = null;
        }
        else if (content instanceof core_1.TemplateRef) {
            this.textContent = null;
            this._reference = this.container.createEmbeddedView(content);
        }
        this.settings = settings;
        this.host = host;
    };
    TooltipContainer.prototype.ngOnDestroy = function () {
        if (this._reference && this._reference.destroy)
            this._reference.destroy();
    };
    TooltipContainer.prototype.ngAfterViewInit = function () {
        var _this = this;
        function pxIfNotNull(x) {
            if (x == null)
                return null;
            return x + 'px';
        }
        ;
        if (this.host && this.element) {
            var hostInfo = this.host.nativeElement.getBoundingClientRect();
            var viewPort = { width: this.window.nativeElement.document.documentElement.clientWidth, height: this.window.nativeElement.document.documentElement.clientHeight };
            var tooltipInfo = { width: this.element.nativeElement.offsetWidth, height: this.element.nativeElement.offsetHeight };
            var area = tooltipInfo.height * tooltipInfo.width;
            if (area > 0) {
                var tooltipCalculated = { width: Math.sqrt(area / this.settings.ratio) * this.settings.ratio, height: Math.sqrt(area / this.settings.ratio) };
                var target = { top: hostInfo.top + hostInfo.height + this.settings.topSpacing, left: hostInfo.left, bottom: null };
                if (hostInfo.left > viewPort.width / 2)
                    target.left = hostInfo.left + hostInfo.width - tooltipCalculated.width;
                if (viewPort.height - (tooltipCalculated.height + target.top) <= tooltipCalculated.height / 2) {
                    target.bottom = viewPort.height - hostInfo.top + this.settings.bottomSpacing;
                    target.top = null;
                }
                if (tooltipCalculated.width >= 200) {
                    tooltipCalculated.width = 200;
                }
                this.styleObj = {
                    opacity: 0.01, top: pxIfNotNull(target.top), left: pxIfNotNull(target.left), bottom: pxIfNotNull(target.bottom), width: pxIfNotNull(tooltipCalculated.width),
                    "z-index": 99999
                };
                console.log(this.styleObj);
                setTimeout(function () {
                    _this.styleObj.opacity = 1;
                }, 10);
            }
        }
    };
    TooltipContainer.prototype.getPositionValues = function (el) {
        var offset = { top: el.offsetTop, left: el.offsetLeft, globalHeight: el.clientHeight, globalWidth: el.clientWidth };
        if (el.offsetParent) {
            var parent_1 = this.getPositionValues(el.offsetParent);
            offset.left += parent_1.left;
            offset.top += parent_1.top;
            offset.globalHeight = parent_1.globalHeight;
            offset.globalWidth = parent_1.globalWidth;
        }
        return offset;
    };
    __decorate([
        core_1.ViewChild('anchor', { read: core_1.ViewContainerRef }), 
        __metadata('design:type', core_1.ViewContainerRef)
    ], TooltipContainer.prototype, "container", void 0);
    __decorate([
        core_1.ViewChild('element', { read: core_1.ElementRef }), 
        __metadata('design:type', core_1.ElementRef)
    ], TooltipContainer.prototype, "element", void 0);
    TooltipContainer = __decorate([
        core_1.Component({
            template: "\n<div class=\"tooltip\" #element [ngStyle]=\"styleObj\">\n<span style=\"white-space:pre-line;\">{{textContent}}</span>\n<template #anchor></template>\n</div>", selector: 'tooltip',
        }), 
        __metadata('design:paramtypes', [services_1.WindowRef])
    ], TooltipContainer);
    return TooltipContainer;
}());



},{"../../services":"@toolkit/services","./clickOutside":49,"@angular/core":"@angular/core","rxjs":"rxjs"}],63:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var forms_1 = require('@angular/forms');
var CUSTOM_VALUE_ACCESSOR = new core_1.Provider(forms_1.NG_VALUE_ACCESSOR, { useExisting: core_1.forwardRef(function () { return TrimAccessor; }), multi: true });
var TrimAccessor = (function () {
    function TrimAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    TrimAccessor.prototype.blurred = function (value) {
        var trimmed = value;
        if (value)
            trimmed = value.trim();
        if (value !== trimmed)
            this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', trimmed);
        this.onChange(trimmed);
        this.onTouched();
    };
    TrimAccessor.prototype.writeValue = function (value) {
        if (value)
            value = value.trim();
        else
            value = '';
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', value);
    };
    TrimAccessor.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    TrimAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    TrimAccessor = __decorate([
        core_1.Directive({
            selector: 'input[ngModel][trim], textarea[ngModel][trim]',
            host: { '(blur)': 'blurred($event.target.value)', '(input)': 'onChange($event.target.value)' },
            providers: [CUSTOM_VALUE_ACCESSOR]
        }), 
        __metadata('design:paramtypes', [core_1.Renderer, core_1.ElementRef])
    ], TrimAccessor);
    return TrimAccessor;
}());
exports.TrimAccessor = TrimAccessor;



},{"@angular/core":"@angular/core","@angular/forms":"@angular/forms"}],64:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var forms_1 = require('@angular/forms');
var moment = require('moment/moment');
var GenericValidatorDirective = (function () {
    function GenericValidatorDirective() {
    }
    GenericValidatorDirective.prototype.validate = function (c) {
        return this.method && this.method(c);
    };
    __decorate([
        core_1.Input('validate-using'), 
        __metadata('design:type', Function)
    ], GenericValidatorDirective.prototype, "method", void 0);
    GenericValidatorDirective = __decorate([
        core_1.Directive({
            selector: '[validate-using]',
            providers: [{ provide: forms_1.NG_VALIDATORS, useExisting: GenericValidatorDirective, multi: true }]
        }), 
        __metadata('design:paramtypes', [])
    ], GenericValidatorDirective);
    return GenericValidatorDirective;
}());
exports.GenericValidatorDirective = GenericValidatorDirective;
function getNumber(value) {
    if (typeof value === 'string')
        return parseFloat(value);
    else
        return value;
}
var ConditionalMinMaxValidator = (function () {
    function ConditionalMinMaxValidator() {
    }
    ConditionalMinMaxValidator.prototype.ngOnChanges = function () {
        if (!!this.control)
            this.control.updateValueAndValidity();
    };
    ConditionalMinMaxValidator.prototype.validateMinMax = function (value) {
        if ((this.validationParams.min || this.validationParams.min === 0) && value < this.validationParams.min)
            return { minFail: true };
        if ((this.validationParams.max || this.validationParams.max === 0) && value > this.validationParams.max)
            return { maxFail: true };
        return {};
    };
    ConditionalMinMaxValidator.prototype.validate = function (c) {
        this.control = c;
        var isRequired = this.validationParams.isRequired;
        var hasValue = !!c.value || c.value === 0;
        if (isRequired && !hasValue)
            return { requiredFail: true };
        if (!isRequired && !hasValue)
            return {};
        return this.validateMinMax(c.value);
    };
    __decorate([
        core_1.Input('conditional-min-max'), 
        __metadata('design:type', Object)
    ], ConditionalMinMaxValidator.prototype, "validationParams", void 0);
    ConditionalMinMaxValidator = __decorate([
        core_1.Directive({
            selector: '[conditional-min-max]',
            providers: [{ provide: forms_1.NG_VALIDATORS, useExisting: ConditionalMinMaxValidator, multi: true }]
        }), 
        __metadata('design:paramtypes', [])
    ], ConditionalMinMaxValidator);
    return ConditionalMinMaxValidator;
}());
exports.ConditionalMinMaxValidator = ConditionalMinMaxValidator;
var ConditionalRequiredValidator = (function () {
    function ConditionalRequiredValidator() {
    }
    ConditionalRequiredValidator.prototype.ngOnChanges = function () {
        if (!!this.control)
            this.control.updateValueAndValidity();
    };
    ConditionalRequiredValidator.prototype.validate = function (c) {
        this.control = c;
        if (!this.isRequired || (!!c.value || c.value === 0))
            return {};
        return { requiredFail: true };
    };
    __decorate([
        core_1.Input('conditional-required'), 
        __metadata('design:type', Boolean)
    ], ConditionalRequiredValidator.prototype, "isRequired", void 0);
    ConditionalRequiredValidator = __decorate([
        core_1.Directive({
            selector: '[conditional-required]',
            providers: [{ provide: forms_1.NG_VALIDATORS, useExisting: ConditionalRequiredValidator, multi: true }]
        }), 
        __metadata('design:paramtypes', [])
    ], ConditionalRequiredValidator);
    return ConditionalRequiredValidator;
}());
exports.ConditionalRequiredValidator = ConditionalRequiredValidator;
var MinValidatorDirective = (function () {
    function MinValidatorDirective() {
    }
    MinValidatorDirective.prototype.validate = function (c) {
        if (this.minValue == null && this.exclusiveMinValue == null)
            return {};
        var isExclusive = this.exclusiveMinValue != null;
        var limit = getNumber(isExclusive ? this.exclusiveMinValue : this.minValue);
        var value = getNumber(c.value);
        if (value < limit)
            return {
                'min': { limit: limit, value: value }
            };
        if (value === limit && isExclusive)
            return {
                'minExclusive': { limit: limit, value: value }
            };
        else
            return {};
    };
    __decorate([
        core_1.Input('min'), 
        __metadata('design:type', Object)
    ], MinValidatorDirective.prototype, "minValue", void 0);
    __decorate([
        core_1.Input('minExclusive'), 
        __metadata('design:type', Object)
    ], MinValidatorDirective.prototype, "exclusiveMinValue", void 0);
    MinValidatorDirective = __decorate([
        core_1.Directive({
            selector: '[min]:not([type=date]),[minExclusive]:not([type=date])',
            providers: [{ provide: forms_1.NG_VALIDATORS, useExisting: MinValidatorDirective, multi: true }]
        }), 
        __metadata('design:paramtypes', [])
    ], MinValidatorDirective);
    return MinValidatorDirective;
}());
exports.MinValidatorDirective = MinValidatorDirective;
var MaxValidatorDirective = (function () {
    function MaxValidatorDirective() {
    }
    MaxValidatorDirective.prototype.validate = function (c) {
        if (this.maxValue == null && this.exclusiveMaxValue == null)
            return {};
        var isExclusive = this.exclusiveMaxValue != null;
        var limit = getNumber(isExclusive ? this.exclusiveMaxValue : this.maxValue);
        var value = getNumber(c.value);
        if (value > limit)
            return {
                'max': { limit: limit, value: value }
            };
        if (value === limit && isExclusive)
            return {
                'maxExclusive': { limit: limit, value: value }
            };
        else
            return {};
    };
    __decorate([
        core_1.Input('max'), 
        __metadata('design:type', Object)
    ], MaxValidatorDirective.prototype, "maxValue", void 0);
    __decorate([
        core_1.Input('maxExclusive'), 
        __metadata('design:type', Object)
    ], MaxValidatorDirective.prototype, "exclusiveMaxValue", void 0);
    MaxValidatorDirective = __decorate([
        core_1.Directive({
            selector: '[max]:not([type=date]),[maxExclusive]:not([type=date])',
            providers: [{ provide: forms_1.NG_VALIDATORS, useExisting: MaxValidatorDirective, multi: true }]
        }), 
        __metadata('design:paramtypes', [])
    ], MaxValidatorDirective);
    return MaxValidatorDirective;
}());
exports.MaxValidatorDirective = MaxValidatorDirective;
var MaxDateValidatorDirective = (function () {
    function MaxDateValidatorDirective() {
    }
    MaxDateValidatorDirective.prototype.validate = function (c) {
        if (this.maxValue == null && this.exclusiveMaxValue == null)
            return {};
        var isExclusive = this.exclusiveMaxValue != null;
        var limit = moment.utc(isExclusive ? this.exclusiveMaxValue : this.maxValue);
        var value = moment.utc(c.value);
        if (value.isAfter(limit))
            return {
                'max': { limit: limit, value: value }
            };
        if (value.isSame(limit) && isExclusive)
            return {
                'maxExclusive': { limit: limit, value: value }
            };
        else
            return {};
    };
    __decorate([
        core_1.Input('max'), 
        __metadata('design:type', Object)
    ], MaxDateValidatorDirective.prototype, "maxValue", void 0);
    __decorate([
        core_1.Input('maxExclusive'), 
        __metadata('design:type', Object)
    ], MaxDateValidatorDirective.prototype, "exclusiveMaxValue", void 0);
    MaxDateValidatorDirective = __decorate([
        core_1.Directive({
            selector: '[max][type=date],[maxExclusive][type=date]',
            providers: [{ provide: forms_1.NG_VALIDATORS, useExisting: MaxDateValidatorDirective, multi: true }]
        }), 
        __metadata('design:paramtypes', [])
    ], MaxDateValidatorDirective);
    return MaxDateValidatorDirective;
}());
exports.MaxDateValidatorDirective = MaxDateValidatorDirective;
var MinDateValidatorDirective = (function () {
    function MinDateValidatorDirective() {
    }
    MinDateValidatorDirective.prototype.validate = function (c) {
        if (this.minValue == null && this.exclusiveMinValue == null)
            return {};
        var isExclusive = this.exclusiveMinValue != null;
        var limit = moment.utc(isExclusive ? this.exclusiveMinValue : this.minValue);
        var value = moment.utc(c.value);
        if (value.isBefore(limit))
            return {
                'min': { limit: limit, value: value }
            };
        if (value.isSame(limit) && isExclusive)
            return {
                'minExclusive': { limit: limit, value: value }
            };
        else
            return {};
    };
    __decorate([
        core_1.Input('min'), 
        __metadata('design:type', Object)
    ], MinDateValidatorDirective.prototype, "minValue", void 0);
    __decorate([
        core_1.Input('minExclusive'), 
        __metadata('design:type', Object)
    ], MinDateValidatorDirective.prototype, "exclusiveMinValue", void 0);
    MinDateValidatorDirective = __decorate([
        core_1.Directive({
            selector: '[min][type=date],[minExclusive][type=date]',
            providers: [{ provide: forms_1.NG_VALIDATORS, useExisting: MinDateValidatorDirective, multi: true }]
        }), 
        __metadata('design:paramtypes', [])
    ], MinDateValidatorDirective);
    return MinDateValidatorDirective;
}());
exports.MinDateValidatorDirective = MinDateValidatorDirective;
var NotBlankValidatorDirective = (function () {
    function NotBlankValidatorDirective() {
    }
    NotBlankValidatorDirective.prototype.validate = function (c) {
        if (c.value && typeof c.value === 'string') {
            if (!c.value.trim()) {
                return { 'not-blank': true };
            }
        }
        return {};
    };
    NotBlankValidatorDirective = __decorate([
        core_1.Directive({
            selector: '[not-blank][required]',
            providers: [{ provide: forms_1.NG_VALIDATORS, useExisting: NotBlankValidatorDirective, multi: true }]
        }), 
        __metadata('design:paramtypes', [])
    ], NotBlankValidatorDirective);
    return NotBlankValidatorDirective;
}());
exports.NotBlankValidatorDirective = NotBlankValidatorDirective;
exports.VALIDATORS = [GenericValidatorDirective, MaxValidatorDirective, MinValidatorDirective, NotBlankValidatorDirective, MinDateValidatorDirective, MaxDateValidatorDirective];



},{"@angular/core":"@angular/core","@angular/forms":"@angular/forms","moment/moment":1}],65:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var common_1 = require('@angular/common');
var Translation = require("../services/translation");
var LocaleDatePipe = (function () {
    function LocaleDatePipe(_translation) {
        this._translation = _translation;
        this._date = new common_1.DatePipe();
    }
    LocaleDatePipe.prototype.transform = function (value, opts) {
        var orig = value;
        if (!!value && typeof value === 'string') {
            if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,4})?$/.test(value))
                value += 'Z';
            value = new Date(value);
        }
        try {
            return this._date.transform(value, opts);
        }
        catch (e) {
            throw e;
        }
    };
    LocaleDatePipe = __decorate([
        core_1.Pipe({
            name: 'localeDate'
        }), 
        __metadata('design:paramtypes', [Translation.ExtendedTranslateService])
    ], LocaleDatePipe);
    return LocaleDatePipe;
}());
exports.LocaleDatePipe = LocaleDatePipe;



},{"../services/translation":92,"@angular/common":"@angular/common","@angular/core":"@angular/core"}],66:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var translation_1 = require('../services/translation');
var LocaleIntPercentPipe = (function () {
    function LocaleIntPercentPipe(translation) {
        this.translation = translation;
    }
    LocaleIntPercentPipe.prototype.transform = function (value, pattern) {
        if (value !== 'undefined' || value !== null) {
            this.currentLocale = this.translation.getLocale();
            return new Intl.NumberFormat(this.currentLocale, this.getFractionDigits(pattern)).format(value / 100);
        }
    };
    LocaleIntPercentPipe.prototype.getFractionDigits = function (pattern) {
        if (pattern === undefined)
            return undefined;
        var fractionDigits = pattern.split('-');
        var options = {
            style: 'percent',
            minimumFractionDigits: fractionDigits[0], maximumFractionDigits: fractionDigits[1]
        };
        return options;
    };
    LocaleIntPercentPipe = __decorate([
        core_1.Pipe({
            name: 'localeIntPercent'
        }), 
        __metadata('design:paramtypes', [translation_1.ExtendedTranslateService])
    ], LocaleIntPercentPipe);
    return LocaleIntPercentPipe;
}());
exports.LocaleIntPercentPipe = LocaleIntPercentPipe;



},{"../services/translation":92,"@angular/core":"@angular/core"}],67:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var translation_1 = require('../services/translation');
var LocalePercentPipe = (function () {
    function LocalePercentPipe(translation) {
        this.translation = translation;
    }
    LocalePercentPipe.prototype.transform = function (value, pattern) {
        if (value !== 'undefined' || value !== null) {
            this.currentLocale = this.translation.getLocale();
            return new Intl.NumberFormat(this.currentLocale, this.getFractionDigits(pattern)).format(value);
        }
    };
    LocalePercentPipe.prototype.getFractionDigits = function (pattern) {
        if (pattern === undefined)
            return undefined;
        var fractionDigits = pattern.split('-');
        var options = {
            style: 'percent',
            minimumFractionDigits: fractionDigits[0], maximumFractionDigits: fractionDigits[1]
        };
        return options;
    };
    LocalePercentPipe = __decorate([
        core_1.Pipe({
            name: 'localePercent'
        }), 
        __metadata('design:paramtypes', [translation_1.ExtendedTranslateService])
    ], LocalePercentPipe);
    return LocalePercentPipe;
}());
exports.LocalePercentPipe = LocalePercentPipe;



},{"../services/translation":92,"@angular/core":"@angular/core"}],68:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var translation_1 = require('../services/translation');
var LocaleShortNumberPipe = (function () {
    function LocaleShortNumberPipe(translation) {
        this.translation = translation;
    }
    LocaleShortNumberPipe.prototype.transform = function (num, digits) {
        this.currentLocale = this.translation.getLocale();
        var units = ['K', 'M', 'B', 'T', 'P', 'E', 'Z', 'Y'];
        var decimal;
        if (num < 1000 && num > -1000)
            return num.toString();
        for (var i = units.length - 1; i >= 0; i--) {
            decimal = Math.pow(1000, i + 1);
            if (num <= -decimal || num >= decimal) {
                var currentValue = +(num / decimal).toFixed(digits);
                var localeNumber = new Intl.NumberFormat(this.currentLocale).format(currentValue);
                return localeNumber + units[i];
            }
        }
        return '0';
    };
    LocaleShortNumberPipe = __decorate([
        core_1.Pipe({ name: 'localeShortNumber' }), 
        __metadata('design:paramtypes', [translation_1.ExtendedTranslateService])
    ], LocaleShortNumberPipe);
    return LocaleShortNumberPipe;
}());
exports.LocaleShortNumberPipe = LocaleShortNumberPipe;



},{"../services/translation":92,"@angular/core":"@angular/core"}],69:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var CamelPipe = (function () {
    function CamelPipe() {
    }
    CamelPipe.prototype.transform = function (value) {
        if (!value || typeof value !== 'string')
            return value;
        var lastMatch = undefined;
        return value.replace(/(?:(?:[A-Z]+(?![a-z]))|\b\w)/g, function (letter, index) {
            var ret = (index == 0 || index === lastMatch + 1) ? letter.toLowerCase() : letter.toUpperCase();
            lastMatch = index;
            return ret;
        }).replace(/\s+/g, '');
    };
    CamelPipe = __decorate([
        core_1.Pipe({ name: 'camelcase' }), 
        __metadata('design:paramtypes', [])
    ], CamelPipe);
    return CamelPipe;
}());
exports.CamelPipe = CamelPipe;
var PascalPipe = (function () {
    function PascalPipe() {
    }
    PascalPipe.prototype.transform = function (value) {
        if (!value || typeof value !== 'string')
            return value;
        return value.replace(/(\w)(\w*)/g, function (g0, g1, g2) { return g1.toUpperCase() + g2.toLowerCase(); });
    };
    PascalPipe = __decorate([
        core_1.Pipe({ name: 'pascalcase' }), 
        __metadata('design:paramtypes', [])
    ], PascalPipe);
    return PascalPipe;
}());
exports.PascalPipe = PascalPipe;



},{"@angular/core":"@angular/core"}],70:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var KeysPipe = (function () {
    function KeysPipe() {
    }
    KeysPipe.prototype.transform = function (value, args) {
        var keys = [];
        for (var enumMember in value) {
            var key = parseInt(enumMember, 10);
            var isValueProperty = key >= 0;
            if (isValueProperty) {
                keys.push({ key: key, value: value[enumMember] });
            }
        }
        return keys;
    };
    KeysPipe = __decorate([
        core_1.Pipe({ name: 'enumKeys' }), 
        __metadata('design:paramtypes', [])
    ], KeysPipe);
    return KeysPipe;
}());
exports.KeysPipe = KeysPipe;



},{"@angular/core":"@angular/core"}],71:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var common_1 = require('@angular/common');
var FormatDatePipe = (function () {
    function FormatDatePipe() {
        this.date = new common_1.DatePipe();
    }
    FormatDatePipe.prototype.transform = function (value, opts) {
        try {
            return this.date.transform(value, opts);
        }
        catch (e) {
            throw e;
        }
    };
    FormatDatePipe = __decorate([
        core_1.Pipe({
            name: 'formatDate'
        }), 
        __metadata('design:paramtypes', [])
    ], FormatDatePipe);
    return FormatDatePipe;
}());
exports.FormatDatePipe = FormatDatePipe;



},{"@angular/common":"@angular/common","@angular/core":"@angular/core"}],72:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var common_1 = require('@angular/common');
var IntPercentPipe = (function () {
    function IntPercentPipe() {
        this._percent = new common_1.PercentPipe();
    }
    IntPercentPipe.prototype.transform = function (value, digits) {
        if (value === undefined)
            return undefined;
        return this._percent.transform(value / 100, digits);
    };
    IntPercentPipe = __decorate([
        core_1.Pipe({ name: 'intPercent' }), 
        __metadata('design:paramtypes', [])
    ], IntPercentPipe);
    return IntPercentPipe;
}());
exports.IntPercentPipe = IntPercentPipe;



},{"@angular/common":"@angular/common","@angular/core":"@angular/core"}],73:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var common_1 = require('@angular/common');
function pad(num, size) {
    var s = "000000000" + num;
    return s.substr(s.length - size);
}
var IsoDateOnlyPipe = (function () {
    function IsoDateOnlyPipe() {
        this._date = new common_1.DatePipe();
    }
    IsoDateOnlyPipe.prototype.transform = function (value, opts) {
        var orig = value;
        if (!!value && typeof value === 'string') {
            var str = value;
            value = new Date(str);
        }
        var date = value;
        if (!date)
            return null;
        return this._date.transform(date, opts);
    };
    IsoDateOnlyPipe = __decorate([
        core_1.Pipe({ name: 'dateOnly' }), 
        __metadata('design:paramtypes', [])
    ], IsoDateOnlyPipe);
    return IsoDateOnlyPipe;
}());
exports.IsoDateOnlyPipe = IsoDateOnlyPipe;



},{"@angular/common":"@angular/common","@angular/core":"@angular/core"}],74:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var translation_1 = require('../services/translation');
var LocaleNumberPipe = (function () {
    function LocaleNumberPipe(translation) {
        this.translation = translation;
    }
    LocaleNumberPipe.prototype.transform = function (value, pattern) {
        if (value == "" || value === undefined)
            return 0;
        if (value !== 'undefined' || value !== null || !isNaN(value)) {
            this.currentLocale = this.translation.getLocale();
            var ouput = new Intl.NumberFormat(this.currentLocale, this.getFractionDigits(pattern)).format(value);
            return ouput;
        }
        else {
            return '';
        }
    };
    LocaleNumberPipe.prototype.getFractionDigits = function (pattern) {
        if (pattern === undefined)
            return undefined;
        var fractionDigits = pattern.split('-');
        var options = {
            minimumFractionDigits: fractionDigits[0], maximumFractionDigits: fractionDigits[1]
        };
        return options;
    };
    LocaleNumberPipe = __decorate([
        core_1.Pipe({
            name: 'localeNumber'
        }), 
        __metadata('design:paramtypes', [translation_1.ExtendedTranslateService])
    ], LocaleNumberPipe);
    return LocaleNumberPipe;
}());
exports.LocaleNumberPipe = LocaleNumberPipe;



},{"../services/translation":92,"@angular/core":"@angular/core"}],75:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var translation_1 = require('../services/translation');
var core_1 = require('@angular/core');
var LocaleOrdinalPipe = (function () {
    function LocaleOrdinalPipe(lang) {
        this.lang = lang;
    }
    LocaleOrdinalPipe.prototype.getSuffix = function (currentLanguage, last, specialLast) {
        switch (currentLanguage) {
            case "fr":
                if (last === 1 && specialLast !== 11)
                    return 'er';
                else
                    return 'ème';
            case "pt":
                return 'º';
            case "es":
                if (last === 1 && specialLast !== 11)
                    return 'er';
                else if (last === 2 && specialLast !== 12)
                    return 'do';
                else if (last === 3 && specialLast !== 13)
                    return 'er';
                else
                    return 'to';
            case "zh":
                return '第';
            case "de":
                return '.';
            default:
                if (last === 1 && specialLast !== 11)
                    return 'st';
                else if (last === 2 && specialLast !== 12)
                    return 'nd';
                else if (last === 3 && specialLast !== 13)
                    return 'rd';
                else
                    return 'th';
        }
    };
    LocaleOrdinalPipe.prototype.transform = function (value) {
        var currentLanguage = this.lang.currentLang || "en";
        if (value == null)
            return null;
        value = Math.round(value);
        var suffix = '';
        var abs = Math.abs(value);
        var last = abs % 10;
        var specialLast = abs % 100;
        suffix = this.getSuffix(currentLanguage, last, specialLast);
        return value + suffix;
    };
    LocaleOrdinalPipe = __decorate([
        core_1.Pipe({
            name: 'localeOrdinal'
        }), 
        __metadata('design:paramtypes', [translation_1.TranslateService])
    ], LocaleOrdinalPipe);
    return LocaleOrdinalPipe;
}());
exports.LocaleOrdinalPipe = LocaleOrdinalPipe;



},{"../services/translation":92,"@angular/core":"@angular/core"}],76:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var OrdinalPipe = (function () {
    function OrdinalPipe() {
    }
    OrdinalPipe.prototype.transform = function (value) {
        if (value == null)
            return null;
        value = Math.round(value);
        var suffix = '';
        var abs = Math.abs(value);
        var last = abs % 10;
        var specialLast = abs % 100;
        if (last === 1 && specialLast !== 11) {
            suffix = 'st';
        }
        else if (last === 2 && specialLast !== 12) {
            suffix = 'nd';
        }
        else if (last === 3 && specialLast !== 13) {
            suffix = 'rd';
        }
        else {
            suffix = 'th';
        }
        return value + suffix;
    };
    OrdinalPipe = __decorate([
        core_1.Pipe({
            name: 'ordinal'
        }), 
        __metadata('design:paramtypes', [])
    ], OrdinalPipe);
    return OrdinalPipe;
}());
exports.OrdinalPipe = OrdinalPipe;



},{"@angular/core":"@angular/core"}],77:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var common_1 = require('@angular/common');
var SafeDatePipe = (function () {
    function SafeDatePipe() {
        this._date = new common_1.DatePipe();
    }
    SafeDatePipe.prototype.transform = function (value, opts) {
        var orig = value;
        if (!!value && typeof value === 'string') {
            if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,4})?$/.test(value))
                value += 'Z';
            value = new Date(value);
        }
        try {
            return this._date.transform(value, opts);
        }
        catch (e) {
            debugger;
            throw e;
        }
    };
    SafeDatePipe = __decorate([
        core_1.Pipe({ name: 'date' }), 
        __metadata('design:paramtypes', [])
    ], SafeDatePipe);
    return SafeDatePipe;
}());
exports.SafeDatePipe = SafeDatePipe;



},{"@angular/common":"@angular/common","@angular/core":"@angular/core"}],78:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var ShortNumberPipe = (function () {
    function ShortNumberPipe() {
    }
    ShortNumberPipe.prototype.transform = function (num, digits) {
        var units = ['K', 'M', 'B', 'T', 'P', 'E', 'Z', 'Y'];
        var decimal;
        if (num < 1000 && num > -1000)
            return num.toString();
        for (var i = units.length - 1; i >= 0; i--) {
            decimal = Math.pow(1000, i + 1);
            if (num <= -decimal || num >= decimal) {
                return +(num / decimal).toFixed(digits) + units[i];
            }
        }
        return '0';
    };
    ShortNumberPipe = __decorate([
        core_1.Pipe({ name: 'shortNumber' }), 
        __metadata('design:paramtypes', [])
    ], ShortNumberPipe);
    return ShortNumberPipe;
}());
exports.ShortNumberPipe = ShortNumberPipe;



},{"@angular/core":"@angular/core"}],79:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var _NUMBER_MATCH_REGEXP = /-?\d+(\.\d+)?/;
var ThresholdPipe = (function () {
    function ThresholdPipe() {
    }
    ThresholdPipe.prototype.transform = function (value, options) {
        if (options == null)
            return value;
        if (value == null)
            return null;
        var origValue = value;
        if (typeof value === 'string') {
            value = value.replace(/,| /g, "");
            var match_1 = _NUMBER_MATCH_REGEXP.exec(value);
            if (!match_1) {
                return null;
            }
            value = parseFloat(match_1[0]);
        }
        if (isNaN(value)) {
            return null;
        }
        var match = options.find(function (o) { return (o.lowerBound == null || o.lowerBound < value) && (o.upperBound == null || o.upperBound > value) && !o.default; }) || options.find(function (o) { return o.default; });
        if (match)
            return match.text;
        else
            return origValue;
    };
    ThresholdPipe = __decorate([
        core_1.Pipe({
            name: 'threshold'
        }), 
        __metadata('design:paramtypes', [])
    ], ThresholdPipe);
    return ThresholdPipe;
}());
exports.ThresholdPipe = ThresholdPipe;



},{"@angular/core":"@angular/core"}],80:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var counter = 1;
var map = new WeakMap();
var UniqueIdPipe = (function () {
    function UniqueIdPipe() {
    }
    UniqueIdPipe.prototype.transform = function (value) {
        var val = map.get(value);
        if (!val) {
            val = counter++;
            map.set(value, val);
        }
        return val;
    };
    UniqueIdPipe = __decorate([
        core_1.Pipe({ name: 'uniqueId' }), 
        __metadata('design:paramtypes', [])
    ], UniqueIdPipe);
    return UniqueIdPipe;
}());
exports.UniqueIdPipe = UniqueIdPipe;



},{"@angular/core":"@angular/core"}],81:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var translation_1 = require('../services/translation');
var YesNoPipe = (function () {
    function YesNoPipe(translate, cdr) {
        this.innerPipe = new translation_1.TranslatePipe(translate, cdr);
    }
    YesNoPipe.prototype.transform = function (value) {
        if (!!value)
            return this.innerPipe.transform('GLOBAL.YES');
        else
            return this.innerPipe.transform('GLOBAL.NO');
    };
    YesNoPipe = __decorate([
        core_1.Pipe({ name: 'yesno', pure: false }), 
        __metadata('design:paramtypes', [translation_1.TranslateService, core_1.ChangeDetectorRef])
    ], YesNoPipe);
    return YesNoPipe;
}());
exports.YesNoPipe = YesNoPipe;



},{"../services/translation":92,"@angular/core":"@angular/core"}],82:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var LanguageFormatterService = (function () {
    function LanguageFormatterService() {
        this.languageNumberDecoratores = {};
        this.setupLanguageNumberDecoratores();
    }
    LanguageFormatterService.prototype.formatDisplayValue = function (dispalyValue, currentlocale) {
        if (dispalyValue) {
            if (this.languageNumberDecoratores['comma'].findIndex(function (x) { return x === currentlocale; }) > -1) {
                dispalyValue = dispalyValue.replace(/,| /g, '');
                dispalyValue = dispalyValue.replace(/\s/g, '');
            }
            if (this.languageNumberDecoratores['space'].findIndex(function (x) { return x === currentlocale; }) > -1) {
                dispalyValue = dispalyValue.replace(/\s/g, '');
                dispalyValue = dispalyValue.replace(/,| /, '.');
            }
            if (this.languageNumberDecoratores['dot'].findIndex(function (x) { return x === currentlocale; }) > -1) {
                dispalyValue = dispalyValue.replace(/\./g, '');
                dispalyValue = dispalyValue.replace(/,| /, '.');
            }
            return dispalyValue;
        }
        else
            return;
    };
    LanguageFormatterService.prototype.getFormattedNumber = function (displayText, locale) {
        if (displayText.indexOf('%') > -1) {
            displayText = displayText.replace(/%| /, "");
            return new Intl.NumberFormat(locale, {
                style: 'percent',
                minimumFractionDigits: 1
            }).format(Number(displayText / 100));
        }
        else {
            if (displayText === "")
                return "";
            return new Intl.NumberFormat(locale, {
                minimumFractionDigits: 0
            }).format(Number(displayText));
        }
    };
    LanguageFormatterService.prototype.removeFormatting = function (displayText) {
        displayText = displayText.replace(/,| /g, "");
        displayText = displayText.replace(/\s/g, '');
        return displayText;
    };
    LanguageFormatterService.prototype.getPlatformSupportedLanguages = function () {
        return [
            { code: "en", displayName: "English" },
            { code: "fr", displayName: "Français" },
            { code: "es", displayName: "Español" },
            { code: "zh", displayName: "普通话" },
            { code: "pt", displayName: "Português" },
            { code: "de", displayName: "Deutsch" }
        ];
    };
    LanguageFormatterService.prototype.getFormattedLangugageCode = function () {
        return [
            { code: "en", langCode: "en-US" },
            { code: "fr", langCode: "fr-FR" },
            { code: "es", langCode: "es-ES" },
            { code: "zh", langCode: "zh-CN" },
            { code: "pt", langCode: "pt-PT" },
            { code: "de", langCode: "de-DE" }
        ];
    };
    LanguageFormatterService.prototype.setupLanguageNumberDecoratores = function () {
        this.languageNumberDecoratores['comma'] = ['en', 'zh-CN', 'en-US'];
        this.languageNumberDecoratores['space'] = ['fr', 'fr-FR', 'pt-PT'];
        this.languageNumberDecoratores['dot'] = ['es', 'es-ES', 'de', 'de-DE'];
    };
    LanguageFormatterService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [])
    ], LanguageFormatterService);
    return LanguageFormatterService;
}());
exports.LanguageFormatterService = LanguageFormatterService;



},{"@angular/core":"@angular/core"}],83:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var configService_1 = require('./configService');
var clientService_1 = require('./clientService');
var siteHeaderService_1 = require('./siteHeaderService');
var userService_1 = require('./userService');
var ApplicationInsightsService = (function () {
    function ApplicationInsightsService(_clients, _user, _siteHeaderService, _configService) {
        this._clients = _clients;
        this._user = _user;
        this._siteHeaderService = _siteHeaderService;
        this._configService = _configService;
        this.appInsights = window["appInsights"];
    }
    ApplicationInsightsService.prototype.config = function (instrumentationKey) {
        this.configImpl(instrumentationKey);
    };
    ApplicationInsightsService.prototype.configImpl = function (instrumentationKey) {
        this.appInsights.config.instrumentationKey = instrumentationKey;
    };
    ApplicationInsightsService.prototype.send = function (analyticsSendInput, isRunIdRequired) {
        if (isRunIdRequired === void 0) { isRunIdRequired = true; }
        if (!analyticsSendInput.eventAction)
            throw new Error('eventAction property is empty');
        if (isRunIdRequired && !analyticsSendInput.runId)
            throw new Error('runId property is empty');
        this.sendImpl(analyticsSendInput);
    };
    ApplicationInsightsService.prototype.sendImpl = function (analyticsSendInput) {
        var eventCategory = analyticsSendInput.eventCategory || this._siteHeaderService.pageList[this._siteHeaderService.index].identifier;
        var paramsObj = {
            eventCategory: eventCategory,
            eventAction: analyticsSendInput.eventAction
        };
        var eventLabel = {
            ClientID: this._clients.currentClient ? this._clients.currentClient.clientId : '',
            ClientName: this._clients.currentClient ? this._clients.currentClient.displayName : '',
            UserUpn: this._user.currentUserInfo ? this._user.currentUserInfo.username : '',
            UserDisplayName: this._user.currentUserInfo ? this._user.currentUserInfo.fullName : '',
            RunId: analyticsSendInput.runId
        };
        if (analyticsSendInput.addtionalFields)
            Object.assign(eventLabel, analyticsSendInput.addtionalFields);
        paramsObj['eventLabel'] = JSON.stringify(eventLabel);
        this.appInsights.trackEvent({ name: eventCategory }, paramsObj);
    };
    ApplicationInsightsService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [clientService_1.ClientService, userService_1.UserService, siteHeaderService_1.SiteHeaderService, configService_1.ConfigService])
    ], ApplicationInsightsService);
    return ApplicationInsightsService;
}());
exports.ApplicationInsightsService = ApplicationInsightsService;



},{"./clientService":84,"./configService":85,"./siteHeaderService":91,"./userService":93,"@angular/core":"@angular/core"}],84:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var Api = require('../backend/webapis');
var rx_1 = require('rxjs');
var ClientService = (function () {
    function ClientService(_api) {
        this._api = _api;
        this.currentClientChanged = new rx_1.ReplaySubject(1);
        this.runCountChanged = new rx_1.Subject();
    }
    Object.defineProperty(ClientService.prototype, "currentClient", {
        get: function () {
            return this._currentClient;
        },
        set: function (value) {
            this._currentClient = value;
            if (value)
                this.currentClientChanged.next(value);
        },
        enumerable: true,
        configurable: true
    });
    ClientService.prototype.getDetails = function (id) {
        return this._api.getDetails(id).map(function (r) { return r.data; });
    };
    ClientService.prototype.loadById = function (id) {
        var _this = this;
        var obs = this._api.get(id).uiSignal('load client');
        obs.subscribe(function (ret) { return _this.currentClient = ret.data; });
        return obs.map(function (ret) { return ret.data; });
    };
    ClientService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [Api.ClientsProxy])
    ], ClientService);
    return ClientService;
}());
exports.ClientService = ClientService;



},{"../backend/webapis":17,"@angular/core":"@angular/core","rxjs":"rxjs"}],85:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = require('@angular/core');
var Api = require('../backend/webapis');
var rx_1 = require('rxjs');
var ConfigService = (function () {
    function ConfigService(settings, _settingsApi) {
        var _this = this;
        this._settingsApi = _settingsApi;
        this.currentModelChanged = new rx_1.ReplaySubject(1);
        this.settings = new rx_1.ReplaySubject();
        this.models = settings.models;
        this._subdomain = settings.subdomain;
        this._settingsApi.get().subscribe(function (ret) { return _this.settings.next(ret.data); });
    }
    Object.defineProperty(ConfigService.prototype, "currentModel", {
        get: function () {
            return this._currentModel;
        },
        set: function (value) {
            this._currentModel = value;
            this.currentModelChanged.next(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigService.prototype, "subdomain", {
        get: function () { return this._subdomain; },
        enumerable: true,
        configurable: true
    });
    ConfigService = __decorate([
        core_1.Injectable(),
        __param(0, core_1.Inject("models")), 
        __metadata('design:paramtypes', [Object, Api.SettingsProxy])
    ], ConfigService);
    return ConfigService;
}());
exports.ConfigService = ConfigService;



},{"../backend/webapis":17,"@angular/core":"@angular/core","rxjs":"rxjs"}],86:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var router_1 = require('@angular/router');
var rx_1 = require('rxjs');
var common_1 = require('@angular/common');
var translation_1 = require('./translation');
var configService_1 = require('./configService');
var siteHeaderService_1 = require('./siteHeaderService');
var runService_1 = require('./runService');
var backend_1 = require('../../backend');
var interfaces_1 = require('../../interfaces');
require('rxjs');
var ng2_toastr_1 = require('ng2-toastr');
var NavigationService = (function () {
    function NavigationService(_runService, _toastr, _router, config, _location, injector, _translate, _errorProxy, _headerServiceTEMPORARY) {
        var _this = this;
        this._runService = _runService;
        this._toastr = _toastr;
        this._router = _router;
        this.config = config;
        this._location = _location;
        this.injector = injector;
        this._translate = _translate;
        this._errorProxy = _errorProxy;
        this._headerServiceTEMPORARY = _headerServiceTEMPORARY;
        this.navigationChanged = new rx_1.ReplaySubject(1);
        this._runService.activeRun.subscribe(function (run) {
            _this.currentRun = run;
        });
    }
    NavigationService.prototype.triggerNavigationAction = function (navigationAction, stage, hideOverlay) {
        var _this = this;
        if (navigationAction.type == backend_1.Dto.NavigationType.persist && this.currentRun) {
            return this._runService.persist(this.currentRun.runId, this.currentRun.data, this.currentRun.currencyInfo, stage, hideOverlay).do(function () { return _this._toastr.success(_this._translate.instant('GLOBAL.TOASTS.SAVED')); }).toPromise().then(function (r) { return !!r; });
        }
        if (navigationAction.type == backend_1.Dto.NavigationType.persistAndProcess && this.currentRun) {
            return this._runService.persist(this.currentRun.runId, this.currentRun.data, this.currentRun.currencyInfo, stage, hideOverlay, navigationAction.processUrl).do(function () { return _this._toastr.success(_this._translate.instant('GLOBAL.TOASTS.SAVED')); }).toPromise().then(function (r) { return !!r; });
        }
        else if (navigationAction.type == backend_1.Dto.NavigationType.persistAndExecute && this.currentRun && navigationAction.trigger !== undefined) {
            var param = navigationAction.trigger;
            if (!!navigationAction.triggerParameter)
                param = { number: navigationAction.trigger, param: navigationAction.triggerParameter };
            return this._runService.executeTrigger(this.currentRun.runId, this.currentRun.data, param, this.currentRun.currencyInfo, stage, hideOverlay).do(function () { return _this._toastr.success(_this._translate.instant('GLOBAL.TOASTS.SAVED')); }).toPromise().then(function (r) { return !!r; });
        }
        else
            return null;
    };
    NavigationService.prototype.navigate = function (params) {
        var _this = this;
        this._headerServiceTEMPORARY.navigation.inProgress = params.offset;
        var target = params.originalIndex + params.offset;
        var backUrl = params.router.url;
        var currentStage = this._runService.getStageIdentifier(params.level);
        var prevInstruction = params.pageList[params.originalIndex];
        var nextInstruction = params.pageList[target];
        var runServiceInteraction = function (hideOverlay) { return function (ret) {
            if (ret && params.offset === interfaces_1.NavigationDirection.forward && !_this.currentRun.info.isReadonly) {
                var prepare = Promise.resolve(true);
                if (params.originalIndex === 0)
                    prepare = _this._runService.updateStage(_this.currentRun.runId, currentStage).toPromise().then(function (r) { return !!r; });
                var forwardNextStage_1 = currentStage.split('/').reduce(function (acc, item, index, list) { return acc.concat([index == list.length - 1 ? nextInstruction.identifier : item]); }, []).join('/');
                return prepare.then(function () {
                    if (prevInstruction.onForwardNavigation) {
                        var runServicePromise = _this.triggerNavigationAction(prevInstruction.onForwardNavigation, forwardNextStage_1, hideOverlay);
                        if (!!runServicePromise)
                            return runServicePromise;
                    }
                    else {
                        return _this._runService.updateStage(_this.currentRun.runId, forwardNextStage_1).toPromise().then(function (r) { return !!r; });
                    }
                });
            }
            return Promise.resolve(ret);
        }; };
        var moveToTarget = function (ret) { return ret ? params.router.navigate([params.pageList[target].identifier], { relativeTo: params.relativeTo }) : Promise.resolve(false); };
        var moveToLoader = function (ret) { return ret ? params.router.navigate(['~loading', prevInstruction.identifier], { relativeTo: params.relativeTo })
            .then(function (ret) {
            if (!ret)
                return false;
            _this.navigationChanged.next(backUrl);
            _this._location.replaceState(backUrl);
            return true;
        })
            : Promise.resolve(false); };
        var moveToBlank = function (ret) { return ret ? params.router.navigate(['~inProgress'], { relativeTo: params.relativeTo })
            .then(function (ret) {
            if (!ret)
                return false;
            _this.navigationChanged.next(backUrl);
            _this._location.replaceState(backUrl);
            return true;
        })
            : Promise.resolve(false); };
        var op;
        if (params.offset == interfaces_1.NavigationDirection.forward && prevInstruction.onForwardNavigation && prevInstruction.onForwardNavigation.loadingScreenItems)
            op = moveToLoader(true).then(runServiceInteraction(true)).then(moveToTarget);
        else
            op = moveToBlank(true).then(runServiceInteraction(false)).then(moveToTarget);
        return op.catch(function (err) {
            if (err && err.message && err.stack) {
                var originalException = core_1.ExceptionHandler.exceptionToString(err.message, err.stack);
                _this._errorProxy.error({
                    text: originalException
                }).fireAndForget();
                console.error(originalException);
            }
            _this._headerServiceTEMPORARY.navigation.inProgress = undefined;
            params.router.navigate([params.pageList[params.originalIndex].identifier], { relativeTo: params.relativeTo }).then(function (err) { return _this._toastr.error(_this._translate.instant('GLOBAL.TOASTS.NAVIGATION_ERROR')); });
        }).then(function () { _this._headerServiceTEMPORARY.navigation.inProgress = undefined; });
    };
    NavigationService.prototype.navigateByUrl = function (url) {
        this.navigationChanged.next(url);
        this._router.navigateByUrl(url);
    };
    NavigationService.prototype.canNavigateTo = function (input) {
        if (input.runModel.info.isReadonly)
            return { canNavigate: true };
        var level = input.path.length;
        var stageData = input.runModel.info.stage;
        var history = [];
        if (stageData && stageData.startsWith("history:")) {
            history = stageData.substr("history:".length).split(';');
        }
        var parent = null;
        var list = this.config.currentModel.runPages;
        var isUnordered = false;
        var _loop_1 = function(i) {
            var index = list.findIndex(function (r) { return r.identifier == input.path[i]; });
            if (index === -1)
                throw input.path[i] + " not found in run page hierarchy";
            parent = list[index];
            list = parent.children || [];
            isUnordered = parent.unorderedChildren;
        };
        for (var i = 0; i < level; i++) {
            _loop_1(i);
        }
        var currentIndex = list.findIndex(function (r) { return r.identifier == input.targetIdentifier; });
        if (currentIndex === -1)
            throw input.targetIdentifier + " not found in run page hierarchy";
        if (isUnordered)
            return this.customCanNavigateCheck(list[currentIndex], input) || { canNavigate: true };
        var prefix = input.path.length ? input.path.join("/") + '/' : '';
        var cnt = 0;
        if (currentIndex == 0) {
            var customRuleCheck = this.customCanNavigateCheck(list[0], { path: input.path, runModel: input.runModel, targetIdentifier: list[0].identifier });
            if (customRuleCheck && !customRuleCheck.canNavigate) {
                return {
                    canNavigate: false, toastResource: customRuleCheck.toastResource
                };
            }
        }
        else {
            var _loop_2 = function(ix) {
                var ident = prefix + list[ix].identifier;
                var previous = prefix + (ix && list[ix - 1].identifier || "");
                cnt = history.indexOf(ident, cnt);
                if (cnt === -1) {
                    return { value: { canNavigate: false, alternativeIdentifier: previous } };
                }
                else if (history.some(function (item, h_index) { return item.startsWith(ident + '/') && h_index > cnt; })) {
                    return { value: { canNavigate: false, alternativeIdentifier: previous } };
                }
                if (ix > 0) {
                    var customRuleCheck = this_1.customCanNavigateCheck(list[ix], { path: input.path, runModel: input.runModel, targetIdentifier: list[ix].identifier });
                    if (customRuleCheck && !customRuleCheck.canNavigate) {
                        return { value: {
                            canNavigate: false, alternativeIdentifier: previous, toastResource: customRuleCheck.toastResource
                        } };
                    }
                }
            };
            var this_1 = this;
            for (var ix = 0; ix <= currentIndex; ix++) {
                var state_2 = _loop_2(ix);
                if (typeof state_2 === "object") return state_2.value;
            }
        }
        return { canNavigate: true };
    };
    NavigationService.prototype.customCanNavigateCheck = function (description, request) {
        var type = description.$$module["CanNavigateTo"];
        if (!type)
            return null;
        var instance = this.injector.get(type);
        return instance.canNavigateTo(request);
    };
    NavigationService.prototype.getCurrentPath = function () {
        return this._router.url.split('/').slice(3).join('/');
    };
    NavigationService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [runService_1.RunService, ng2_toastr_1.ToastsManager, router_1.Router, configService_1.ConfigService, common_1.Location, core_1.Injector, translation_1.TranslateService, backend_1.Api.ErrorProxy, siteHeaderService_1.SiteHeaderService])
    ], NavigationService);
    return NavigationService;
}());
exports.NavigationService = NavigationService;



},{"../../backend":"@toolkit/backend","../../interfaces":"@toolkit/interfaces","./configService":85,"./runService":89,"./siteHeaderService":91,"./translation":92,"@angular/common":"@angular/common","@angular/core":"@angular/core","@angular/router":"@angular/router","ng2-toastr":"ng2-toastr","rxjs":"rxjs"}],87:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var rx_1 = require('rxjs');
var router_1 = require('@angular/router');
var runService_1 = require('./runService');
var navigationService_1 = require('./navigationService');
var configService_1 = require('./configService');
var PageService = (function () {
    function PageService(_configService, _runService, _navigationService, _router) {
        var _this = this;
        this._configService = _configService;
        this._runService = _runService;
        this._navigationService = _navigationService;
        this._router = _router;
        this.pageStateChanged = new rx_1.ReplaySubject(1);
        this.pages = [];
        this._configService.currentModelChanged
            .subscribe(function (data) {
            _this.pageList = data.runPages;
            _this._runService.activeRun.subscribe(function (runModel) {
                _this.runModel = runModel;
                _this.pages = _this.buildRunPages(_this.runModel);
                _this.pageStateChanged.next(_this.pages);
            });
        });
        this._router.events.filter(function (o) { return o instanceof router_1.NavigationEnd; })
            .sampleTime(500)
            .subscribe(function (e) {
            if (e.urlAfterRedirects.indexOf('~inProgress') === -1)
                _this.pages = _this.buildRunPages(_this.runModel);
            _this.pageStateChanged.next(_this.pages);
        });
    }
    PageService.prototype.buildRunPages = function (runModel, pageList) {
        if (pageList === void 0) { pageList = this.pageList; }
        if (!runModel)
            return [];
        var pageUrls = this.buildPageLinks(runModel.runId, pageList, "", this._navigationService.getCurrentPath(), 1);
        this.populateNavigatablePages(runModel, pageUrls);
        return pageUrls;
    };
    PageService.prototype.populateNavigatablePages = function (runModel, pageLinks, canParentNavigatable) {
        var _this = this;
        pageLinks.map(function (pl) {
            if (canParentNavigatable === false)
                pl.canNavigate = false;
            else {
                var full = pl.url.split('/').slice(2);
                pl.canNavigate = _this._navigationService.canNavigateTo({
                    path: full.slice(0, full.length - 1),
                    runModel: runModel,
                    targetIdentifier: full[full.length - 1]
                })
                    .canNavigate;
            }
            if (pl.children && pl.children.length > 0)
                _this.populateNavigatablePages(runModel, pl.children, pl.canNavigate);
        });
    };
    PageService.prototype.buildPageLinks = function (activeRunId, runPages, path, currentPath, level, prefix) {
        var _this = this;
        if (prefix === void 0) { prefix = null; }
        prefix = prefix || "CURRENT_MODEL.RUN_PAGES.PAGE";
        return runPages.map(function (x, index) {
            var pagelink = {
                displayTitle: x.displayTitle,
                identifier: x.identifier,
                url: path === '' ? "run/" + activeRunId + "/" + x.identifier : "run/" + activeRunId + "/" + path + "/" + x.identifier,
                canNavigate: false,
                current: currentPath === (path === '' ? x.identifier : path + '/' + x.identifier),
                visible: false,
                level: level,
                displayResourceKey: prefix + "_" + index
            };
            if (x.children && x.children.length > 0) {
                pagelink.children = _this.buildPageLinks(activeRunId, x.children, path === '' ? x.identifier : path + "/" + x.identifier, currentPath, level + 1, pagelink.displayResourceKey);
                pagelink.ancestorOfCurrent = pagelink.children.some(function (c) { return c.current || c.ancestorOfCurrent; });
            }
            return pagelink;
        });
    };
    PageService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [configService_1.ConfigService, runService_1.RunService, navigationService_1.NavigationService, router_1.Router])
    ], PageService);
    return PageService;
}());
exports.PageService = PageService;



},{"./configService":85,"./navigationService":86,"./runService":89,"@angular/core":"@angular/core","@angular/router":"@angular/router","rxjs":"rxjs"}],88:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var ReferenceTranslationService = (function () {
    function ReferenceTranslationService() {
        this.refDataTranslation = {};
    }
    ReferenceTranslationService.prototype.setRefDataTranslation = function (translation) {
        var _this = this;
        this.refDataTranslation = {};
        Object.keys(translation).forEach(function (c) {
            _this.refDataTranslation[c.toUpperCase()] = translation[c];
        });
    };
    ReferenceTranslationService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [])
    ], ReferenceTranslationService);
    return ReferenceTranslationService;
}());
exports.ReferenceTranslationService = ReferenceTranslationService;



},{"@angular/core":"@angular/core"}],89:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var Api = require('../backend/webapis');
var rx_1 = require('rxjs');
var translation_1 = require('./translation');
var configService_1 = require('./configService');
var router_1 = require('@angular/router');
var ng2_toastr_1 = require('ng2-toastr');
var RunService = (function () {
    function RunService(_runs, _config, _translate, _toastr, _router) {
        var _this = this;
        this._runs = _runs;
        this._config = _config;
        this._translate = _translate;
        this._toastr = _toastr;
        this._router = _router;
        this._runInfoChanged = new rx_1.Subject();
        this._persisted = new rx_1.Subject();
        this.currencyConverted = new rx_1.Subject();
        this._activeRun = new rx_1.ReplaySubject(1);
        this._activeRunObs = this._activeRun.do(function (run) {
            _this.snapshot = run;
        });
        this.runInfoChanged = this._runInfoChanged;
        this.persisted = this._persisted;
        var lastSnapshot = null;
        var cancelled = [];
        this._router.events.filter(function (o) { return o instanceof router_1.NavigationStart; }).subscribe(function (o) {
            lastSnapshot = _this.snapshot;
            var match = /\/run\/(\d+)/.exec(o.url);
            if (match) {
                var runId = parseInt(match[1]);
                if (!_this.snapshot || _this.snapshot.info.runId !== runId)
                    _this.load(runId);
            }
        });
        this._router.events.filter(function (o) { return o instanceof router_1.NavigationEnd; }).subscribe(function (o) {
            if (cancelled.indexOf(o.id) > -1)
                return;
            var match = /\/run\/(\d+)/.exec(o.url);
            if (!match)
                _this.snapshot = null;
        });
        this._router.events.filter(function (o) { return o instanceof router_1.NavigationCancel; }).subscribe(function (o) {
            _this.snapshot = lastSnapshot;
            cancelled.push(o.id);
        });
    }
    RunService.prototype.load = function (id) {
        var _this = this;
        var obs = this._runs.get(id).uiSignal('load run').share();
        obs.subscribe(function (ret) { return _this._activeRun.next(ret.data); }, function (err) {
            if (err.status === 403 || err.status === 404) {
                _this._router.navigate(['/']);
                _this._translate.get('GLOBAL.TOASTS.RUN_UNAVAILABLE').subscribe(function (o) { return _this._toastr.error(o); });
            }
            else
                throw err;
        });
        return obs;
    };
    Object.defineProperty(RunService.prototype, "activeRun", {
        get: function () {
            return this._activeRunObs;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RunService.prototype, "isReadonly", {
        get: function () {
            return !this.snapshot || this.snapshot.info.isReadonly;
        },
        enumerable: true,
        configurable: true
    });
    RunService.prototype.getSnapshot = function () {
        return this.snapshot;
    };
    RunService.prototype.setSnapshot = function (val) {
        this.snapshot = val;
    };
    RunService.prototype.getStageIdentifier = function (level) {
        if (level === void 0) { level = 99; }
        var find = new RegExp("/run/\\d+/(([^/]+/){0," + level + "}[^/]+)").exec(this._router.url);
        return find && find[1];
    };
    RunService.prototype.persist = function (id, data, currencyInfo, stageOverride, noSignal, processAction) {
        var _this = this;
        var obs = this._runs.updateRunJson(id, {
            runId: id,
            modelName: this._config.currentModel.modelName,
            runModelData: data,
            processAction: processAction,
            stage: stageOverride || this.getStageIdentifier(),
            currencyInfo: currencyInfo
        })
            .do(function (r) {
            if (_this.snapshot) {
                if (r.data.processedModel) {
                    _this.snapshot = r.data.processedModel;
                    _this._activeRun.next(r.data.processedModel);
                }
                else {
                    _this.snapshot.info.stage = r.data.stage;
                    _this.snapshot.options = r.data.runOptions;
                    _this._persisted.next(_this.snapshot);
                    _this._runInfoChanged.next(_this.snapshot.info);
                }
            }
        })
            .map(function (r) { return r.data.id; });
        if (!noSignal)
            obs = obs.uiSignal({ debugInfo: 'persist run', uiLabel: this._translate.instant('GLOBAL.BUSY.PERSISTING') });
        obs = obs.share();
        obs.fireAndForget();
        return obs.delay(10);
    };
    RunService.prototype.executeTrigger = function (id, data, trigger, currencyInfo, stageOverride, noSignal) {
        var _this = this;
        var triggerNo = -1;
        var triggerParam = '';
        if (typeof trigger === 'number') {
            triggerNo = trigger;
        }
        else {
            triggerNo = trigger.number;
            triggerParam = trigger.param;
        }
        var obs = this._runs.execute(id, {
            runId: id,
            triggerNo: triggerNo,
            triggerParam: triggerParam,
            modelName: this._config.currentModel.modelName,
            runModelData: data,
            stage: stageOverride || this.getStageIdentifier(),
            currencyInfo: currencyInfo
        })
            .map(function (r) { return r.data; });
        if (!noSignal)
            obs = obs.uiSignal({ debugInfo: this._translate.instant('GLOBAL.BUSY.TRIGGER') + trigger, uiLabel: this._translate.instant('GLOBAL.BUSY.EXECUTING') });
        obs = obs.share();
        obs.subscribe(function (ret) { return _this._activeRun.next(ret); }, function () { }, function () { });
        return obs.delay(10);
    };
    RunService.prototype.updateStage = function (id, stage) {
        var _this = this;
        var obs = this._runs.updateRunStage(id, {
            runId: id, stage: stage
        }).map(function (r) { return r.data; })
            .do(function (r) {
            if (_this.snapshot) {
                _this.snapshot.info.stage = r.stage;
                _this._runInfoChanged.next(_this.snapshot.info);
            }
        });
        obs = obs.share();
        obs.fireAndForget();
        return obs;
    };
    RunService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [Api.RunsProxy, configService_1.ConfigService, translation_1.TranslateService, ng2_toastr_1.ToastsManager, router_1.Router])
    ], RunService);
    return RunService;
}());
exports.RunService = RunService;



},{"../backend/webapis":17,"./configService":85,"./translation":92,"@angular/core":"@angular/core","@angular/router":"@angular/router","ng2-toastr":"ng2-toastr","rxjs":"rxjs"}],90:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var SharedDataService = (function () {
    function SharedDataService() {
        this.data = {};
    }
    SharedDataService.prototype.setOption = function (option, value) {
        this.data[option] = value;
    };
    SharedDataService.prototype.getOption = function (option) {
        return this.data[option];
    };
    SharedDataService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [])
    ], SharedDataService);
    return SharedDataService;
}());
exports.SharedDataService = SharedDataService;



},{"@angular/core":"@angular/core"}],91:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var rx_1 = require('rxjs');
var configService_1 = require('./configService');
var SiteHeaderService = (function () {
    function SiteHeaderService(_configService) {
        var _this = this;
        this._configService = _configService;
        this.navigation = {
            previous: '',
            next: '',
            previousClicked: new rx_1.Subject(),
            nextClicked: new rx_1.Subject(),
            current: '',
            inProgress: undefined
        };
        this._preset = new rx_1.Subject();
        this._configService.currentModelChanged
            .combineLatest(this._preset, function (models, preset) { return ({ models: models, preset: preset }); })
            .subscribe(function (data) {
            _this.pageList = data.models.runPages;
            var index;
            if (data.preset)
                index = data.models.runPages.findIndex(function (o) { return o.identifier === data.preset; });
            if (index == undefined || index == -1)
                _this.index = 0;
            else
                _this.index = index;
        });
    }
    Object.defineProperty(SiteHeaderService, "MAIN_MODE", {
        get: function () {
            return "MAIN_MODE";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SiteHeaderService, "NAVIGATION_MODE", {
        get: function () {
            return "NAVIGATION_MODE";
        },
        enumerable: true,
        configurable: true
    });
    SiteHeaderService.prototype.setTo = function (preset) { this._preset.next(preset); };
    Object.defineProperty(SiteHeaderService.prototype, "index", {
        get: function () {
            return this._index;
        },
        set: function (val) {
            this._index = val;
            if (!this.pageList)
                return;
            if (val === 0)
                this.navigation.previous = null;
            else
                this.navigation.previous = "CURRENT_MODEL.RUN_PAGES.PAGE_" + (val - 1);
            if (val + 1 === this.pageList.length)
                this.navigation.next = null;
            else
                this.navigation.next = "CURRENT_MODEL.RUN_PAGES.PAGE_" + (val + 1);
            this.navigation.current = "CURRENT_MODEL.RUN_PAGES.PAGE_" + val;
        },
        enumerable: true,
        configurable: true
    });
    SiteHeaderService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [configService_1.ConfigService])
    ], SiteHeaderService);
    return SiteHeaderService;
}());
exports.SiteHeaderService = SiteHeaderService;



},{"./configService":85,"@angular/core":"@angular/core","rxjs":"rxjs"}],92:[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = require('@angular/core');
var ng2_translate_1 = require('ng2-translate');
exports.TranslateLoader = ng2_translate_1.TranslateLoader;
exports.TranslatePipe = ng2_translate_1.TranslatePipe;
exports.TranslateService = ng2_translate_1.TranslateService;
var configService_1 = require('./configService');
var rx_1 = require('rxjs');
var webapis_1 = require('../backend/webapis');
var LanguageFormatterService_1 = require("./LanguageFormatterService");
var referenceTranslationService_1 = require('./referenceTranslationService');
function isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item) && item !== null);
}
function mergeDeep(target, source) {
    var output = Object.assign({}, target);
    if (isObject(target) && isObject(source)) {
        Object.keys(source).forEach(function (key) {
            if (isObject(source[key])) {
                if (!(key in target))
                    Object.assign(output, (_a = {}, _a[key] = source[key], _a));
                else
                    output[key] = mergeDeep(target[key], source[key]);
            }
            else {
                Object.assign(output, (_b = {}, _b[key] = source[key], _b));
            }
            var _a, _b;
        });
    }
    return output;
}
function defaultTranslation(m) {
    var runPageDefaults = {};
    function collect(item, index, prefix) {
        var pattern = prefix + "_" + index;
        runPageDefaults[pattern] = item.displayTitle;
        if (item.children)
            item.children.forEach(function (i2, ix2) { return collect(i2, ix2, pattern); });
    }
    ;
    m.runPages.forEach(function (item, index) { return collect(item, index, 'PAGE'); });
    var obj = {
        TITLE: m.displayName,
        RUN_PAGES: runPageDefaults
    };
    return {
        CURRENT_MODEL: obj
    };
}
var ModelAwareLoader = (function () {
    function ModelAwareLoader(_config) {
        this._config = _config;
    }
    ModelAwareLoader.prototype.getTranslation = function (lang) {
        var main = rx_1.Observable.fromPromise(System.import('/app/assets/i18n/' + lang + '.json!json'));
        return this._config.currentModelChanged
            .take(1)
            .flatMap(function (model) { return model.supportedLanguages
            && model.supportedLanguages.indexOf(lang) > -1
            && rx_1.Observable.fromPromise(System.import(webapis_1.ProxyProxy.redirector_url("clientside/assets/i18n/" + lang + ".json").url + "!json").then(function (r) { return mergeDeep(defaultTranslation(model), r); }))
            || rx_1.Observable.of(defaultTranslation(model)); })
            .combineLatest(main, function (fromModel, fromPlatform) { return mergeDeep(fromPlatform, fromModel); });
    };
    ModelAwareLoader = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [configService_1.ConfigService])
    ], ModelAwareLoader);
    return ModelAwareLoader;
}());
exports.ModelAwareLoader = ModelAwareLoader;
var ExtendedTranslateService = (function (_super) {
    __extends(ExtendedTranslateService, _super);
    function ExtendedTranslateService(referenceTranslationProxy, _config, currentLoader, missingTranslationHandler, languageFormatterService, refTranslationService) {
        var _this = this;
        _super.call(this, currentLoader, missingTranslationHandler);
        this.referenceTranslationProxy = referenceTranslationProxy;
        this._config = _config;
        this.languageFormatterService = languageFormatterService;
        this.refTranslationService = refTranslationService;
        this.languages = new rx_1.ReplaySubject(1);
        this.userLanguage = new rx_1.ReplaySubject(1);
        this._config.currentModelChanged.subscribe(function (m) {
            (_super.prototype.getLangs.call(_this) || []).forEach(function (l) { return _super.prototype.reloadLang.call(_this, l); });
            var modelLanguages = (m.supportedLanguages || ["en"]);
            var known = _this.languagesSnapshot = _this.languageFormatterService.getPlatformSupportedLanguages().filter(function (n) { return modelLanguages.findIndex(function (i) { return i === n.code; }) != -1; });
            _super.prototype.setDefaultLang.call(_this, known[0].code);
            _this.languages.next(known);
            var userLang = known[0].code;
            if (navigator && navigator.language) {
                var browserLang_1 = navigator.language.split('-')[0].toLowerCase();
                if (known.findIndex(function (l) { return l.code === browserLang_1; }) != -1)
                    userLang = browserLang_1;
            }
            _this.use(userLang);
        });
    }
    ExtendedTranslateService.prototype.use = function (language) {
        var _this = this;
        this.userLanguageSnapshot = language;
        var obs = _super.prototype.use.call(this, language);
        this.userLanguage.next(language);
        this.setLocale(language);
        var fullLanguage = this.languageFormatterService.getFormattedLangugageCode().find(function (x) { return x.code === language; });
        this.referenceTranslationProxy.getReferenceTranslationValues(fullLanguage.langCode).subscribe(function (c) { return _this.refTranslationService.setRefDataTranslation(c.data); });
        return obs;
    };
    ExtendedTranslateService.prototype.setLocale = function (language) {
        this.selectedLocale = this.languageFormatterService.getFormattedLangugageCode().find(function (x) { return x.code === language; }).langCode;
    };
    ExtendedTranslateService.prototype.getLocale = function () {
        return this.selectedLocale;
    };
    ExtendedTranslateService = __decorate([
        core_1.Injectable(),
        __param(3, core_1.Optional()), 
        __metadata('design:paramtypes', [webapis_1.ReferenceTranslationProxy, configService_1.ConfigService, ng2_translate_1.TranslateLoader, ng2_translate_1.MissingTranslationHandler, LanguageFormatterService_1.LanguageFormatterService, referenceTranslationService_1.ReferenceTranslationService])
    ], ExtendedTranslateService);
    return ExtendedTranslateService;
}(ng2_translate_1.TranslateService));
exports.ExtendedTranslateService = ExtendedTranslateService;
exports.TRANSLATIONS = [ExtendedTranslateService,
    { provide: ng2_translate_1.TranslateService, useExisting: ExtendedTranslateService },
    { provide: ng2_translate_1.TranslateLoader, useClass: ModelAwareLoader },
    { provide: core_1.PLATFORM_PIPES, useValue: ng2_translate_1.TranslatePipe, multi: true }];



},{"../backend/webapis":17,"./LanguageFormatterService":82,"./configService":85,"./referenceTranslationService":88,"@angular/core":"@angular/core","ng2-translate":"ng2-translate","rxjs":"rxjs"}],93:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var rx_1 = require('rxjs');
var UserService = (function () {
    function UserService() {
        this.userInfo = new rx_1.BehaviorSubject({ loggedOn: false, determined: false });
        this._onUnauthorized = new rx_1.Subject();
        this.onUnauthorized = this._onUnauthorized.throttleTime(1000);
        this.reauthorized = this.userInfo.filter(function (o) { return o.loggedOn; }).map(function () { });
    }
    Object.defineProperty(UserService.prototype, "currentUserInfo", {
        get: function () { return this._userInfo; },
        set: function (val) {
            this._userInfo = val;
            this.userInfo.next({ loggedOn: !!val, details: val, determined: true });
        },
        enumerable: true,
        configurable: true
    });
    UserService.prototype.unauthorized = function () {
        this._userInfo = null;
        this.userInfo.next({ loggedOn: !!null, details: null, determined: false, unauthorized: true });
        this._onUnauthorized.next(null);
    };
    UserService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [])
    ], UserService);
    return UserService;
}());
exports.UserService = UserService;



},{"@angular/core":"@angular/core","rxjs":"rxjs"}],94:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var loginPage_1 = require('./loginPage');
exports.LoginPage = loginPage_1.LoginPage;
var noRolePage_1 = require('./noRolePage');
exports.NoRolePage = noRolePage_1.NoRolePage;
var core_1 = require('@angular/core');
var services_1 = require('../@toolkit/services');
var HasRolesGuard = (function () {
    function HasRolesGuard(_userService) {
        this._userService = _userService;
    }
    HasRolesGuard.prototype.canActivate = function (route, state) {
        return this._userService.userInfo
            .filter(function (info) { return info.determined; })
            .map(function (info) { return info.loggedOn && info.details && !info.details.noRole; })
            .take(1);
    };
    HasRolesGuard = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [services_1.UserService])
    ], HasRolesGuard);
    return HasRolesGuard;
}());
exports.HasRolesGuard = HasRolesGuard;



},{"../@toolkit/services":"@toolkit/services","./loginPage":97,"./noRolePage":99,"@angular/core":"@angular/core"}],95:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var rx_1 = require('rxjs');
var backend_1 = require('../@toolkit/backend');
var core_2 = require('angular2-cookie/core');
var services_1 = require('../@toolkit/services');
var AuthProvider = (function () {
    function AuthProvider(_cookies, _proxy, _user, _userService, _window) {
        this._cookies = _cookies;
        this._proxy = _proxy;
        this._user = _user;
        this._userService = _userService;
        this._window = _window;
    }
    AuthProvider.prototype.verify = function (modelName) {
        return this._user.verify().map(function () { return true; }).catch(function () { return rx_1.Observable.of(false); });
    };
    AuthProvider.prototype.refreshUser = function () {
        var _this = this;
        var obs = this._user.get().uiSignal('user load');
        obs.subscribe(function (ret) {
            _this._userService.currentUserInfo = ret.data;
        }, function (err) {
            _this._userService.currentUserInfo = null;
        });
        return obs;
    };
    AuthProvider = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [core_2.CookieService, backend_1.Api.ProxyProxy, backend_1.Api.UserProxy, services_1.UserService, services_1.WindowRef])
    ], AuthProvider);
    return AuthProvider;
}());
exports.AuthProvider = AuthProvider;



},{"../@toolkit/backend":"@toolkit/backend","../@toolkit/services":"@toolkit/services","@angular/core":"@angular/core","angular2-cookie/core":"angular2-cookie/core","rxjs":"rxjs"}],96:[function(require,module,exports){
module.exports = '<section class="account-page">\n    <div>\n        Please wait while we redirect you to the login page...\n    </div>\n</section>';
},{}],97:[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var reactiveComponent_1 = require('../@toolkit/reactiveComponent');
var services_1 = require('../@toolkit/services');
var authProvider_1 = require('./authProvider');
var router_1 = require('@angular/router');
var directives_1 = require('../@toolkit/directives');
var LoginPage = (function (_super) {
    __extends(LoginPage, _super);
    function LoginPage(_auth, _router, _activatedRoute, _config, _userService) {
        _super.call(this);
        this._auth = _auth;
        this._router = _router;
        this._activatedRoute = _activatedRoute;
        this._config = _config;
        this._userService = _userService;
    }
    LoginPage.prototype.ngOnInit = function () {
        var _this = this;
        this._subscriptions = [
            this._activatedRoute.params.subscribe(function (r) {
                _this._redirectUri = '/api/proxy/login?from=' + encodeURIComponent(r["from"] || '/');
                window.location.href = _this._redirectUri;
            })
        ];
    };
    LoginPage = __decorate([
        core_1.Component({ template: require('./loginPage.html'), moduleId: module.id, directives: [directives_1.CUSTOM_VALUE_ACCESSORS, directives_1.VALIDATORS] }), 
        __metadata('design:paramtypes', [authProvider_1.AuthProvider, router_1.Router, router_1.ActivatedRoute, services_1.ConfigService, services_1.UserService])
    ], LoginPage);
    return LoginPage;
}(reactiveComponent_1.ReactiveComponent));
exports.LoginPage = LoginPage;



},{"../@toolkit/directives":"@toolkit/directives","../@toolkit/reactiveComponent":"@toolkit/reactiveComponent","../@toolkit/services":"@toolkit/services","./authProvider":95,"./loginPage.html":96,"@angular/core":"@angular/core","@angular/router":"@angular/router"}],98:[function(require,module,exports){
module.exports = '<section class="account-page wide">\n    <h2>{{\'NOROLE.INFO\'|translate}}</h2>\n    <div>\n        <ol>\n            <li>\n                {{\'NOROLE.INSTRUCTIONS\'|translate}} <a [href]="\'mailto:\'+email">{{email}}</a>\n            </li>\n            <li><a [routerLink]="[\'/login\']">{{\'NOROLE.RETURN_LINK\'|translate}}</a></li>\n        </ol>\n    </div>\n</section>';
},{}],99:[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var services_1 = require('../@toolkit/services');
var reactiveComponent_1 = require('../@toolkit/reactiveComponent');
var router_1 = require('@angular/router');
var NoRolePage = (function (_super) {
    __extends(NoRolePage, _super);
    function NoRolePage(_config) {
        _super.call(this);
        this._config = _config;
    }
    NoRolePage.prototype.ngOnInit = function () {
        var _this = this;
        this._subscriptions = [this._config.currentModelChanged.subscribe(function (model) { return _this.email = model.contactEmail; })];
    };
    NoRolePage = __decorate([
        core_1.Component({
            template: require('./noRolePage.html'),
            moduleId: module.id,
            directives: [router_1.ROUTER_DIRECTIVES]
        }), 
        __metadata('design:paramtypes', [services_1.ConfigService])
    ], NoRolePage);
    return NoRolePage;
}(reactiveComponent_1.ReactiveComponent));
exports.NoRolePage = NoRolePage;



},{"../@toolkit/reactiveComponent":"@toolkit/reactiveComponent","../@toolkit/services":"@toolkit/services","./noRolePage.html":98,"@angular/core":"@angular/core","@angular/router":"@angular/router"}],100:[function(require,module,exports){
module.exports = '<div>\n    <site-header [currentModel]="currentModel"></site-header>\n</div>\n<div class="page-wrap">\n    <div *ngIf="isMainHeader|async">\n        <client-search></client-search>\n    </div>\n    <router-outlet></router-outlet>\n</div>\n<site-footer></site-footer>\n<loading></loading>';
},{}],101:[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var platform_browser_1 = require('@angular/platform-browser');
var services_1 = require('./@toolkit/services');
var Router = require('@angular/router');
var ReactiveComponent_1 = require('./@toolkit/ReactiveComponent');
var siteHeader_1 = require('./siteHeader');
var components_1 = require('./@toolkit/components');
var vex_1 = require('angular2-modal/plugins/vex');
var clientSearch_1 = require('./models/clientSearch');
var Rx = require('rxjs');
var AppComponent = (function (_super) {
    __extends(AppComponent, _super);
    function AppComponent(_config, _router, modal, viewContainer, _titleService, _translate, _applicationInsightsService, _clientService) {
        _super.call(this);
        this._config = _config;
        this._router = _router;
        this.modal = modal;
        this._titleService = _titleService;
        this._translate = _translate;
        this._applicationInsightsService = _applicationInsightsService;
        this._clientService = _clientService;
        this.isMainHeader = new Rx.Subject();
        this.models = _config.models;
        modal.defaultViewContainer = viewContainer;
    }
    AppComponent.prototype.selectModel = function (model) {
        var _this = this;
        if (model !== this.currentModel) {
            this.currentModel = model;
            this._config.currentModel = model;
            this._subscriptions = [
                this._router.events.filter(function (s) { return s instanceof Router.NavigationEnd; })
                    .subscribe(function (s) {
                    var isMainHeader;
                    if (!_this._router.routerState.snapshot.url.startsWith('/run/') &&
                        !_this._router.routerState.snapshot.url.startsWith('/login') &&
                        !_this._router.routerState.snapshot.url.startsWith('/norole'))
                        isMainHeader = true;
                    setTimeout(function () {
                        _this.isMainHeader.next(isMainHeader);
                    }, 1);
                })
            ];
            var setTitle = function () { return _this._translate.get('CURRENT_MODEL.TITLE').subscribe(function (o) { return _this._titleService.setTitle(o); }); };
            this._translate.userLanguage.subscribe(setTitle);
            this._applicationInsightsService.config(this.currentModel.instrumentationKey != null
                ? this.currentModel.instrumentationKey : "");
        }
    };
    AppComponent.prototype.oneTrustCookieConsentNotice = function (dataDomainScript) {
        if (dataDomainScript) {
            var scriptTag = document.createElement('script');
            scriptTag.type = 'text/javascript';
            scriptTag.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
            scriptTag.charset = 'UTF-8';
            scriptTag.setAttribute('data-domain-script', dataDomainScript);
            document.documentElement.appendChild(scriptTag);
            var scriptFunctionTag = document.createElement('script');
            scriptFunctionTag.type = 'text/javascript';
            scriptFunctionTag.innerHTML = 'function OptanonWrapper() { }';
            document.documentElement.appendChild(scriptFunctionTag);
        }
    };
    AppComponent.prototype.ngOnInit = function () {
        this.selectModel(this._config.subdomain);
        this.oneTrustCookieConsentNotice(this.currentModel.oneTrustCookieDataDomainScript);
    };
    AppComponent = __decorate([
        core_1.Component({
            selector: 'analytics-app',
            template: require('./app.html'),
            moduleId: module.id,
            directives: [Router.ROUTER_DIRECTIVES, siteHeader_1.SiteHeaderComponent, siteHeader_1.SiteFooterComponent, components_1.LoadingIndicator, clientSearch_1.ClientSearch],
            viewProviders: [platform_browser_1.Title]
        }), 
        __metadata('design:paramtypes', [services_1.ConfigService, Router.Router, vex_1.Modal, core_1.ViewContainerRef, platform_browser_1.Title, services_1.ExtendedTranslateService, services_1.ApplicationInsightsService, services_1.ClientService])
    ], AppComponent);
    return AppComponent;
}(ReactiveComponent_1.ReactiveComponent));
exports.AppComponent = AppComponent;



},{"./@toolkit/ReactiveComponent":2,"./@toolkit/components":"@toolkit/components","./@toolkit/services":"@toolkit/services","./app.html":100,"./models/clientSearch":107,"./siteHeader":122,"@angular/core":"@angular/core","@angular/platform-browser":"@angular/platform-browser","@angular/router":"@angular/router","angular2-modal/plugins/vex":"angular2-modal/plugins/vex","rxjs":"rxjs"}],102:[function(require,module,exports){
"use strict";
var platform_browser_dynamic_1 = require('@angular/platform-browser-dynamic');
var app_1 = require('./app');
var core_1 = require('@angular/core');
var forms_1 = require('@angular/forms');
var Router = require('@angular/router');
var main_1 = require('./models/main');
var http_1 = require('@angular/http');
var backend_1 = require('./@toolkit/backend');
var services_1 = require('./@toolkit/services');
var ng2_toastr_1 = require('ng2-toastr');
var pipes_1 = require('./@toolkit/pipes');
var core_2 = require('angular2-cookie/core');
var authProvider_1 = require('./account/authProvider');
var platform_browser_1 = require('angular2-modal/platform-browser');
require('rxjs');
var core_3 = require('@angular/core');
var errorHandler_1 = require('./errorHandler');
var vex_1 = require('angular2-modal/plugins/vex');
if (!System.import) {
    core_3.enableProdMode();
    var getJSON = function (url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.open("get", url, true);
        xhr.responseType = "json";
        xhr.onload = function () {
            var status = xhr.status;
            if (status == 200) {
                var response = xhr.response;
                if (typeof response === 'string')
                    response = JSON.parse(response);
                callback(null, response);
            }
            else {
                callback(status);
            }
        };
        xhr.send();
    };
    var loaded_1 = false;
    var loadScript = function (src, cb) {
        if (src === '@dynamicRoutes!json') {
            getJSON('/api/modules', function (err, data) { return cb(err, data); });
        }
        else if (src.endsWith('!json')) {
            getJSON(src.substring(0, src.length - '!json'.length), function (err, data) { return cb(err, data); });
        }
        else {
            var path = src.substring("/api/proxy/redirector/clientside/".length);
            if (loaded_1) {
                try {
                    var x = require("module/" + path);
                    cb(null, x);
                }
                catch (e) {
                    cb(e);
                }
            }
            else {
                var script = document.createElement('script');
                script.async = true;
                script.src = "/api/proxy/redirector/clientside/application-bundle.js";
                script.onerror = function () {
                    cb(new Error("Failed to load" + script.src));
                };
                script.onload = function () {
                    loaded_1 = true;
                    try {
                        var x = require("module/" + path);
                        cb(null, x);
                    }
                    catch (e) {
                        cb(e);
                    }
                };
                document.getElementsByTagName("head")[0].appendChild(script);
            }
        }
    };
    var cache = {};
    System.import = function (v) {
        if (!cache[v])
            cache[v] = new Promise(function (resolve, reject) { loadScript(v, function (err, res) { if (err)
                reject(err);
            else
                resolve(res); }); });
        return cache[v];
    };
}
System.import('@dynamicRoutes!json').then(function (models) {
    var modelsettings = { models: models };
    var appName = window.location.hostname.split('.')[0];
    var routeConfig;
    var subdomain = models.find(function (o) { return o.modelName == appName; });
    modelsettings.subdomain = subdomain;
    var toastOptions = {
        autoDismiss: true,
    };
    var MODULE_PROVIDER = core_1.provide('models', { useValue: modelsettings });
    return main_1.RouteGenerator(subdomain).then(function (result) {
        var APP_ROUTER_PROVIDERS = Router.provideRouter(result.routes, { enableTracing: false });
        platform_browser_dynamic_1.bootstrap(app_1.AppComponent, [
            http_1.HTTP_PROVIDERS,
            [core_2.CookieService].concat(core_2.ANGULAR2_COOKIE_PROVIDERS),
            authProvider_1.AuthProvider,
            platform_browser_1.MODAL_BROWSER_PROVIDERS,
            vex_1.VEX_MODAL_PROVIDERS.filter(function (o) { return !!o.token; }),
            backend_1.Api.WEBAPI_PROVIDERS,
            APP_ROUTER_PROVIDERS,
            MODULE_PROVIDER,
            services_1.INTERNAL_SHARED_SERVICES,
            [ng2_toastr_1.ToastsManager, core_1.provide(ng2_toastr_1.ToastOptions, { useValue: new ng2_toastr_1.ToastOptions(toastOptions) })],
            [forms_1.disableDeprecatedForms(), forms_1.provideForms()],
            { provide: core_1.PLATFORM_PIPES, useValue: pipes_1.CUSTOM_PIPES, multi: true },
            { provide: core_1.ExceptionHandler, useClass: errorHandler_1.PlatformErrorHandler },
            main_1.GUARDS
        ].concat(result.services));
    });
});



},{"./@toolkit/backend":"@toolkit/backend","./@toolkit/pipes":"@toolkit/pipes","./@toolkit/services":"@toolkit/services","./account/authProvider":95,"./app":101,"./errorHandler":104,"./models/main":110,"@angular/core":"@angular/core","@angular/forms":"@angular/forms","@angular/http":"@angular/http","@angular/platform-browser-dynamic":"@angular/platform-browser-dynamic","@angular/router":"@angular/router","angular2-cookie/core":"angular2-cookie/core","angular2-modal/platform-browser":"angular2-modal/platform-browser","angular2-modal/plugins/vex":"angular2-modal/plugins/vex","ng2-toastr":"ng2-toastr","rxjs":"rxjs"}],103:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
function createDynamicChild(factory, position, index, options) {
    var resolvedDependencies = options && options.length && core_1.ReflectiveInjector.resolve(options.map(function (o) { return core_1.provide(o.name, { useValue: o.value }); }));
    return position.createComponent(factory, 0, core_1.ReflectiveInjector.fromResolvedProviders(resolvedDependencies || [], position.parentInjector));
}
exports.createDynamicChild = createDynamicChild;
var CreateDynamicChildDirective = (function () {
    function CreateDynamicChildDirective(_viewContainer, templateRef, componentResolver) {
        this._viewContainer = _viewContainer;
        this.componentResolver = componentResolver;
    }
    CreateDynamicChildDirective.prototype.ngOnChanges = function () {
        var _this = this;
        if (this.componentType)
            this.componentResolver.resolveComponent(this.componentType).then(function (cf) { return createDynamicChild(cf, _this._viewContainer, 0, _this.options); });
        else
            this._viewContainer.clear();
    };
    __decorate([
        core_1.Input('dynamicChild'), 
        __metadata('design:type', core_1.Type)
    ], CreateDynamicChildDirective.prototype, "componentType", void 0);
    __decorate([
        core_1.Input('dynamicChildOptions'), 
        __metadata('design:type', Array)
    ], CreateDynamicChildDirective.prototype, "options", void 0);
    CreateDynamicChildDirective = __decorate([
        core_1.Directive({ selector: 'template[dynamicChild]' }), 
        __metadata('design:paramtypes', [core_1.ViewContainerRef, core_1.TemplateRef, core_1.ComponentResolver])
    ], CreateDynamicChildDirective);
    return CreateDynamicChildDirective;
}());
exports.CreateDynamicChildDirective = CreateDynamicChildDirective;



},{"@angular/core":"@angular/core"}],104:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var backend_1 = require('./@toolkit/backend');
var PlatformErrorHandler = (function () {
    function PlatformErrorHandler(injector) {
        this.injector = injector;
    }
    PlatformErrorHandler.prototype.call = function (exception, stackTrace, reason) {
        var proxy = this.injector.get(backend_1.Api.ErrorProxy);
        var originalException = core_1.ExceptionHandler.exceptionToString(exception, stackTrace);
        proxy.error({
            text: originalException
        }).fireAndForget();
        console.error(originalException);
    };
    PlatformErrorHandler = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [core_1.Injector])
    ], PlatformErrorHandler);
    return PlatformErrorHandler;
}());
exports.PlatformErrorHandler = PlatformErrorHandler;



},{"./@toolkit/backend":"@toolkit/backend","@angular/core":"@angular/core"}],105:[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var common_1 = require('@angular/common');
var Router = require('@angular/router');
var services_1 = require('../@toolkit/services');
var interfaces = require('../@toolkit/interfaces');
var Rx = require('rxjs');
var reactiveComponent_1 = require('../@toolkit/reactiveComponent');
var services_2 = require('../@toolkit/services');
var ng2_toastr_1 = require('ng2-toastr');
var vex_1 = require('angular2-modal/plugins/vex');
var ActiveRunPage = (function (_super) {
    __extends(ActiveRunPage, _super);
    function ActiveRunPage(_headerService, _runService, _router, _activatedRoute, _clientService, _navigation, _translate, _toastr) {
        _super.call(this);
        this._headerService = _headerService;
        this._runService = _runService;
        this._router = _router;
        this._activatedRoute = _activatedRoute;
        this._clientService = _clientService;
        this._navigation = _navigation;
        this._translate = _translate;
        this._toastr = _toastr;
    }
    ActiveRunPage.prototype.ngOnInit = function () {
        var _this = this;
        this._subscriptions = [
            ,
            this._headerService.navigation.nextClicked.subscribe(function () { _this.navigate(interfaces.NavigationDirection.forward); }),
            this._headerService.navigation.previousClicked.subscribe(function () { _this.navigate(interfaces.NavigationDirection.backward); }),
            this._runService.activeRun.subscribe(function (run) {
                _this.currentRun = run;
                if (!_this._clientService.currentClient || _this._clientService.currentClient.clientId !== run.info.clientId) {
                    _this._clientService.loadById(run.info.clientId);
                }
            })
        ];
    };
    ActiveRunPage.prototype.navigate = function (offset) {
        this._navigation.navigate({
            offset: offset,
            originalIndex: this._headerService.index,
            pageList: this._headerService.pageList,
            relativeTo: this._activatedRoute,
            router: this._router,
            level: 0
        });
    };
    ActiveRunPage = __decorate([
        core_1.Component({
            template: "\n<div>\n  <router-outlet></router-outlet>\n</div>",
            moduleId: module.id,
            directives: [Router.ROUTER_DIRECTIVES]
        }), 
        __metadata('design:paramtypes', [services_2.SiteHeaderService, services_1.RunService, Router.Router, Router.ActivatedRoute, services_1.ClientService, services_1.NavigationService, services_1.TranslateService, ng2_toastr_1.ToastsManager])
    ], ActiveRunPage);
    return ActiveRunPage;
}(reactiveComponent_1.ReactiveComponent));
exports.ActiveRunPage = ActiveRunPage;
function has(x, test) {
    return x && test(x);
}
function isValid(item) {
    if (!item.rootForm.valid)
        return false;
    if (!item.parent)
        return true;
    return isValid(item.parent);
}
var ModalState;
(function (ModalState) {
    ModalState[ModalState["Open"] = 0] = "Open";
    ModalState[ModalState["Closed"] = 1] = "Closed";
    ModalState[ModalState["Rejected"] = 2] = "Rejected";
})(ModalState || (ModalState = {}));
;
var ProgressionGuard = (function () {
    function ProgressionGuard(_toastr, _service, _runs, _navigation, _modal, _location, _config, _router, _translate) {
        this._toastr = _toastr;
        this._service = _service;
        this._runs = _runs;
        this._navigation = _navigation;
        this._modal = _modal;
        this._location = _location;
        this._config = _config;
        this._router = _router;
        this._translate = _translate;
        this.modalOpen = new Rx.BehaviorSubject(ModalState.Closed);
    }
    ProgressionGuard.prototype.canDeactivate = function (component, route, state) {
        var _this = this;
        var direction = this._service.navigation.inProgress;
        var level = -1;
        var definition = (function () {
            var current = route.url[0].path;
            var full = state.url.split('/').slice(3);
            level = full.indexOf(current);
            var runPage = null;
            var list = _this._config.currentModel.runPages;
            var _loop_1 = function(i) {
                var index = list.findIndex(function (r) { return r.identifier == full[i]; });
                if (index === -1)
                    throw full[i] + " not found in run page hierarchy";
                runPage = list[index];
                list = runPage.children || [];
            };
            for (var i = 0; i < level + 1; i++) {
                _loop_1(i);
            }
            return runPage;
        })();
        if (direction === interfaces.NavigationDirection.forward && has(component, function (c) { return c.onForwardNavigation; })) {
            component.onForwardNavigation();
        }
        var haltNavigationCheckImpl = function () {
            if (has(component, function (c) { return c.haltNavigation; })) {
                var result = component.haltNavigation(direction);
                var obs = void 0;
                if (result instanceof Rx.Observable)
                    obs = result;
                else
                    obs = Rx.Observable.of(result);
                return obs.do(function (hn) {
                    if (!hn.toast)
                        return;
                    setTimeout(function () {
                        if (hn.toast instanceof interfaces.ToastDefinition) {
                            _this._toastr.show(hn.toast);
                        }
                        else {
                            var arr = hn.toast;
                            Rx.Observable.interval(100).take(arr.length).subscribe(function (i) { return _this._toastr.show(arr[i]); });
                        }
                    }, 100);
                }).map(function (hn) { return !hn.stop; });
            }
            else
                return Rx.Observable.of(true);
        };
        var haltNavigationCheck = function () {
            if (direction === interfaces.NavigationDirection.forward)
                return haltNavigationCheckImpl();
            else
                return Rx.Observable.of(true);
        };
        var formValidationCheckImpl = function () {
            if (has(component, function (c) { return c.rootForm; })) {
                if (isValid(component)) {
                    return Rx.Observable.of(true);
                }
                else {
                    _this._toastr.error(_this._translate.instant('GLOBAL.TOASTS.VALIDATION_FAILED'));
                    return Rx.Observable.of(false);
                }
            }
            return Rx.Observable.of(true);
        };
        var formValidationCheck = function () {
            if (has(component, function (c) { return c.rootForm; }) && direction === interfaces.NavigationDirection.forward) {
                return formValidationCheckImpl();
            }
            else
                return Rx.Observable.of(true);
        };
        var pendingChangesCheck = function () {
            if (has(component, function (c) { return c.changeTracker; })
                && (direction === undefined || direction === interfaces.NavigationDirection.backward)
                && !!(definition.onForwardNavigation || component.applyChanges)) {
                return _this.modalOpen.skipWhile(function (v) { return v === ModalState.Open; }).take(1).flatMap(function (state) {
                    if (state === ModalState.Rejected) {
                        _this.modalOpen.next(ModalState.Closed);
                        return Rx.Observable.of(false);
                    }
                    component.changeTracker.performChecks(true);
                    if (!component.changeTracker.isChanged)
                        return Rx.Observable.of(true);
                    _this.modalOpen.next(ModalState.Open);
                    var promise = _this._modal.confirm()
                        .addButton("vex-dialog-button vex-dialog-button-primary", _this._translate.instant("GLOBAL.BTN.SAVE"), function (cmp) { return cmp.dialog.close("save"); })
                        .addButton("vex-dialog-button vex-dialog-button-secondary", _this._translate.instant("GLOBAL.BTN.UNDO"), function (cmp) { return cmp.dialog.close("undo"); })
                        .cancelBtn(_this._translate.instant("GLOBAL.BTN.CANCEL"))
                        .okBtn(null)
                        .message(_this._translate.instant("GLOBAL.TOASTS.PENDING_CHANGES_CONFIRM"))
                        .open().then(function (dialog) { return dialog.result.then(function (ret) { return ret; }, function () { return false; }); })
                        .then(function (ret) {
                        if (ret === "save") {
                            return Rx.Observable.zip(formValidationCheckImpl(), haltNavigationCheckImpl()).toPromise()
                                .then(function (rets) {
                                if (rets.every(function (r) { return r; })) {
                                    var action = null;
                                    if (component.applyChanges)
                                        action = component.applyChanges().toPromise();
                                    else {
                                        var stage = _this._runs.getStageIdentifier(level);
                                        action = _this._navigation.triggerNavigationAction(definition.onForwardNavigation, stage, false);
                                    }
                                    return action.then(function (success) {
                                        _this.modalOpen.next(success ? ModalState.Closed : ModalState.Rejected);
                                        return success;
                                    });
                                }
                                else {
                                    _this.modalOpen.next(ModalState.Rejected);
                                    return false;
                                }
                            });
                        }
                        else if (ret === "undo") {
                            return _this._runs.load(_this._runs.getSnapshot().runId).do(function () { return _this.modalOpen.next(ModalState.Closed); }).toPromise().then(function () { return true; });
                        }
                        else {
                            _this.modalOpen.next(ModalState.Rejected);
                            return false;
                        }
                    });
                    return Rx.Observable.fromPromise(promise);
                });
            }
            else
                return Rx.Observable.of(true);
        };
        return Rx.Observable.zip(haltNavigationCheck(), formValidationCheck(), pendingChangesCheck()).map(function (results) { return results.every(function (i) { return !!i; }); });
    };
    ProgressionGuard = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [ng2_toastr_1.ToastsManager, services_2.SiteHeaderService, services_1.RunService, services_1.NavigationService, vex_1.Modal, common_1.Location, services_1.ConfigService, Router.Router, services_1.TranslateService])
    ], ProgressionGuard);
    return ProgressionGuard;
}());
exports.ProgressionGuard = ProgressionGuard;
var JumpGuard = (function () {
    function JumpGuard(navigation, runs, router, translate, toastr) {
        this.navigation = navigation;
        this.runs = runs;
        this.router = router;
        this.translate = translate;
        this.toastr = toastr;
    }
    JumpGuard.prototype.canActivate = function (route, state) {
        var _this = this;
        var current = route.url[0].path;
        var runId = parseInt(state.url.split('/')[2]);
        var full = state.url.split('/').slice(3);
        var level = full.indexOf(current);
        var path = full.slice(0, level);
        return this.runs.activeRun.filter(function (o) { return o.info.runId === runId; }).take(1).map(function (runModel) {
            var success = _this.navigation.canNavigateTo({
                path: path,
                runModel: runModel,
                targetIdentifier: current
            });
            if (!success.canNavigate)
                _this.navigateAway(runModel.runId, path, success.alternativeIdentifier, success.toastResource);
            return success.canNavigate;
        });
    };
    JumpGuard.prototype.navigateAway = function (runId, path, identifier, message) {
        var _this = this;
        this.router.navigate(['run', runId].concat(path, [identifier]), {
            relativeTo: null
        }).then(function () { return _this.translate.get(message || "GLOBAL.TOASTS.INVALID_PAGE").toPromise(); }).then(function (s) { return _this.toastr.error(s); });
    };
    JumpGuard = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [services_1.NavigationService, services_1.RunService, Router.Router, services_1.TranslateService, ng2_toastr_1.ToastsManager])
    ], JumpGuard);
    return JumpGuard;
}());
exports.JumpGuard = JumpGuard;



},{"../@toolkit/interfaces":"@toolkit/interfaces","../@toolkit/reactiveComponent":"@toolkit/reactiveComponent","../@toolkit/services":"@toolkit/services","@angular/common":"@angular/common","@angular/core":"@angular/core","@angular/router":"@angular/router","angular2-modal/plugins/vex":"angular2-modal/plugins/vex","ng2-toastr":"ng2-toastr","rxjs":"rxjs"}],106:[function(require,module,exports){
module.exports = '<div class="client-header">\n    <table>\n        <tr>\n            <td class="company-name">{{currentClient?.displayName}}</td>\n            <td class="snug" style="font-size: 13px;">{{\'SITE_HEADER.CLIENTS\'|translate}}&nbsp;&nbsp;</td>\n            <td class="snug">\n                <autocomplete [dataSource]="search" (enter)="activate($event)">\n                    <template let-item="item">\n                        <div title="{{item?.displayName}}">\n                            {{item?.displayName}}\n                        </div>\n                    </template>\n                </autocomplete>\n            </td>\n        </tr>\n    </table>\n</div>\n    <!--<div style="display: inline-block;" class="company-name"></div>\n    <div class="right" style="font-size: 14px;">\n        {{\'SITE_HEADER.CLIENTS\'|translate}}&nbsp;&nbsp;\n        <autocomplete [dataSource]="search" (enter)="activate($event)">\n            <template let-item="item">\n                <div title="{{item?.displayName}}">\n                    {{item?.displayName}}\n                </div>\n            </template>\n        </autocomplete>\n    </div>\n    \n</div>-->\n\n';
},{}],107:[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var services_1 = require('../@toolkit/services');
var backend_1 = require('../@toolkit/backend');
var reactiveComponent_1 = require('../@toolkit/reactiveComponent');
var directives_1 = require('../@toolkit/directives');
var Router = require('@angular/router');
var ClientSearch = (function (_super) {
    __extends(ClientSearch, _super);
    function ClientSearch(_api, _config, _router, _clientService) {
        var _this = this;
        _super.call(this);
        this._api = _api;
        this._config = _config;
        this._router = _router;
        this._clientService = _clientService;
        this.search = function (v) {
            return _this._api.clientSearch({ searchTerm: v });
        };
    }
    ClientSearch.prototype.showClientSelector = function (event) {
        this.displaySelector = true;
    };
    ;
    Object.defineProperty(ClientSearch.prototype, "active", {
        set: function (v) {
            var _this = this;
            if (v)
                this._viewInit.take(1).subscribe(function (o) { return _this._autoComplete.focus(); });
        },
        enumerable: true,
        configurable: true
    });
    ClientSearch.prototype.activate = function (data) {
        this._router.navigate(['/runs', data.clientId]);
    };
    ClientSearch.prototype.ngOnInit = function () {
        var _this = this;
        this.displaySelector = true;
        this._subscriptions = [
            this._router.events.filter(function (s) { return s instanceof Router.NavigationEnd; })
                .subscribe(function (s) {
                if (_this._router.routerState.snapshot.url.startsWith('/login')) {
                    _this.currentClient = null;
                    _this.displaySelector = true;
                }
            })
        ];
        this._clientService.currentClientChanged
            .subscribe(function (c) {
            _this.currentClient = c;
            _this.displaySelector = false;
        });
    };
    __decorate([
        core_1.ViewChild(directives_1.AutocompleteComponent), 
        __metadata('design:type', directives_1.AutocompleteComponent)
    ], ClientSearch.prototype, "_autoComplete", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Boolean), 
        __metadata('design:paramtypes', [Boolean])
    ], ClientSearch.prototype, "active", null);
    ClientSearch = __decorate([
        core_1.Component({
            selector: 'client-search',
            moduleId: module.id,
            template: require('./clientSearch.html'),
            directives: [directives_1.AUTOCOMPLETE]
        }), 
        __metadata('design:paramtypes', [backend_1.Api.ClientsProxy, services_1.ConfigService, Router.Router, services_1.ClientService])
    ], ClientSearch);
    return ClientSearch;
}(reactiveComponent_1.ReactiveComponent));
exports.ClientSearch = ClientSearch;



},{"../@toolkit/backend":"@toolkit/backend","../@toolkit/directives":"@toolkit/directives","../@toolkit/reactiveComponent":"@toolkit/reactiveComponent","../@toolkit/services":"@toolkit/services","./clientSearch.html":106,"@angular/core":"@angular/core","@angular/router":"@angular/router"}],108:[function(require,module,exports){
module.exports = '<div class="task-box">\n\n    <div class="status">{{percent|intPercent}}</div>\n\n    <ul class="task-list" *ngFor="let item of source">\n        <li [class.completed]="item.done">{{item.label}}</li>\n    </ul>\n\n</div>';
},{}],109:[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var services_1 = require('../@toolkit/services');
var Router = require('@angular/router');
var reactiveComponent_1 = require('../@toolkit/reactiveComponent');
var Rx = require('rxjs');
var LoadingStepComponent = (function (_super) {
    __extends(LoadingStepComponent, _super);
    function LoadingStepComponent(_route, _config, _translate) {
        _super.call(this);
        this._route = _route;
        this._config = _config;
        this._translate = _translate;
        this.trigger = new Rx.Subject();
        this.percent = 0;
    }
    Object.defineProperty(LoadingStepComponent.prototype, "page", {
        get: function () {
            return this._page;
        },
        set: function (v) {
            this._page = v;
            this.trigger.next(v);
        },
        enumerable: true,
        configurable: true
    });
    LoadingStepComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._subscriptions = [
            this._config.currentModelChanged.combineLatest(this.trigger, function (model, page) {
                return model.runPages.find(function (o) { return o.identifier == page; });
            })
                .filter(function (runPage) {
                return runPage && !!runPage.onForwardNavigation && !!runPage.onForwardNavigation.loadingScreenItems;
            })
                .subscribe(function (runPage) {
                var data = runPage.onForwardNavigation.loadingScreenItems.map(function (o) { return ({ label: o.isResource ? _this._translate.instant(o.itemLabel) : o.itemLabel, done: false }); });
                Rx.Observable.from(runPage.onForwardNavigation.loadingScreenItems.map(function (o) { return o.milisecDelay; }))
                    .map(function (delay, index) { return Rx.Observable.timer(delay).map(function () { return index; }); })
                    .concatAll()
                    .subscribe(function (index) { return data[index].done = true; });
                var sum = runPage.onForwardNavigation.loadingScreenItems.reduce(function (acc, i, index, arr) { return index == arr.length - 1 ? acc + (i.milisecDelay * 0.1) : acc + i.milisecDelay; }, 0);
                _this.percent = 0;
                Rx.Observable.interval(sum / 100).take(100).subscribe(function (i) { return _this.percent++; });
                _this.source = data;
            }),
            this._route.params.subscribe(function (p) {
                _this.page = p["page"];
            })
        ];
    };
    LoadingStepComponent = __decorate([
        core_1.Component({ template: require('./loadingStep.html'), moduleId: module.id }), 
        __metadata('design:paramtypes', [Router.ActivatedRoute, services_1.ConfigService, services_1.TranslateService])
    ], LoadingStepComponent);
    return LoadingStepComponent;
}(reactiveComponent_1.ReactiveComponent));
exports.LoadingStepComponent = LoadingStepComponent;
var BlankTransitionComponent = (function () {
    function BlankTransitionComponent(_route, _router, _service) {
        this._route = _route;
        this._router = _router;
        this._service = _service;
        _router.events.filter(function (o) { return o instanceof Router.NavigationEnd; }).filter(function (o) { return o.url.indexOf('~inProgress') !== -1; }).subscribe(function (o) {
            if (!_service.navigation.inProgress)
                _router.navigate(['../'], { relativeTo: _route });
        });
    }
    BlankTransitionComponent = __decorate([
        core_1.Component({ template: '' }), 
        __metadata('design:paramtypes', [Router.ActivatedRoute, Router.Router, services_1.SiteHeaderService])
    ], BlankTransitionComponent);
    return BlankTransitionComponent;
}());
exports.BlankTransitionComponent = BlankTransitionComponent;



},{"../@toolkit/reactiveComponent":"@toolkit/reactiveComponent","../@toolkit/services":"@toolkit/services","./loadingStep.html":108,"@angular/core":"@angular/core","@angular/router":"@angular/router","rxjs":"rxjs"}],110:[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var Router = require('@angular/router');
var ModelPages = require('./modelPages');
var activeRun_1 = require('./activeRun');
var AccountPages = require('../account/accountPages');
var services_1 = require('../@toolkit/services');
var backend_1 = require('../@toolkit/backend');
var ng2_toastr_1 = require('ng2-toastr');
var ReactiveComponent_1 = require('../@toolkit/ReactiveComponent');
var notFoundPage_1 = require('../notFoundPage');
var ModuleLandingComponent = (function (_super) {
    __extends(ModuleLandingComponent, _super);
    function ModuleLandingComponent(_config, _clientService, _activatedRoute, _toastr, _translate, _userService, _applicationInsightsService, _router) {
        _super.call(this);
        this._config = _config;
        this._clientService = _clientService;
        this._activatedRoute = _activatedRoute;
        this._toastr = _toastr;
        this._translate = _translate;
        this._userService = _userService;
        this._applicationInsightsService = _applicationInsightsService;
        this._router = _router;
    }
    ModuleLandingComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._subscriptions = [this._userService.userInfo.filter(function (info) { return info.determined && info.loggedOn && !info.details.noRole; })
                .subscribe(function () {
                _this._translate.get('HOMEPAGE.SELECT_CLIENT_TOAST').subscribe(function (v) { return _this._toastr.info(v); });
                _this._clientService.currentClient = null;
                _this.gaInit();
            }),
        ];
    };
    ModuleLandingComponent.prototype.gaInit = function () {
        this._applicationInsightsService.send({
            eventCategory: 'Client - Runs',
            eventAction: 'PageLoaded'
        }, false);
    };
    ModuleLandingComponent = __decorate([
        core_1.Component({
            template: "",
            moduleId: module.id,
        }), 
        __metadata('design:paramtypes', [services_1.ConfigService, services_1.ClientService, Router.ActivatedRoute, ng2_toastr_1.ToastsManager, services_1.TranslateService, services_1.UserService, services_1.ApplicationInsightsService, Router.Router])
    ], ModuleLandingComponent);
    return ModuleLandingComponent;
}(ReactiveComponent_1.ReactiveComponent));
exports.ModuleLandingComponent = ModuleLandingComponent;
var RouterOutletComponet = (function () {
    function RouterOutletComponet() {
    }
    RouterOutletComponet = __decorate([
        core_1.Component({
            template: "\n<div>\n  <router-outlet></router-outlet>\n</div>",
            moduleId: module.id,
            directives: [Router.ROUTER_DIRECTIVES]
        }), 
        __metadata('design:paramtypes', [])
    ], RouterOutletComponet);
    return RouterOutletComponet;
}());
exports.RouterOutletComponet = RouterOutletComponet;
var BlankComponent = (function () {
    function BlankComponent() {
    }
    BlankComponent = __decorate([
        core_1.Component({ template: '' }), 
        __metadata('design:paramtypes', [])
    ], BlankComponent);
    return BlankComponent;
}());
exports.BlankComponent = BlankComponent;
var DummyComponent = (function () {
    function DummyComponent() {
    }
    DummyComponent = __decorate([
        core_1.Component({ template: '<div>foobar</div>' }), 
        __metadata('design:paramtypes', [])
    ], DummyComponent);
    return DummyComponent;
}());
exports.DummyComponent = DummyComponent;
function RouteGenerator(model) {
    var srcs = function (source) { return (source || []).reduce(function (acc, rp) { return acc.concat([rp.srcUrl], srcs(rp.children)); }, []); };
    var indexComponents = {};
    var promises = [];
    var transitionPages = [{
            path: '~loading/:page',
            component: ModelPages.LoadingStepComponent
        },
        {
            path: '~inProgress',
            component: ModelPages.BlankTransitionComponent
        }
    ];
    srcs(model.runPages).forEach(function (src) {
        if (!indexComponents[src]) {
            indexComponents[src] = true;
            var promise = System.import(backend_1.Api.ProxyProxy.redirector_url("clientside/" + src).url);
            promises.push(promise);
            promise.then(function (component) { return indexComponents[src] = component; });
        }
    });
    return Promise.all(promises).then(function () {
        var services = [];
        var transformRoutes = function (rps) {
            return rps.map(function (runPage, index) {
                var module = indexComponents[runPage.srcUrl];
                runPage.$$module = module;
                var component = module[Object.keys(module)[0]];
                Object.keys(module).slice(1).forEach(function (key) { return services.push(module[key]); });
                var route = { path: runPage.identifier, component: component, canDeactivate: [activeRun_1.ProgressionGuard], canActivate: [activeRun_1.JumpGuard] };
                if (runPage.children && runPage.children.length) {
                    route.children = transformRoutes(runPage.children);
                }
                if (index == 0)
                    return [{ path: '', terminal: true, redirectTo: runPage.identifier },
                        route];
                else
                    return [route];
            }).reduce(function (acc, item) { return acc.concat(item); }, transitionPages);
        };
        var runPages = transformRoutes(model.runPages || []);
        var ret = {
            children: [
                {
                    path: '',
                    component: ModuleLandingComponent,
                    terminal: true
                },
                {
                    path: 'runs/:id',
                    component: ModelPages.RunsPage,
                    canActivate: [AccountPages.HasRolesGuard]
                },
                {
                    path: 'run/:runid',
                    component: ModelPages.ActiveRunPage,
                    canActivate: [AccountPages.HasRolesGuard],
                    children: runPages
                },
                {
                    path: 'login',
                    component: AccountPages.LoginPage
                },
                {
                    path: 'norole',
                    component: AccountPages.NoRolePage,
                    terminal: true
                },
                { path: '**', component: notFoundPage_1.NotFoundPage }
            ],
            component: RouterOutletComponet,
            path: '',
        };
        return { routes: [ret], services: services };
    });
}
exports.RouteGenerator = RouteGenerator;
;
exports.GUARDS = [activeRun_1.ProgressionGuard, AccountPages.HasRolesGuard, activeRun_1.JumpGuard];



},{"../@toolkit/ReactiveComponent":2,"../@toolkit/backend":"@toolkit/backend","../@toolkit/services":"@toolkit/services","../account/accountPages":94,"../notFoundPage":119,"./activeRun":105,"./modelPages":111,"@angular/core":"@angular/core","@angular/router":"@angular/router","ng2-toastr":"ng2-toastr"}],111:[function(require,module,exports){
"use strict";
var activeRun_1 = require('./activeRun');
exports.ActiveRunPage = activeRun_1.ActiveRunPage;
exports.ProgressionGuard = activeRun_1.ProgressionGuard;
var newRun_1 = require('./newRun');
exports.NewRunPage = newRun_1.NewRunPage;
var runsPage_1 = require('./runsPage');
exports.RunsPage = runsPage_1.RunsPage;
var runList_1 = require('./runList');
exports.RunListPage = runList_1.RunListPage;
var loadingStep_1 = require('./loadingStep');
exports.LoadingStepComponent = loadingStep_1.LoadingStepComponent;
exports.BlankTransitionComponent = loadingStep_1.BlankTransitionComponent;



},{"./activeRun":105,"./loadingStep":109,"./newRun":113,"./runList":115,"./runsPage":117}],112:[function(require,module,exports){
module.exports = '<!--<div class="grid padded">\n    <div class="col-dt-1 col-ipl-1 col-ipp-1">\n        <div class="module">\n            <div class="module-header">{{\'RUN.CREATE.TITLE\'|translate:{client:currentClient?.displayName} }}</div>\n            <div class="module-content border">-->\n<form #createForm="ngForm">\n    <table class="pretty" ngModelGroup #main="ngModelGroup">\n        <tr>\n            <td>\n                {{\'RUN.CREATE.LABEL.NAME\'|translate}}\n                <input type="text" style="width: 100%; margin-top: 5px;" maxlength="100" [(ngModel)]="editedRun.name" required not-blank trim name="name" />\n            </td>\n        </tr>\n        <tr>\n            <td style="padding-top: 10px">\n                {{\'RUN.CREATE.LABEL.DESCRIPTION\'|translate}}\n                <textarea rows="5" style="width: 100%; margin-top: 5px; resize: none;" maxlength="4000" [(ngModel)]="editedRun.description" required not-blank trim name="description"></textarea>\n            </td>\n        </tr>\n    </table>\n    <div *dynamicChild="runOptionsType;options: componentOptions">\n\n    </div>\n    <div *ngIf="requiredFields?.length && editedRun.clientDetails" style="margin-top: 10px">\n        <expander #expander>\n            <table class="pretty">\n                <tr>\n                    <td colspan="2">\n                        {{\'RUN.CREATE.LABEL.REQUIRED_CLIENT_DETAILS\'|translate}}\n                    </td>\n                </tr>\n                <tr *ngFor="let item of requiredFields">\n                    <td style="width: 15%">\n                        {{\'RUN.CREATE.LABEL.DETAILS.\'+item.fieldName.toUpperCase()|translate}}\n                        <div class="help" [tooltip]="referenceTranslationService.refDataTranslation[item.tooltipKey] || item.tooltip"></div>\n                    </td>\n                    <td><input type="text" [numberFormat]="item.numberFormat||\'number\'" [(ngModel)]="editedRun.clientDetails[item.fieldName]" required name="details.{{item.fieldName}}" [min]="item.minValueString" [max]="item.maxValueString"/></td>\n                </tr>\n            </table>\n\n        </expander>\n        <button class="metro-button bottom-right" (click)="expander.open() || createRun()" [disabled]="!createForm.form.valid && expander.isOpen || !main.valid">{{\'RUN.CREATE.BTN\'|translate}}</button>\n    </div>\n\n    <button *ngIf="!(requiredFields?.length && editedRun.clientDetails)" class="metro-button bottom-right" (click)="createRun()" [disabled]="!createForm.form.valid">{{\'RUN.CREATE.BTN\'|translate}}</button>\n    <div class="clear"></div>\n</form>';
},{}],113:[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var services_1 = require('../@toolkit/services');
var backend_1 = require('../@toolkit/backend');
var ng2_toastr_1 = require('ng2-toastr');
var router_1 = require('@angular/router');
var ReactiveComponent_1 = require('../@toolkit/ReactiveComponent');
var rx_1 = require('rxjs');
var dynamicChild_1 = require('../dynamicChild');
var directives_1 = require('../@toolkit/directives');
var casingPipes_1 = require('../@toolkit/src/pipes/casingPipes');
var NewRunPage = (function (_super) {
    __extends(NewRunPage, _super);
    function NewRunPage(_config, _toastr, _clients, _router, _activatedRoute, _translate, _api, _users, _userService, _applicationInsightsService, referenceTranslationService) {
        var _this = this;
        _super.call(this);
        this._config = _config;
        this._toastr = _toastr;
        this._clients = _clients;
        this._router = _router;
        this._activatedRoute = _activatedRoute;
        this._translate = _translate;
        this._api = _api;
        this._users = _users;
        this._userService = _userService;
        this._applicationInsightsService = _applicationInsightsService;
        this.referenceTranslationService = referenceTranslationService;
        this.componentOptions = [{ name: "setOptions", value: function (options) { return _this.editedOptions = options; } }];
        this.camelCase = new casingPipes_1.CamelPipe();
    }
    Object.defineProperty(NewRunPage.prototype, "currentClient", {
        get: function () { return this._clients.currentClient; },
        enumerable: true,
        configurable: true
    });
    NewRunPage.prototype.ngOnInit = function () {
        var _this = this;
        this.editedRun = { name: '', description: '', clientId: 0, clientDetails: null, options: null, userAssignedClientDetails: null };
        this._subscriptions = [
            this._config.currentModelChanged
                .do(function (model) { return _this._requiredFields = model && model.requiredClientDetails && model.requiredClientDetails.fields.map(function (c) { return Object.assign(c, { fieldName: _this.camelCase.transform(c.fieldName) }); }); })
                .flatMap(function (model) {
                if (!model || !model.runOptionsSrcUrl)
                    return rx_1.Observable.empty();
                var url = backend_1.Api.ProxyProxy.redirector_url("clientside/" + model.runOptionsSrcUrl).url;
                return rx_1.Observable.fromPromise(System.import(url).then(function (module) { return module[Object.keys(module)[0]]; }));
            }).subscribe(function (type) { return _this.runOptionsType = type; }),
            this._clients.currentClientChanged.filter(function (c) { return !!c; }).flatMap(function (c) { return _this._clients.getDetails(c.clientId).uiSignal('client details'); }).subscribe(function (details) {
                _this.originalDetails = details;
                if (_this.expander)
                    _this.expander.isOpen = false;
                _this.editedRun = { name: '', description: '', clientId: Number(details.id), clientDetails: Object.assign({}, details) };
            })
        ];
    };
    Object.defineProperty(NewRunPage.prototype, "requiredFields", {
        get: function () {
            var _this = this;
            if (!this._requiredFields)
                return [];
            this._requiredFields.forEach(function (c) {
                var aux = c;
                aux.tooltipKey = 'METRICSORDER_' + c.fieldName.split(' ').join().toUpperCase() + '_TOOLTIP';
            });
            return this._requiredFields &&
                this.originalDetails &&
                this._requiredFields.filter(function (o) { return _this.originalDetails[o.fieldName] == null; });
        },
        enumerable: true,
        configurable: true
    });
    NewRunPage.prototype.createRun = function () {
        var _this = this;
        this._api.createRun(this._config.currentModel.modelName, Object.assign({ options: this.editedOptions, userAssignedClientDetails: this.requiredFields.map(function (o) { return o.fieldName; }) }, this.editedRun)).uiSignal({ debugInfo: 'create run', uiLabel: this._translate.instant('GLOBAL.BUSY.CREATING_RUN') }).subscribe(function (ret) {
            _this.gaInit(ret.data.id);
            _this._router.navigate(['../../run', ret.data.id], { relativeTo: _this._activatedRoute });
        });
    };
    NewRunPage.prototype.gaInit = function (runId) {
        this._applicationInsightsService.send({
            eventCategory: 'Client - Runs',
            eventAction: 'RunCreated',
            runId: runId
        });
    };
    __decorate([
        core_1.ViewChild(directives_1.ExpanderComponent), 
        __metadata('design:type', directives_1.ExpanderComponent)
    ], NewRunPage.prototype, "expander", void 0);
    NewRunPage = __decorate([
        core_1.Component({
            selector: 'new-run',
            template: require('./newRun.html'),
            moduleId: module.id,
            directives: [directives_1.VALIDATORS, directives_1.CUSTOM_VALUE_ACCESSORS, directives_1.ExpanderComponent, directives_1.TOOLTIP, dynamicChild_1.CreateDynamicChildDirective]
        }), 
        __metadata('design:paramtypes', [services_1.ConfigService, ng2_toastr_1.ToastsManager, services_1.ClientService, router_1.Router, router_1.ActivatedRoute, services_1.TranslateService, backend_1.Api.RunsProxy, backend_1.Api.UserProxy, services_1.UserService, services_1.ApplicationInsightsService, services_1.ReferenceTranslationService])
    ], NewRunPage);
    return NewRunPage;
}(ReactiveComponent_1.ReactiveComponent));
exports.NewRunPage = NewRunPage;



},{"../@toolkit/ReactiveComponent":2,"../@toolkit/backend":"@toolkit/backend","../@toolkit/directives":"@toolkit/directives","../@toolkit/services":"@toolkit/services","../@toolkit/src/pipes/casingPipes":69,"../dynamicChild":103,"./newRun.html":112,"@angular/core":"@angular/core","@angular/router":"@angular/router","ng2-toastr":"ng2-toastr","rxjs":"rxjs"}],114:[function(require,module,exports){
module.exports = '<div style="height: 45px">\n	<div class="filter-box left thin">\n		<div>\n			{{\'RUN.SAVED.PAGE_SIZE\'|translate}}\n			<label class="tab-check" *ngFor="let filterValue of [\'RUN.SAVED.ALL\'|translate,10,25,50]">\n				<input type="radio" [(ngModel)]="limitSize" [value]="filterValue" name="rowFilter.{{filterValue}}" />\n				<span class="bold">{{filterValue}}</span>\n			</label>\n		</div>\n	</div>\n	<div class="filter-box left thin">\n		<div>\n			<label class="tab-check" *ngFor="let filterValue of filterValues">\n\n				<input type="radio" [(ngModel)]="userFilter" [value]="filterValue" name="userFilter.{{filterValue}}" />\n				<span class="bold">{{(\'RUN.SAVED.USER_FILTER.\'+(filterValue||\'all\').toUpperCase())|translate}}</span>\n			</label>\n		</div>\n	</div>\n	<div class="filter-box left thin self-centering">\n		<div>\n			{{\'RUN.SAVED.DATE_FILTER.LABEL\'|translate}}\n			<click-input [placeholder]="\'RUN.SAVED.DATE_FILTER.ANYTIME\'|translate" style="font-weight:bold">\n				<input type="date" [(ngModel)]="dateFilter.from" name="dateFilterFrom" (ngModelChange)="applyFilters()" />\n			</click-input>\n			{{\'RUN.SAVED.DATE_FILTER.AND\'|translate}}\n			<click-input [placeholder]="\'RUN.SAVED.DATE_FILTER.ANYTIME\'|translate" style="font-weight:bold">\n				<input type="date" [(ngModel)]="dateFilter.to" name="dateFilterTo" (ngModelChange)="applyFilters()" />\n			</click-input>\n		</div>\n	</div>\n	<div class="filter-box left thin self-centering">\n		<div>\n			<click-input [placeholder]="\'RUN.SAVED.SEARCH_BY.PLACEHOLDER\'|translate" style="font-weight: bold">\n				<input [(ngModel)]="searchExp" trim />\n			</click-input>\n		</div>\n	</div>\n	<div class="filter-box left thin self-centering">\n		<div class="quick-button" (click)="clearFilters()">{{\'RUN.SAVED.CLEAR_FILTERS\'|translate}}</div>\n	</div>\n</div>\n\n\n<table class="pretty lined selectable scrollable scrollable-450" [class.descending]="descending">\n    <thead>\n        <tr>\n            <th style="width: 30%" class="sorting-header" (click)="sortBy=\'name\'" [class.active]="sortBy===\'name\'"><span>{{\'RUN.SAVED.TABLE.NAME\'|translate}}</span></th>\n            <th style="width: 87px">&nbsp;</th>\n            <!--<th style="width: 18%" class="sorting-header" (click)="sortBy=\'description\'" [class.active]="sortBy===\'description\'"><span>{{\'RUN.SAVED.TABLE.DESCRIPTION\'|translate}}</span></th>-->\n            <th style="width: 15%" class="sorting-header" (click)="sortBy=\'creatorUserDisplayName\'" [class.active]="sortBy===\'creatorUserDisplayName\'"><span>{{\'RUN.SAVED.TABLE.CREATED_BY\'|translate}}</span></th>\n            <!--<th style="width: 15%" class="sorting-header" (click)="sortBy=\'userDisplayName\'" [class.active]="sortBy===\'userDisplayName\'"><span>{{\'RUN.SAVED.TABLE.LAST_SAVED_BY\'|translate}}</span></th>-->\n            <th style="width: 10%" class="sorting-header" (click)="sortBy=\'createDate\'" [class.active]="sortBy===\'createDate\'"><span>{{\'RUN.SAVED.TABLE.DATE_CREATED\'|translate}}</span></th>\n            <th style="width: 10%" *ngIf="!isMultipleFinalRuns" class="sorting-header" (click)="sortBy=\'isFinalized\'" [class.active]="sortBy===\'isFinalized\'"><span>{{\'RUN.SAVED.TABLE.FINAL\'|translate}}</span></th>\n            <th style="width: 10%" *ngIf="isMultipleFinalRuns" class="sorting-header" (click)="sortBy=\'isFinalRunSelected\'" [class.active]="sortBy===\'isFinalRunSelected\'"><span>{{\'RUN.SAVED.TABLE.FINAL_COVERAGES\'|translate}}</span></th>\n            \n            <th *ngIf="isDemoClient" style="width: 10%" class="sorting-header" (click)="sortBy=\'isProspect\'" [class.active]="sortBy===\'isProspect\'"><span>{{\'RUN.SAVED.TABLE.PROSPECT\'|translate}}</span></th>\n            <!--<th style="width: 10%" class="sorting-header" (click)="sortBy=\'saveDate\'" [class.active]="sortBy===\'saveDate\'"><span>{{\'RUN.SAVED.TABLE.LAST_SAVED_DATE\'|translate}}</span></th>-->\n            <th [hidden]="!hasOptions" style="width: 20%">\n                <template #headerAnchor>\n                </template>\n            </th>\n            <th style="width: 15%">&nbsp;</th>\n        </tr>\n    </thead>\n    <tbody>\n        <template let-row ngFor [ngForOf]="filteredRuns">\n            <tr (click)="changeRow(row)" (dblclick)="load(row.runId,true)" [scrollTo]="\'run-row-\'+row.runId" delay="250" [class.selected]="selectedRun===row" id="{{i===0?\'run-row-first\':\'\'}}">\n                <td style="width: 30%" id="run-row-{{row.runId}}" class="ellipsis-cell">\n                    <span *ngIf="row.info.isReadonly"><i class="icon-lock" title="{{\'RUN.READONLY\'|translate}}"></i></span>\n                    <span *ngIf="row.info.isSystemGenerated"><i class="icon-cog" title="{{\'RUN.CMO\'|translate}}"></i></span>\n                    <click-input [disabled]="row.info.isReadonly">\n                        <input [(ngModel)]="row.info.name" required not-blank trim maxlength="100" name="runs.{{row.runId}}.info.name" style="width: 100%" />\n                    </click-input>\n                </td>\n                <td style="width: 87px; padding: 0;"><i *ngIf="row.info.sharedWith?.length" class="muted">{{\'RUN.SAVED.SHARED_LABEL\'|translate}}</i></td>\n                <td style="width: 15%">{{row.info.creatorUserDisplayName}}</td>\n                <td style="width: 10%">{{row.info.createDate | localeDate:\'dd MMM y\'}}</td>\n                <td style="width: 10%"><span *ngIf="row.info.isFinalized && !isMultipleFinalRuns" [tooltip]="\'RUN.FINAL.LABEL.MARK_BY\'|translate:{user:row?.info?.finalStatusChangedBy,finaldate:row?.info?.finalStatusChangedOn|date:\'dd MMM y\'}"class="icon-tick"></span>\n                <span *ngIf="isMultipleFinalRuns">\n\n                    <span *ngFor="let lobs of row.info.finalCoverages let idx = index" style="padding-right: 5px">\n                        <span>{{lobs}} </span>\n                    </span>\n                </span>\n               </td>\n                <td *ngIf="isDemoClient" style="width: 10%">\n                    <input *ngIf="row.info.isProspect" type="checkbox" class="circle-check" [tooltip]="\'RUN.PROSPECT.LABEL.MARK_BY\'|translate:{user:row?.info?.prospectStatusChangedBy,prospectdate:row?.info?.prospectStatusChangedOn|date:\'dd MMM y\'}" [(ngModel)]="row.info.isProspect" (change)="prospect($event.target.checked,row)" /> <input type="checkbox" class="circle-check" [tooltip]="\'RUN.PROSPECT.LABEL.CHK\'|translate" [(ngModel)]="row.info.isProspect" (change)="prospect($event.target.checked,row)" *ngIf="!row.info.isProspect" />\n                </td>\n                <td [hidden]="!hasOptions" style="width: 20%">\n                    <template [ngTemplateOutlet]="optionsItemTemplate" [ngOutletContext]="{$implicit: row.options}">\n                    </template>\n                </td>\n                <td style="width: 15%" class="right-align">\n                    <div *ngIf="changeTracker.isChangedAt([\'runs\',row.runId])" style="display:inline-flex">\n                        <button (click)="save(row.info)" class="metro-button-thin">{{\'GLOBAL.BTN.SAVE\'|translate}}</button>\n                        <button (click)="changeTracker.undo([\'runs\',row.runId,\'info\'])" class="metro-button-thin">{{\'GLOBAL.BTN.UNDO\'|translate}}</button>\n                    </div>\n                </td>\n            </tr>\n            <tr *ngIf="selectedRun===row" class="selected arrow">\n                <td colspan="6" style="position:relative;padding:9px 15px;background-color:#efefef;">\n                    <template [ngIf]="!sharingOptions.open">\n\n                        <table>\n							<tr>\n								<!--<td><b>Progress</b></td>-->\n								<td><progress-indicator [run]="selectedRun"></progress-indicator></td>\n							</tr>\n                            <tr>\n                                <!--<td><b>Description</b></td>-->\n                                <td>\n                                    <!--<click-input [disabled]="row.info.isReadonly">-->\n                                    <textarea *ngIf="!row.info.isReadonly" [(ngModel)]="row.info.description"   required not-blank maxlength="4000" name="runs.{{row.runId}}.info.description" rows="3" style="width: 100%; resize: none;" trim></textarea>\n                                    <span *ngIf="row.info.isReadonly">{{row.info.description}}</span>\n                                    <!--</click-input>-->\n                                </td>\n                            </tr>\n                            <tr>\n                                <!--<td><b>{{\'RUN.SAVED.TABLE.LAST_SAVED_BY\'|translate}}</b></td>-->\n                                <td>\n                                    {{\'RUN.SAVED.TABLE.LAST_SAVED_BY\'|translate}}\n                                    <b>{{row.info.userDisplayName}}</b> {{\'RUN.FOOTER.ON\'|translate}}\n                                    <b>{{row.info.saveDate | localeDate:\'dd MMM y\'}}</b>\n                                </td>\n                            </tr>\n                        </table>\n\n                        <div style="margin-top:20px">\n                            <button class="metro-button left" (click)="delete(selectedRun.runId)">\n                                {{\'RUN.SAVED.BTN.DELETE\'|translate}}\n                            </button>\n                            <p class="left" *ngIf="!isMultipleFinalRuns">\n                                <input type="checkbox" *ngIf="row.info.isFinalized" [tooltip]="\'RUN.FINAL.LABEL.MARK_BY\'|translate:{user:row?.info?.finalStatusChangedBy,finaldate:row?.info?.finalStatusChangedOn|date:\'dd MMM y\'}" class="circle-check" [(ngModel)]="row.info.isFinalized" (change)="final($event.target.checked,row)" />\n                                <input type="checkbox" *ngIf="!row.info.isFinalized" [tooltip]="\'RUN.FINAL.LABEL.CHK\'|translate" class="circle-check" [(ngModel)]="row.info.isFinalized" (change)="final($event.target.checked,row)" />\n                                {{\'RUN.FINAL.LABEL.CHK\'|translate}}                            </p>\n                            <p class="left" *ngIf="isMultipleFinalRuns">\n                                <input type="checkbox"  name="selectFinalRun" [(ngModel)]="row.info.isFinalRunSelected" class="circle-check" (change)="final(true,row)" />\n                                {{\'RUN.FINAL.LABEL.CHK\'|translate}}\n                                <input type="checkbox" *ngIf="row.info?.finalCoverages !=null && row.info?.finalCoverages?.length > 0" [(ngModel)]="isUnmarkFinalRunSelected" name="deselectFinalRun1" class="circle-check" (change)="final(false,row)" />\n                                <span *ngIf="row.info?.finalCoverages !=null && row.info?.finalCoverages?.length > 0">{{\'RUN.FINAL.LABEL.DESELECT\'|translate}}</span>\n                            </p>\n                            <button class="metro-button right" (click)="load(selectedRun.runId)" [routerLink]="[\'../../run\', selectedRun.runId]">\n                                {{\'RUN.SAVED.BTN.LOAD\'|translate}}\n                            </button>\n\n                            <button class="metro-button right" style="margin-right:5px" (click)="share(selectedRun)" [scrollTo]="\'run-row-\'+selectedRun?.runId" delay="750">\n                                {{(selectedRun?.info?.sharedWith?.length?\'RUN.SAVED.BTN.SHARE_MANAGE\':\'RUN.SAVED.BTN.SHARE_NEW\')|translate}}\n                            </button>\n                            <button *ngIf="(modell !== \'dno\'&& modell !== \'dnorc\') || ((modell === \'dno\'||modell === \'dnorc\') && (currentUser.role ===\'Administrator\'))" class="metro-button right" style="margin-right:5px" (click)="clone(selectedRun.runId)" [scrollTo]="\'run-row-first\'" delay="1000">\n                                {{\'RUN.SAVED.BTN.CLONE\'|translate}}\n                            </button>\n                        </div>\n\n                    </template>\n                    <template [ngIf]="sharingOptions.open">\n\n\n\n                        {{\'RUN.SAVED.SHARING_OPTIONS.SEARCH\'|translate}}&nbsp;&nbsp;\n\n\n                        <autocomplete [dataSource]="searchUser" (enter)="addShare($event)">\n                            <template let-item="item">\n                                <div title="{{item.displayName}}" style="padding: 3px;">\n                                    <p style="margin-bottom: 3px;">\n                                        <b>{{item.displayName}}</b>\n                                    </p>{{item.emailAddress}}\n                                </div>\n                            </template>\n                        </autocomplete>\n\n\n\n                        <table class="pretty lined" style="margin:15px 0;">\n                            <thead>\n                                <tr>\n                                    <th>{{\'RUN.SAVED.SHARING_OPTIONS.TABLE.USER\'|translate}}</th>\n                                    <th></th>\n                                    <th>{{\'RUN.SAVED.SHARING_OPTIONS.TABLE.SHARED_SINCE\'|translate}}</th>\n                                    <th></th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr *ngFor="let share of sharingOptions.sharedWith">\n                                    <td>{{share.userDisplayName}}</td>\n                                    <td>{{share.userName}}</td>\n                                    <td>{{share.shareDate| localeDate:\'dd MMM y\'}}</td>\n                                    <td class="snug"><button class="metro-button-thin" (click)="removeShare(share)">{{\'RUN.SAVED.SHARING_OPTIONS.TABLE.BTN_REMOVE\'|translate}}</button></td>\n                                </tr>\n                                <tr *ngIf="!sharingOptions.sharedWith?.length">\n                                    <td colspan="3">{{\'RUN.SAVED.SHARING_OPTIONS.NOT_SHARED\'|translate}}</td>\n                                </tr>\n                            </tbody>\n                        </table>\n\n                        <button class="metro-button left" (click)="hideSharing()">{{\'GLOBAL.BTN.CANCEL\'|translate}}</button>\n\n\n                        <button [disabled]="!sharingOptions.changes ||!(sharingOptions.sharedWith?.length || sharingOptions.deleting)"\n                                (click)="saveSharing()" class="metro-button right">\n                            <!--<span [ngClass]="{\'icon-plus\':sharingOptions.firstTime, \'icon-floppy-disk\': !sharingOptions.firstTime && !sharingOptions.deleting, \'icon-bin\': sharingOptions.deleting}"></span>-->\n                            <span *ngIf="sharingOptions.firstTime">{{\'RUN.SAVED.SHARING_OPTIONS.BTN.FIRST_TIME\'|translate}}</span>\n                            <span *ngIf="!sharingOptions.firstTime && !sharingOptions.deleting">{{\'RUN.SAVED.SHARING_OPTIONS.BTN.SAVE_CHANGES\'|translate}}</span>\n                            <span *ngIf="sharingOptions.deleting">{{\'RUN.SAVED.SHARING_OPTIONS.BTN.DELETE\'|translate}}</span>\n                        </button>\n\n\n                    </template>\n                </td>\n            </tr>\n        </template>\n    </tbody>\n</table>\n\n<div class="clear"></div>';
},{}],115:[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var reactiveComponent_1 = require('../@toolkit/reactiveComponent');
var services_1 = require('../@toolkit/services');
var backend_1 = require('../@toolkit/backend');
var vex_1 = require('angular2-modal/plugins/vex');
var router_1 = require('@angular/router');
var rx_1 = require('rxjs');
var dynamicChild_1 = require('../dynamicChild');
var directives_1 = require('../@toolkit/directives');
var components_1 = require('../@toolkit/components');
var CT2 = require('../@toolkit/changeTracking');
var core_2 = require('angular2-cookie/core');
var moment = require('moment/moment');
var FinalRunModalSelect_1 = require('../@toolkit/src/components/FinalRunModalSelect');
var FinalRunModalDeselect_1 = require("../@toolkit/src/components/FinalRunModalDeselect");
var LIMITSIZE_COOKIENAME = "runMgmtLimitSize";
var RunListPage = (function (_super) {
    __extends(RunListPage, _super);
    function RunListPage(_clients, _config, _runs, _users, _userService, _resolver, _router, _translate, _applicationInsightsService, _cookies, _pageService, _activatedRoute, _modal, _sharedDataService) {
        var _this = this;
        _super.call(this);
        this._clients = _clients;
        this._config = _config;
        this._runs = _runs;
        this._users = _users;
        this._userService = _userService;
        this._resolver = _resolver;
        this._router = _router;
        this._translate = _translate;
        this._applicationInsightsService = _applicationInsightsService;
        this._cookies = _cookies;
        this._pageService = _pageService;
        this._activatedRoute = _activatedRoute;
        this._modal = _modal;
        this._sharedDataService = _sharedDataService;
        this.theme = 'default';
        this.isDemoClient = false;
        this.isUnmarkFinalRunSelected = false;
        this.sharingOptions = {};
        this.searchUser = function (term) {
            return _this._users.find(term);
        };
        this.descending = false;
        this.filterValues = ['', 'creator', 'sharer', 'sharedWith', 'final'];
        this._userFilter = '';
        this.dateFilter = { from: null, to: null };
        var limitValue = this._cookies.get(LIMITSIZE_COOKIENAME);
        if (limitValue) {
            this._limit = limitValue === "All" ? "All" : parseInt(limitValue);
        }
        else
            this._limit = 10;
    }
    Object.defineProperty(RunListPage.prototype, "runs", {
        get: function () {
            return this._underlyingRuns;
        },
        set: function (val) {
            this._underlyingRuns = val;
            this.applyFilters();
        },
        enumerable: true,
        configurable: true
    });
    RunListPage.prototype.ngOnInit = function () {
        var _this = this;
        this._subscriptions = [
            this._config.currentModelChanged
                .combineLatest(this._clients.currentClientChanged)
                .flatMap(function (opt) { return _this._runs.list(opt[0].modelId, opt[1].clientId).uiSignal('load run list'); })
                .subscribe(function (ret) {
                _this.runs = ret.data.sort(function (a, b) { return new Date(b.info.createDate).getTime() -
                    new Date(a.info.createDate).getTime(); });
                _this.changeTracker.commit();
            }),
            this._config.currentModelChanged.do(function () { return _this.hasOptions = false; })
                .flatMap(function (model) {
                if (!model || !model.runOptionsListDisplaySrcUrl)
                    return rx_1.Observable.empty();
                var url = backend_1.Api.ProxyProxy.redirector_url("clientside/" + model.runOptionsListDisplaySrcUrl).url;
                return rx_1.Observable.fromPromise(System.import(url).then(function (module) { return module[Object.keys(module)[0]]; }));
            })
                .flatMap(function (component) { return _this._resolver.resolveComponent(component); })
                .subscribe(function (factory) {
                _this._component = dynamicChild_1.createDynamicChild(factory, _this.runOptionsView, 0);
                _this.hasOptions = true;
            }), this._clients.currentClientChanged
                .subscribe(function (c) {
                _this.currentClient = c;
                _this.demoClient(_this.currentClient.clientId);
                if (_this._config.currentModel.useMultipleFinalRun) {
                    _this.finalRuns = [];
                    _this._runs.getFullFinalRuns(_this._config.currentModel.modelId, _this.currentClient.clientId).subscribe(function (x) {
                        _this.finalRuns = x.data;
                    });
                }
            }),
            this._userService.userInfo.subscribe(function (info) {
                _this.currentUser = info.details;
            }),
            this._config.currentModelChanged.subscribe(function (m) { _this.modell = m.modelName; }),
        ];
        this._translate.onLangChange.subscribe(function (e) {
            var prevlimitSize = _this.limitSize;
            _this.limitSize = 0;
            setTimeout(function () { return _this.limitSize = prevlimitSize; }, 10);
        });
        this.isMultipleFinalRuns = this._config.currentModel.useMultipleFinalRun;
    };
    RunListPage.prototype.demoClient = function (clientId) {
        var _this = this;
        this._config.settings.subscribe(function (o) {
            if (o.demoClientIds.find(function (o) { return o == clientId; })) {
                _this.isDemoClient = true;
                if (!_this.filterValues.find(function (o) { return o === 'prospect'; })) {
                    _this.filterValues.push('prospect');
                }
            }
            else {
                _this.isDemoClient = false;
                _this.filterValues = _this.filterValues.filter(function (o) { return o !== 'prospect'; });
            }
        });
    };
    RunListPage.prototype.delete = function (runId) {
        var _this = this;
        rx_1.Observable.fromPromise(this._modal.confirm().message(this._translate.instant('RUN.SAVED.MESSAGE.DELETE_RUN'))
            .okBtn(this._translate.instant('GLOBAL.YES'))
            .cancelBtn(this._translate.instant('GLOBAL.NO'))
            .open()
            .then(function (dialog) { return dialog.result.then(function () { return true; }, function () { return false; }); }))
            .filter(function (ok) { return ok; })
            .flatMap(function () { return _this._runs.delete(runId).uiSignal({ debugInfo: 'delete run', uiLabel: _this._translate.instant('GLOBAL.BUSY.DELETING') }); })
            .subscribe(function (ret) {
            if (ret.data.removed) {
                if (_this.isMultipleFinalRuns) {
                    _this._runs.deleteFinalRun(runId).subscribe(function (x) {
                        _this.runs = _this.runs.filter(function (o) { return o.runId !== runId; });
                        _this.changeTracker.commit(['runs', runId]);
                        _this.selectedRun = null;
                    });
                }
                else {
                    _this.runs = _this.runs.filter(function (o) { return o.runId !== runId; });
                    _this.changeTracker.commit(['runs', runId]);
                    _this.selectedRun = null;
                }
                _this._applicationInsightsService.send({
                    eventCategory: 'Client - Runs',
                    eventAction: 'RunDeleted',
                    runId: runId
                });
            }
        });
    };
    RunListPage.prototype.load = function (runId, navigate) {
        this._applicationInsightsService.send({
            eventCategory: 'Client - Runs',
            eventAction: 'RunLoaded',
            runId: runId
        });
        if (navigate)
            this._router.navigate(['../../run', runId], { relativeTo: this._activatedRoute });
    };
    RunListPage.prototype.clone = function (runId) {
        var _this = this;
        var initial = ('Clone of ' + this.runs.find(function (rm) { return rm.runId == runId; }).info.name).slice(0, 100);
        this._modal.confirm().message(this._translate.instant('RUN.SAVED.MESSAGE.CONFIRM_CLONE'))
            .okBtn(this._translate.instant('GLOBAL.YES'))
            .cancelBtn(this._translate.instant('GLOBAL.NO'))
            .open().then(function (dialog) { return dialog.result.then(function () { return true; }, function () { return false; }); })
            .then(function (ret) {
            if (ret) {
                _this._runs.clone({ runId: runId, newName: initial }).uiSignal({ debugInfo: 'clone run', uiLabel: _this._translate.instant('GLOBAL.BUSY.CLONING_RUN') })
                    .subscribe(function (ret) {
                    _this.runs = [ret.data].concat(_this.runs);
                    _this.changeTracker.commit(['runs', ret.data.runId]);
                    _this.selectedRun = ret.data;
                    _this._applicationInsightsService.send({
                        eventCategory: 'Client - Runs',
                        eventAction: 'RunCloned',
                        runId: ret.data.runId
                    });
                });
            }
        });
    };
    RunListPage.prototype.multipleFinalRun = function (run) {
        var _this = this;
        var runId = 0;
        this._sharedDataService.setOption("runId", run.info.runId);
        this._sharedDataService.setOption("modelId", run.info.modelId);
        this._sharedDataService.setOption("name", run.info.name);
        this._sharedDataService.setOption("clientId", run.info.clientId);
        var dialog = new vex_1.DialogPresetBuilder(this._modal)
            .className(this.theme)
            .content(FinalRunModalSelect_1.FinalRunModalSelect)
            .open().then(function (dialog) { return dialog.result.then(function (result) {
            _this._runs.updateRunInfo(run.runId, run.info).uiSignal({ debugInfo: 'update run info', uiLabel: _this._translate.instant('GLOBAL.BUSY.PERSISTING') }).subscribe(function (x) {
                run.info.saveDate = new Date();
                run.info.userDisplayName = _this._userService.currentUserInfo.fullName;
                run.info.userName = _this._userService.currentUserInfo.domain + "\\" + _this._userService.currentUserInfo.username;
                run.info.isFinalRunSelected = true;
                setTimeout(function () {
                    _this.refreshData(run.info.clientId, run.runId);
                }, 3000);
            });
            _this._applicationInsightsService.send({
                eventCategory: 'Client - Runs', eventAction: "Run marked Final",
                runId: run.runId
            });
        }, function () {
            if (run.info.finalCoverages != null && run.info.finalCoverages.length > 0)
                run.info.isFinalRunSelected = true;
            else
                run.info.isFinalRunSelected = false;
        }); });
    };
    RunListPage.prototype.deselectFinalRun = function (run) {
        var _this = this;
        this._sharedDataService.setOption("runId", run.info.runId);
        var dialog = new vex_1.DialogPresetBuilder(this._modal)
            .className(this.theme)
            .content(FinalRunModalDeselect_1.FinalRunModalDeselect)
            .open().then(function (dialog) { return dialog.result.then(function (result) {
            _this.isUnmarkFinalRunSelected = false;
            setTimeout(function () {
                _this.refreshData(run.info.clientId, run.runId);
            }, 3000);
            _this._applicationInsightsService.send({
                eventCategory: 'Client - Runs', eventAction: "Run unmarked Final",
                runId: run.runId
            });
        }, function () {
            _this.isUnmarkFinalRunSelected = false;
        }); });
    };
    RunListPage.prototype.commitSaveDateChanges = function () {
        var _this = this;
        this.filteredRuns.forEach(function (x) {
            if (_this.changeTracker.isChangedAt(["runs", x.runId, "info", "saveDate"]))
                _this.changeTracker.commit(["runs", x.runId, "info", "saveDate"]);
        });
    };
    RunListPage.prototype.refreshData = function (clientId, runId) {
        var _this = this;
        this.finalRuns = [];
        this._runs.getFullFinalRuns(this._config.currentModel.modelId, clientId).subscribe(function (x) {
            _this.finalRuns = x.data;
            if (_this.isMultipleFinalRuns && _this.filteredRuns) {
                _this.mapFinalRunsToFilteredRuns();
            }
            _this.changeTracker.commit(['runs', runId]);
        });
    };
    RunListPage.prototype.final = function (isFinalized, run) {
        var _this = this;
        if (this._config.currentModel.useMultipleFinalRun) {
            if (isFinalized) {
                this.multipleFinalRun(run);
            }
            else {
                this.deselectFinalRun(run);
            }
        }
        else {
            if (isFinalized) {
                var runId_1 = 0;
                var dialog = new vex_1.DialogPresetBuilder(this._modal)
                    .className(this.theme)
                    .content(components_1.CustomModal)
                    .open().then(function (dialog) { return dialog.result.then(function (result) {
                    var policyYear = result;
                    _this._runs.getFinalRunIds(_this._config.currentModel.modelId, run.info.clientId, policyYear).subscribe(function (o) {
                        if (o.data.runIds.length > 0) {
                            runId_1 = o.data.runIds[0];
                        }
                        if (runId_1 === 0) {
                            _this.updateRunStatus(run, _this._config.currentModel.modelId, policyYear);
                        }
                        else {
                            _this._runs.setRunStatus(_this._config.currentModel.modelId, runId_1, false, policyYear).subscribe(function (o) {
                                if (o.data.valueOf) {
                                    var item = _this.runs.find(function (o) { return o.runId === runId_1; });
                                    if (item) {
                                        item.info.isFinalized = false;
                                        _this.changeTracker.commit(['runs', runId_1]);
                                        _this._applicationInsightsService.send({
                                            eventCategory: 'Client - Runs', eventAction: "Run marked Final",
                                            runId: run.runId
                                        });
                                        _this.updateRunStatus(run, _this._config.currentModel.modelId, policyYear);
                                    }
                                }
                            });
                        }
                    });
                }, function () {
                    run.info.isFinalized = false;
                }); });
            }
            else {
                var dialog = new vex_1.DialogPresetBuilder(this._modal)
                    .className(this.theme)
                    .content(components_1.CustomModalDeselect)
                    .open().then(function (dialog) { return dialog.result.then(function (result) {
                    _this._runs.setRunStatus(_this._config.currentModel.modelId, run.runId, false, run.info.policyYear).subscribe(function (o) {
                        _this.changeTracker.commit(['runs', run.runId]);
                        _this._applicationInsightsService.send({
                            eventCategory: 'Client - Runs', eventAction: "Run unmarked Final",
                            runId: run.runId
                        });
                    });
                }, function () {
                    run.info.isFinalized = true;
                }); });
            }
        }
    };
    RunListPage.prototype.prospect = function (isProspect, run) {
        var _this = this;
        var msg = null;
        var gaMsg = null;
        if (isProspect) {
            msg = this._translate.instant('RUN.PROSPECT.MESSAGE.TEXT_SELECT');
            gaMsg = 'Run is marked as Client / Prospect';
        }
        else {
            msg = this._translate.instant('RUN.PROSPECT.MESSAGE.TEXT_DESELECT');
            gaMsg = 'Run is unmarked as Client / Prospect';
        }
        this._modal.confirm().message(msg)
            .okBtn(this._translate.instant('GLOBAL.YES'))
            .cancelBtn(this._translate.instant('GLOBAL.NO'))
            .open().then(function (dialog) { return dialog.result.then(function () { return true; }, function () { return false; }); })
            .then(function (ret) {
            if (ret) {
                _this._subscriptions.push(_this._runs.setProspectStatus(_this._config.currentModel.modelId, run.runId, isProspect).subscribe(function (o) {
                    _this.changeTracker.commit(['runs', run.runId]);
                    _this._applicationInsightsService.send({
                        eventCategory: 'Client - Runs', eventAction: gaMsg,
                        runId: run.runId
                    });
                    if (o.data.valueOf) {
                        _this._subscriptions.push(_this._runs.get(run.runId).subscribe(function (o) {
                            _this.runs.find(function (x) { return x.runId === run.runId; }).info = o.data.info;
                            _this.changeTracker.commit(['runs', run.runId]);
                        }));
                    }
                }));
            }
            else {
                run.info.isProspect = !isProspect;
            }
        });
    };
    RunListPage.prototype.updateRunStatus = function (run, model, policyYear) {
        var _this = this;
        this._subscriptions.push(this._runs.setRunStatus(model, run.runId, true, policyYear).subscribe(function (o) {
            if (o.data.valueOf) {
                _this._subscriptions.push(_this._runs.get(run.runId).subscribe(function (o) {
                    _this.runs.find(function (x) { return x.runId === run.runId; }).info = o.data.info;
                    _this.changeTracker.commit(['runs', run.runId]);
                }));
            }
        }));
    };
    RunListPage.prototype.save = function (runInfo) {
        this._runs.updateRunInfo(runInfo.runId, runInfo).uiSignal({ debugInfo: 'update run info', uiLabel: this._translate.instant('GLOBAL.BUSY.PERSISTING') }).fireAndForget();
        runInfo.saveDate = new Date();
        runInfo.userDisplayName = this._userService.currentUserInfo.fullName;
        runInfo.userName = this._userService.currentUserInfo.domain + "\\" + this._userService.currentUserInfo.username;
        if (this.isMultipleFinalRuns)
            this._runs.updateFinalRunDetails(runInfo.runId, runInfo.name).subscribe(function (x) { });
        this.changeTracker.commit(['runs', runInfo.runId]);
    };
    RunListPage.prototype.share = function (run) {
        this.sharingOptions.open = true;
        this.sharingOptions.sharedWith = (run.info.sharedWith || []).slice(0);
        this.sharingOptions.firstTime = !run.info.sharedWith || !run.info.sharedWith.length;
        this.sharingOptions.runId = run.runId;
    };
    RunListPage.prototype.changeRow = function (row) {
        var _this = this;
        if (row == this.selectedRun)
            row = null;
        if (this.sharingOptions.open) {
            this._modal.confirm().message(this._translate.instant('RUN.SAVED.MESSAGE.SHARING_UNSAVED'))
                .okBtn(this._translate.instant('GLOBAL.YES'))
                .cancelBtn(this._translate.instant('GLOBAL.NO'))
                .open().then(function (dialog) { return dialog.result.then(function () { return true; }, function () { return false; }); })
                .then(function (ret) {
                if (ret) {
                    _this.selectedRun = row;
                    _this.sharingOptions = {};
                }
            });
        }
        else {
            this.selectedRun = row;
        }
    };
    RunListPage.prototype.addShare = function (user) {
        var fresh = {
            runId: -1, shareDate: new Date(), userName: user.domain + "\\" + user.userName, userDisplayName: user.displayName
        };
        if (this.sharingOptions.sharedWith.find(function (o) { return o.userName === fresh.userName; })) {
            this._modal.alert().okBtn(this._translate.instant("GLOBAL.BTN.OK")).message(this._translate.instant('RUN.SAVED.MESSAGE.SHARING_ALREADY')).open();
        }
        else {
            this.sharingOptions.sharedWith.push(fresh);
            if (!this.sharingOptions.changes)
                this.sharingOptions.changes = {
                    addedUsers: [], removedUsers: []
                };
            this.sharingOptions.changes.addedUsers.push(fresh.userName);
        }
        this.sharingOptions.results = [];
        this.sharingOptions.userSearchTerm = null;
        this.sharingOptions.deleting = false;
    };
    RunListPage.prototype.removeShare = function (share) {
        var _this = this;
        this._modal.confirm().message(this._translate.instant('RUN.SAVED.MESSAGE.SHARING_CONFIRM_REMOVE')).okBtn(this._translate.instant('GLOBAL.YES'))
            .cancelBtn(this._translate.instant('GLOBAL.NO'))
            .open()
            .then(function (dialog) { return dialog.result.then(function () { return true; }, function () { return false; }); })
            .then(function (ret) {
            if (!ret)
                return;
            if (!_this.sharingOptions.changes)
                _this.sharingOptions.changes = {
                    addedUsers: [], removedUsers: []
                };
            _this.sharingOptions.changes.removedUsers.push(share.userName);
            _this.sharingOptions.sharedWith = _this.sharingOptions.sharedWith.filter(function (o) { return o !== share; });
            _this.sharingOptions.deleting = !_this.sharingOptions.firstTime && _this.sharingOptions.sharedWith.length === 0;
        });
    };
    RunListPage.prototype.hideSharing = function () {
        this.sharingOptions = {};
    };
    RunListPage.prototype.saveSharing = function () {
        var _this = this;
        if (this.sharingOptions.firstTime) {
            this._runs.createShare(this.sharingOptions.runId, this.sharingOptions.changes)
                .uiSignal({ debugInfo: 'creating share', uiLabel: this._translate.instant('GLOBAL.BUSY.CREATING_RUN') })
                .subscribe(function (ret) {
                _this.runs = [ret.data].concat(_this.runs);
                _this.selectedRun = ret.data;
                _this.sharingOptions = {};
                _this.changeTracker.commit(['runs', ret.data.runId]);
                _this._applicationInsightsService.send({
                    eventCategory: 'Client - Runs',
                    eventAction: 'RunShareCreated',
                    runId: ret.data.runId
                });
            });
        }
        else if (this.sharingOptions.deleting) {
            rx_1.Observable.fromPromise(this._modal.confirm().message(this._translate.instant('RUN.SAVED.MESSAGE.SHARING_DELETING'))
                .okBtn(this._translate.instant('GLOBAL.YES'))
                .cancelBtn(this._translate.instant('GLOBAL.NO'))
                .open()
                .then(function (dialog) { return dialog.result.then(function () { return true; }, function () { return false; }); }))
                .filter(function (ok) { return ok; })
                .flatMap(function () { return _this._runs.delete(_this.sharingOptions.runId).uiSignal({ debugInfo: 'delete shared run ', uiLabel: _this._translate.instant('GLOBAL.BUSY.DELETING') }); })
                .subscribe(function (ret) {
                if (ret.data.removed) {
                    var id_1 = _this.sharingOptions.runId;
                    _this.runs = _this.runs.filter(function (o) { return o.runId !== id_1; });
                    _this.selectedRun = null;
                    _this.sharingOptions = {};
                    _this.changeTracker.commit(['runs', id_1]);
                    _this._applicationInsightsService.send({
                        eventCategory: 'Client - Runs', eventAction: 'RunShareDeleted',
                        runId: id_1
                    });
                }
            });
        }
        else {
            this._runs.manageShares(this.sharingOptions.runId, this.sharingOptions.changes).uiSignal({ debugInfo: 'saving share', uiLabel: this._translate.instant('GLOBAL.BUSY.PERSISTING') }).subscribe(function (ret) {
                var id = _this.sharingOptions.runId;
                _this.selectedRun.info.sharedWith = ret.data;
                _this.changeTracker.commit(['runs', _this.sharingOptions.runId, 'info', 'sharedWith']);
                _this.selectedRun = null;
                _this.sharingOptions = {};
                _this._applicationInsightsService.send({
                    eventCategory: 'Client - Runs', eventAction: 'RunShareUpdated',
                    runId: id
                });
            });
        }
    };
    Object.defineProperty(RunListPage.prototype, "optionsItemTemplate", {
        get: function () { return this._component && this._component.instance && this._component.instance.itemTemplate; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RunListPage.prototype, "limitSize", {
        get: function () {
            return this._limit || 10;
        },
        set: function (value) {
            var all = this._translate.instant('RUN.SAVED.ALL');
            if (value !== this._limit && (typeof value === "number" || value === all)) {
                this._cookies.put(LIMITSIZE_COOKIENAME, value.toString());
                this._limit = value;
                this.applyFilters();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RunListPage.prototype, "sortBy", {
        get: function () {
            return this._sortBy;
        },
        set: function (field) {
            if (field === this._sortBy)
                this.descending = !this.descending;
            else
                this.descending = false;
            this._sortBy = field;
            this.applyFilters();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RunListPage.prototype, "searchExp", {
        get: function () {
            return this._searchExp;
        },
        set: function (exp) {
            exp = exp && exp.trim();
            if (!exp)
                exp = null;
            if (exp !== this._searchExp) {
                this._searchExp = exp;
                this.applyFilters();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RunListPage.prototype, "userFilter", {
        get: function () {
            return this._userFilter;
        },
        set: function (type) {
            if (type !== this._userFilter) {
                this._userFilter = type;
                this.applyFilters();
            }
        },
        enumerable: true,
        configurable: true
    });
    RunListPage.prototype.clearFilters = function () {
        this.userFilter = '';
        this.dateFilter = { from: null, to: null };
        this.searchExp = null;
        this.sortBy = null;
    };
    RunListPage.prototype.applyFilters = function () {
        var _this = this;
        if (this.runs && this.runs.length > 0) {
            var pipeline = this.runs.slice(0);
            var userFilter_1 = this.userFilter;
            if (userFilter_1) {
                var me_1 = (this._userService.currentUserInfo.domain + "\\" + this._userService.currentUserInfo.username)
                    .toUpperCase();
                pipeline = pipeline.filter(function (o) {
                    switch (userFilter_1) {
                        case 'creator':
                            return o.info.creatorUserName.toUpperCase() === me_1;
                        case 'sharer':
                            return o.info.creatorUserName.toUpperCase() === me_1 &&
                                o.info.sharedWith &&
                                !!o.info.sharedWith.length;
                        case 'sharedWith':
                            return o.info.creatorUserName.toUpperCase() !== me_1 &&
                                o.info.sharedWith &&
                                !!o.info.sharedWith.length;
                        case 'final':
                            if (_this.isMultipleFinalRuns)
                                return o.info.isFinalRunSelected === true;
                            else
                                return o.info.isFinalized === true;
                        case 'prospect':
                            return o.info.isProspect === true;
                        default:
                            return true;
                    }
                });
            }
            if (this.dateFilter.from || this.dateFilter.to) {
                var from_1 = moment.utc(new Date(0));
                var to_1 = moment.utc();
                if (this.dateFilter.from)
                    from_1 = moment.utc(this.dateFilter.from).startOf('day');
                if (this.dateFilter.to)
                    to_1 = moment.utc(this.dateFilter.to).endOf('day');
                pipeline = pipeline.filter(function (o) {
                    var creation = moment.utc(o.info.createDate);
                    return creation.isBetween(from_1, to_1) || creation.isSame(from_1) || creation.isSame(to_1);
                });
            }
            var exp_1 = this.searchExp && this.searchExp.toLowerCase();
            if (exp_1)
                pipeline = pipeline.filter(function (o) { return o.info.name.toLowerCase().indexOf(exp_1) !== -1 ||
                    o.info.description.toLowerCase().indexOf(exp_1) !== -1; });
            var nullsafeToLower_1 = function (s) { return !!s ? String(s).toLowerCase() : String(s); };
            var sort_1 = this.sortBy;
            if (sort_1) {
                pipeline = pipeline.sort(function (a, b) {
                    return (+(nullsafeToLower_1(a.info[sort_1]) > nullsafeToLower_1(b.info[sort_1])) -
                        +(nullsafeToLower_1(a.info[sort_1]) < nullsafeToLower_1(b.info[sort_1]))) *
                        (_this.descending ? -1 : 1);
                });
            }
            var limit = this.limitSize;
            if (typeof limit === "number") {
                pipeline = pipeline.slice(0, limit);
            }
            this.filteredRuns = pipeline;
            if (this.isMultipleFinalRuns && this.filteredRuns)
                this.mapFinalRunsToFilteredRuns();
            this._clients.runCountChanged.next({ total: this.runs.length, shown: this.filteredRuns.length });
            if (this.isMultipleFinalRuns && this.filteredRuns)
                setInterval(function () { return _this.commitSaveDateChanges(); }, 3000);
        }
    };
    RunListPage.prototype.mapFinalRunsToFilteredRuns = function () {
        var _this = this;
        if (this.finalRuns) {
            this.finalRuns.forEach(function (x) {
                var currentRun = _this.filteredRuns.find(function (y) { return y.runId === x.runId; });
                if (currentRun) {
                    currentRun.info.isFinalRunSelected = x.isFinalized;
                    currentRun.info.finalCoverages = _this.checkIfFinalRun(x.runId);
                }
            });
            this.changeTracker.commit();
        }
    };
    RunListPage.prototype.checkIfFinalRun = function (runId) {
        var currentCoverages = [];
        if (this.finalRuns.find(function (x) { return x.runId === runId; }))
            this.finalRuns.filter(function (x) { return x.runId === runId && x.isFinalized === true; }).forEach(function (x) {
                currentCoverages.push(x.lob);
            });
        return currentCoverages;
    };
    RunListPage.prototype.checkRunIsFinal = function (runId) {
        var final = false;
        if (this.finalRuns.find(function (x) { return x.runId === runId; })) {
            this.finalRuns.filter(function (x) { return x.runId === runId && x.isFinalized === true; }).forEach(function (x) {
                final = x.isFinalized;
            });
        }
        if (final)
            return true;
        else
            return false;
    };
    __decorate([
        CT2.TrackChanges({ itemKey: 'runId' }), 
        __metadata('design:type', Object)
    ], RunListPage.prototype, "runs", null);
    __decorate([
        CT2.ChangeTracker(), 
        __metadata('design:type', CT2.Changes)
    ], RunListPage.prototype, "changeTracker", void 0);
    __decorate([
        core_1.ViewChild('headerAnchor', { read: core_1.ViewContainerRef }), 
        __metadata('design:type', core_1.ViewContainerRef)
    ], RunListPage.prototype, "runOptionsView", void 0);
    RunListPage = __decorate([
        core_1.Component({
            selector: 'run-list',
            template: require('./runList.html'),
            moduleId: module.id,
            directives: [directives_1.CLICK_INPUT_DIRECTIVE, directives_1.ScrollDirective, directives_1.VALIDATORS, directives_1.AUTOCOMPLETE, directives_1.ExpanderComponent, directives_1.CUSTOM_VALUE_ACCESSORS, router_1.ROUTER_DIRECTIVES, components_1.ProgressIndicatorComponent, directives_1.TOOLTIP],
            styles: ["autocomplete /deep/ ul {max-height:160px;}"]
        }), 
        __metadata('design:paramtypes', [services_1.ClientService, services_1.ConfigService, backend_1.Api.RunsProxy, backend_1.Api.UserProxy, services_1.UserService, core_1.ComponentResolver, router_1.Router, services_1.TranslateService, services_1.ApplicationInsightsService, core_2.CookieService, services_1.PageService, router_1.ActivatedRoute, vex_1.Modal, services_1.SharedDataService])
    ], RunListPage);
    return RunListPage;
}(reactiveComponent_1.ReactiveComponent));
exports.RunListPage = RunListPage;



},{"../@toolkit/backend":"@toolkit/backend","../@toolkit/changeTracking":"@toolkit/changeTracking","../@toolkit/components":"@toolkit/components","../@toolkit/directives":"@toolkit/directives","../@toolkit/reactiveComponent":"@toolkit/reactiveComponent","../@toolkit/services":"@toolkit/services","../@toolkit/src/components/FinalRunModalDeselect":20,"../@toolkit/src/components/FinalRunModalSelect":21,"../dynamicChild":103,"./runList.html":114,"@angular/core":"@angular/core","@angular/router":"@angular/router","angular2-cookie/core":"angular2-cookie/core","angular2-modal/plugins/vex":"angular2-modal/plugins/vex","moment/moment":1,"rxjs":"rxjs"}],116:[function(require,module,exports){
module.exports = '<tabs>\n    <tab tabTitle="{{\'RUN.TABS.SAVED\'|translate}}">\n        <div class="grid padded">\n            <div class="module col-dt-1 col-ipl-1 col-ipp-1">\n                <div class="module-header">\n                    {{\'RUN.TABS.SAVED\'|translate}}\n                    <span *ngIf="!!runCount"> ({{\'RUN.SAVED.RUN_COUNT\'|translate:runCount}})</span>\n                    <!--<span style="padding-left: 3px" class="icon-circle-down" [hidden]="tabsState.savedRuns"></span>-->\n                </div>\n                <div class="module-content border">\n                    <run-list></run-list>\n                </div>\n            </div>\n        </div>\n    </tab>\n    <tab *ngIf=!hideNewRunVisible tabTitle="{{\'RUN.TABS.CREATE\'|translate}}">\n        <div *ngIf="(modell !== \'dno\'&& modell !== \'dnorc\')|| ((modell === \'dno\'||modell === \'dnorc\') && (currentUser.role ===\'Administrator\'))"  class="grid padded">\n            <div class="module col-dt-1 col-ipl-1 col-ipp-1">\n                <div class="module-header">\n                    {{\'RUN.TABS.CREATE_HEADER\'|translate}}\n                </div>\n                <div class="module-content border">\n                    <new-run></new-run>\n                </div>\n            </div>\n        </div>\n        <div *ngIf="((modell === \'dno\'||modell === \'dnorc\') && (currentUser.role !== \'Administrator\'))" class="grid padded">\n            <h2>This version of D&O Quantified has been discontinued. Please visit the new model at <a href="https://doquantified.willistowerswatson.com/" style="color:blue;">https://doquantified.willistowerswatson.com</a> to create new runs.</h2>\n        </div>\n    </tab>\n    <tab *ngFor="let page of dynamicPages, let index=index" tabTitle="{{\'RUN.TABS.\'+page.displayResourceName|uppercase|translate}}">\n        <div class="grid padded">\n            <div class="module col-dt-1 col-ipl-1 col-ipp-1">\n                <div class="module-header">\n                    {{\'RUN.TABS.\'+page.displayResourceName|uppercase|translate}}\n                </div>\n                <div class="module-content border">\n                    <div *dynamicChild="page.component"></div>\n                </div>\n            </div>\n        </div>\n    </tab>\n</tabs>\n\n\n<!--<div class="grid collapse-padded">\n    <div>\n        <div class="collapse">\n            <div class="collapse-header" (click)="toggle(\'savedRuns\')">\n                {{\'RUN.TABS.SAVED\'|translate}}\n                <span style="padding-left: 3px" *ngIf="!!runCount">({{\'RUN.SAVED.RUN_COUNT\'|translate:runCount}})</span>\n                <span style="padding-left: 3px" class="icon-circle-down" [hidden]="tabsState.savedRuns"></span>\n            </div>\n            <div class="collapse-content" [ngClass]="tabsState.savedRuns ? \'open\' : \'close\'">\n                <run-list></run-list>\n            </div>\n        </div>\n    </div>\n\n    <div>\n        <div class="collapse">\n            <div class="collapse-header" (click)="toggle(\'newRun\')">\n                {{\'RUN.TABS.CREATE\'|translate}}\n                <span style="padding-left: 3px" class="icon-circle-down" [hidden]="tabsState.newRun"></span>\n            </div>\n            <div class="collapse-content" [ngClass]="tabsState.newRun ? \'open\' : \'close\'">\n                <new-run></new-run>\n            </div>\n        </div>\n    </div>\n\n    <div *ngFor="let page of dynamicPages, let index=index">\n        <div class="collapse">\n            <div class="collapse-header" (click)="toggle(\'dyn\'+index)">\n                {{\'RUN.TABS.\'+page.displayResourceName|uppercase|translate}}\n                <span style="padding-left: 3px" class="icon-circle-down" [hidden]="tabsState[\'dyn\'+index]"></span>\n            </div>\n            <div class="collapse-content" [ngClass]="tabsState[\'dyn\'+index] ? \'open\' : \'close\'">\n                <div *dynamicChild="page.component"></div>\n            </div>\n        </div>\n    </div>\n</div>-->\n';
},{}],117:[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var router_1 = require('@angular/router');
var services_1 = require('../@toolkit/services');
var backend_1 = require('../@toolkit/backend');
var ReactiveComponent_1 = require('../@toolkit/ReactiveComponent');
var runList_1 = require('./runList');
var newRun_1 = require('./newRun');
var ng2_toastr_1 = require('ng2-toastr');
var dynamicChild_1 = require('../dynamicChild');
var clientSearch_1 = require('./clientSearch');
var DIRECTIVES = require('../@toolkit/directives');
var vex_1 = require('angular2-modal/plugins/vex');
var RunsPage = (function (_super) {
    __extends(RunsPage, _super);
    function RunsPage(_clientService, _userService, _config, _activatedRoute, _router, _translate, _toasts, _runs, _modal) {
        _super.call(this);
        this._clientService = _clientService;
        this._userService = _userService;
        this._config = _config;
        this._activatedRoute = _activatedRoute;
        this._router = _router;
        this._translate = _translate;
        this._toasts = _toasts;
        this._runs = _runs;
        this._modal = _modal;
        this.tabsState = { newRun: true };
        this.runCount = null;
        this.dynamicPages = [];
    }
    RunsPage.prototype.ngOnInit = function () {
        var _this = this;
        this._subscriptions = [
            this._activatedRoute.params.subscribe(function (params) {
                var id = params["id"];
                _this._clientService.loadById(id).subscribe(function (client) {
                    _this.currentClient = client;
                    if (!client) {
                        _this._translate.get('GLOBAL.TOASTS.CLIENT_NOT_FOUND').subscribe(function (m) {
                            _this._toasts.error(m);
                            _this._router.navigate(['/']);
                        });
                    }
                });
            }),
            this._userService.userInfo.subscribe(function (info) {
                _this.currentUser = info.details;
            }),
            this._config.currentModelChanged.subscribe(function (m) { _this.modell = m.modelName; }),
            this._clientService.runCountChanged.subscribe(function (val) { return _this.runCount = val; }),
            this._config.currentModelChanged.subscribe(function (model) {
                if (model.managementPages) {
                    model.managementPages.forEach(function (m, i) {
                        var url = backend_1.Api.ProxyProxy.redirector_url("clientside/" + m.srcUrl).url;
                        _this.dynamicPages.push({
                            index: i,
                            displayResourceName: m.displayResourceName,
                            component: null
                        });
                        System.import(url)
                            .then(function (module) {
                            _this.dynamicPages.find(function (x) { return x.index === i; }).component = module[Object.keys(module)[0]];
                        });
                    });
                }
                else
                    _this.dynamicPages = [];
            })
        ];
        var message = "";
        var webSite = "";
        var appNames = this._translate.instant("GLOBAL.APPNAME");
        var isCyber = Array.isArray(appNames.CYBER) && appNames.CYBER.includes(this.modell);
        var isDtcor = this.modell === appNames.DTCOR;
        if (isCyber || isDtcor) {
            this.hideNewRunVisible = true;
            var appKey = isCyber ? "CYBER" : "DTCOR";
            message = this._translate.instant("GLOBAL." + appKey + ".MESSAGE");
            webSite = this._translate.instant("GLOBAL." + appKey + ".WEBSITE");
            var updatedMessage_1 = message.replace(/{}/g, webSite);
            var headerContent_1 = "Warning: Important Update";
            this._modal
                .alert()
                .message("\n            <div class=\"modal-header\">\n                <h3>" + headerContent_1 + "</h3>\n            </div>\n            <div class=\"modal-body\">\n                " + updatedMessage_1 + "\n            </div>\n        ")
                .open()
                .then(function (dialogRef) {
                setTimeout(function () {
                    var messageElement = document.querySelector(".vex-dialog-message");
                    if (messageElement) {
                        messageElement.innerHTML = "\n                        <div class=\"modal-header\">\n                            <h3>" + headerContent_1 + "</h3>\n                        </div>\n                        <div class=\"modal-body\">\n                            " + updatedMessage_1 + "\n                        </div>\n                    ";
                    }
                }, 100);
            });
        }
    };
    RunsPage.prototype.toggle = function (tabName) {
        var _this = this;
        var keys = Object.keys(this.tabsState);
        keys.filter(function (k) { return k != tabName; }).forEach(function (k) { return _this.tabsState[k] = false; });
        this.tabsState[tabName] = true;
    };
    RunsPage = __decorate([
        core_1.Component({
            template: require('./runsPage.html'),
            moduleId: module.id,
            directives: [clientSearch_1.ClientSearch, runList_1.RunListPage, newRun_1.NewRunPage, dynamicChild_1.CreateDynamicChildDirective, DIRECTIVES.TAB_DIRECTIVE]
        }), 
        __metadata('design:paramtypes', [services_1.ClientService, services_1.UserService, services_1.ConfigService, router_1.ActivatedRoute, router_1.Router, services_1.TranslateService, ng2_toastr_1.ToastsManager, backend_1.Api.RunsProxy, vex_1.Modal])
    ], RunsPage);
    return RunsPage;
}(ReactiveComponent_1.ReactiveComponent));
exports.RunsPage = RunsPage;



},{"../@toolkit/ReactiveComponent":2,"../@toolkit/backend":"@toolkit/backend","../@toolkit/directives":"@toolkit/directives","../@toolkit/services":"@toolkit/services","../dynamicChild":103,"./clientSearch":107,"./newRun":113,"./runList":115,"./runsPage.html":116,"@angular/core":"@angular/core","@angular/router":"@angular/router","angular2-modal/plugins/vex":"angular2-modal/plugins/vex","ng2-toastr":"ng2-toastr"}],118:[function(require,module,exports){
module.exports = '<section class="account-page wide">\n    <h2>{{\'NOTFOUND.INFO\'|translate}}</h2>\n    <div>\n        <ol>\n            <li>\n                {{\'NOTFOUND.INSTRUCTIONS\'|translate}}\n            </li>\n            <li><a [routerLink]="[\'/\']">{{\'NOTFOUND.RETURN_LINK\'|translate}}</a></li>\n        </ol>\n    </div>\n</section>';
},{}],119:[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var services_1 = require('./@toolkit/services');
var reactiveComponent_1 = require('./@toolkit/reactiveComponent');
var router_1 = require('@angular/router');
var NotFoundPage = (function (_super) {
    __extends(NotFoundPage, _super);
    function NotFoundPage(_config) {
        _super.call(this);
        this._config = _config;
    }
    NotFoundPage.prototype.ngOnInit = function () {
        var _this = this;
        this._subscriptions = [this._config.currentModelChanged.subscribe(function (model) { return _this.email = model.contactEmail; })];
    };
    NotFoundPage = __decorate([
        core_1.Component({
            template: require('./notFoundPage.html'),
            moduleId: module.id,
            directives: [router_1.ROUTER_DIRECTIVES]
        }), 
        __metadata('design:paramtypes', [services_1.ConfigService])
    ], NotFoundPage);
    return NotFoundPage;
}(reactiveComponent_1.ReactiveComponent));
exports.NotFoundPage = NotFoundPage;



},{"./@toolkit/reactiveComponent":"@toolkit/reactiveComponent","./@toolkit/services":"@toolkit/services","./notFoundPage.html":118,"@angular/core":"@angular/core","@angular/router":"@angular/router"}],120:[function(require,module,exports){
module.exports = '<footer class="site-footer dropwdown-footer" >\n    <language-selector class="right"></language-selector>\n    <!--<img src="/app/assets/img/willis-towers-watson-logo.png" style="width: 300px; margin: 15px;" class="bottom"/>-->\n\n</footer>\n<footer *ngIf="(mode==\'NAVIGATION_MODE\' && currentRunInfo && currentClient) || showCookieConsent">\n    <ul class="run-info-footer">\n        <li *ngIf="mode==\'NAVIGATION_MODE\' && currentRunInfo && currentClient"><b>{{\'RUN.FOOTER.CLIENT_NAME\'|translate}}:</b></li>\n        <li *ngIf="mode==\'NAVIGATION_MODE\' && currentRunInfo && currentClient">{{currentClient.displayName}}</li>\n        \n        <li *ngIf="mode==\'NAVIGATION_MODE\' && currentRunInfo && currentClient"><b>{{\'RUN.FOOTER.NAME\'|translate}}:</b></li>\n        <li *ngIf="mode==\'NAVIGATION_MODE\' && currentRunInfo && currentClient">{{currentRunInfo.name}}</li>\n        <li *ngIf="mode==\'NAVIGATION_MODE\' && currentRunInfo && currentClient && currentRunInfo.isReadonly"><i class="icon-lock" title="{{\'RUN.READONLY\'|translate}}"></i></li>\n\n        <!--<li><b> {{\'RUN.FOOTER.DESCRIPTION\'|translate}}:</b></li>\n        <li>{{currentRunInfo.description}}</li>-->\n\n        <li *ngIf="mode==\'NAVIGATION_MODE\' && currentRunInfo && currentClient"><b>{{\'RUN.FOOTER.CREATED_BY\'|translate}}:</b></li>\n        <li *ngIf="mode==\'NAVIGATION_MODE\' && currentRunInfo && currentClient">{{currentRunInfo.creatorUserDisplayName}}</li>\n\n        <li class="right" *ngIf="showCookieConsent">\n            <a id="ccpa-link" style="color:whitesmoke" href="javascript:void(0)" title="Do Not Sell My Personal Info" class="ot-sdk-show-settings"></a>\n        </li>\n        <!--<li><b>{{\'RUN.FOOTER.LAST_SAVED_BY\'|translate}}:</b></li>\n        <li>{{currentRunInfo.userDisplayName}}</li>\n\n        <li><b>{{\'RUN.FOOTER.DATE_CREATED\'|translate}}:</b></li>\n        <li>{{currentRunInfo.createDate | localeDate:\'dd MMM y\'}}</li>\n\n        <li><b>{{\'RUN.FOOTER.LAST_SAVED_DATE\'|translate}}:</b></li>\n        <li>{{currentRunInfo.saveDate | localeDate:\'dd MMM y\'}}</li>\n        <template [ngIf]="currentRunInfo.sharedWith?.length">\n            <li><b>{{\'RUN.FOOTER.SHARED_WITH\'|translate}}:</b></li>\n            <li>{{currentRunInfo.sharedWith.length}} user{{currentRunInfo.sharedWith.length!=1 ? \'s\':\'\'}}</li>\n        </template>-->\n    </ul>\n</footer>\n';
},{}],121:[function(require,module,exports){
module.exports = '<header class="site-header" *ngIf="isMainHeader|async">\n    <table>\n        <tr>\n            <td class="snug runs-title">{{\'CURRENT_MODEL.TITLE\'|translate}}</td>\n            <td>&nbsp;</td>\n\n            <td class="snug small" style="padding-left: 20px; text-align: right;">\n                <span *ngIf="currentUser && currentUser.role">\n                    <span>{{currentUser.fullName}}</span> &nbsp;<span>{{(\'SITE_HEADER.ROLE.\'+currentUser.role.toUpperCase())|translate}}</span>\n                </span>\n            </td>\n\n        </tr>\n    </table>\n    <div class="clear"></div>\n</header>\n<header class="site-header" *ngIf="isNavHeader|async">\n    <table class="large" [style.opacity]="header.navigation.inProgress?0:1" >\n        <tr>\n            <td class="snug" (click)="toggleMultiLevelMenu($event)" (clickOutside)="closeMenu()" style="width: 34px; height:26px;" *ngIf="showMenu">\n                <div class="hamburger-menu-holder">\n                    <div class="hamburger-menu" ></div>\n                </div>\n                <div *ngIf="showMLMenu" class="multi-level-menu-holder">\n                    <multi-level-menu></multi-level-menu>\n                </div>\n            </td>\n            <td class="snug" *ngIf="!showMenu && homeUrl"><a title="{{\'SITE_HEADER.HOME\'|translate}}" class="home" [routerLink]="[homeUrl]"></a></td>\n            <td class="snug" id="left-arrow-bit" *ngIf="!!header.navigation.previous">\n                <a (click)="header.navigation.previousClicked.next()" class="nav-left"></a>\n            </td>\n            <td class="snug" id="left-arrow-name" *ngIf="!!header.navigation.previous"><a (click)="header.navigation.previousClicked.next()">{{header.navigation.previous|translate}}</a></td>\n\n            <td>&nbsp;</td>\n\n            <td class="snug" id="right-arrow-name" *ngIf="!!header.navigation.next"><a (click)="header.navigation.nextClicked.next()">{{header.navigation.next|translate}}</a></td>\n            <td class="snug" id="right-arrow-bit" *ngIf="!!header.navigation.next"><a (click)="header.navigation.nextClicked.next()" class="nav-right"></a></td>\n        </tr>\n    </table>\n    <h1 class="title">{{(header.navigation.inProgress?\'SITE_HEADER.LOADING\':header.navigation.current)|translate}}</h1>\n</header>\n';
},{}],122:[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var services_1 = require('./@toolkit/services');
var backend_1 = require('./@toolkit/backend');
var components_1 = require('./@toolkit/components');
var Router = require('@angular/router');
var clientSearch_1 = require('./models/clientSearch');
var ReactiveComponent_1 = require('./@toolkit/ReactiveComponent');
var authProvider_1 = require('./account/authProvider');
var vex_1 = require('angular2-modal/plugins/vex');
var components_2 = require('./@toolkit/components');
var Rx = require('rxjs');
function findMode(_router) {
    if (_router.routerState.snapshot.url.startsWith('/run/'))
        return {
            mode: services_1.SiteHeaderService.NAVIGATION_MODE, start: /\/run\/\d+\/([^\/]+)/g.exec(_router.routerState.snapshot.url)[1]
        };
    else
        return { mode: services_1.SiteHeaderService.MAIN_MODE, start: null };
}
var SiteHeaderComponent = (function (_super) {
    __extends(SiteHeaderComponent, _super);
    function SiteHeaderComponent(header, _userService, _router, _window, _configService, _clientService, _translate, _runService, _navigationService, _modal, _auth) {
        _super.call(this);
        this._userService = _userService;
        this._router = _router;
        this._window = _window;
        this._configService = _configService;
        this._clientService = _clientService;
        this._translate = _translate;
        this._runService = _runService;
        this._navigationService = _navigationService;
        this._modal = _modal;
        this._auth = _auth;
        this.isMainHeader = new Rx.Subject();
        this.isNavHeader = new Rx.Subject();
        this.showMLMenu = false;
        this.header = header;
    }
    SiteHeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._subscriptions = [this._userService.userInfo.subscribe(function (data) { return _this.canSearch = data.loggedOn && data.details && !data.details.noRole; }),
            this._router.events.filter(function (s) { return s instanceof Router.NavigationEnd; })
                .subscribe(function (s) {
                var setup = findMode(_this._router);
                if (setup.start && !setup.start.startsWith('~'))
                    _this.header.setTo(setup.start);
                _this.mode = setup.mode;
                setTimeout(function () {
                    _this.isMainHeader.next(_this.mode === services_1.SiteHeaderService.MAIN_MODE);
                    _this.isNavHeader.next(_this.mode === services_1.SiteHeaderService.NAVIGATION_MODE);
                }, 1);
                if (_this.mode === services_1.SiteHeaderService.MAIN_MODE)
                    _this._runService.setSnapshot(null);
                _this.toggleMultiLevelMenu(null, false);
            }),
            this._userService.userInfo.subscribe(function (info) {
                _this.currentUser = info.details;
                if (!info.loggedOn || !info.details) {
                    var verification = Rx.Observable.of(false);
                    if (!info.unauthorized)
                        verification = _this._auth.verify(_this.currentModel.modelName);
                    verification.subscribe(function (success) {
                        if (success)
                            _this._auth.refreshUser();
                        else
                            _this.attemptAuth();
                    });
                }
                else if (info.details.noRole) {
                    _this._router.navigate(['/norole']);
                }
            }),
            this._userService.onUnauthorized.subscribe(function () {
                _this._translate.get('GLOBAL.ERRORS.SESSION_TIMEOUT').subscribe(function (r) {
                    return _this._modal.alert().okBtn(_this._translate.instant("GLOBAL.BTN.OK")).message(r).open();
                });
            }),
            this._configService.currentModelChanged.subscribe(function (m) { return _this.showMenu = m.optionalUiFeatures && m.optionalUiFeatures.navigationMenu; }),
            this._clientService.currentClientChanged.subscribe(function (c) { return _this.homeUrl = c && "/runs/" + c.clientId || '/'; }),
            this._navigationService.navigationChanged.subscribe(function (u) { return _this.toggleMultiLevelMenu(null, false); })
        ];
    };
    SiteHeaderComponent.prototype.redirectToLoginPage = function (remember) {
        var instruction = ['/login'];
        if (remember && !this._window.nativeElement.location.pathname.includes('login'))
            instruction.push({
                from: this._window.nativeElement.location.pathname
            });
        this._router.navigate(instruction);
    };
    SiteHeaderComponent.prototype.attemptAuth = function () {
        this.redirectToLoginPage(true);
    };
    SiteHeaderComponent.prototype.toggleMultiLevelMenu = function (event, visible) {
        if (event && event.srcElement && event.srcElement && event.srcElement.className &&
            (event.srcElement.className.indexOf('hamburger-menu') > -1 || event.srcElement.className.indexOf('hamburger-menu-holder') > -1))
            this.showMLMenu = !this.showMLMenu;
        else if (visible !== undefined)
            this.showMLMenu = visible;
    };
    SiteHeaderComponent.prototype.closeMenu = function () {
        this.showMLMenu = false;
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], SiteHeaderComponent.prototype, "currentModel", void 0);
    SiteHeaderComponent = __decorate([
        core_1.Component({
            selector: 'site-header',
            template: require('./siteHeader.html'),
            moduleId: module.id,
            directives: [clientSearch_1.ClientSearch, components_1.MultiLevelMenuComponent, Router.ROUTER_DIRECTIVES]
        }), 
        __metadata('design:paramtypes', [services_1.SiteHeaderService, services_1.UserService, Router.Router, services_1.WindowRef, services_1.ConfigService, services_1.ClientService, services_1.TranslateService, services_1.RunService, services_1.NavigationService, vex_1.Modal, authProvider_1.AuthProvider])
    ], SiteHeaderComponent);
    return SiteHeaderComponent;
}(ReactiveComponent_1.ReactiveComponent));
exports.SiteHeaderComponent = SiteHeaderComponent;
var SiteFooterComponent = (function (_super) {
    __extends(SiteFooterComponent, _super);
    function SiteFooterComponent(_runs, _router, _clients, _configService) {
        _super.call(this);
        this._runs = _runs;
        this._router = _router;
        this._clients = _clients;
        this._configService = _configService;
    }
    SiteFooterComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._subscriptions = [
            this._router.events.filter(function (s) { return s instanceof Router.NavigationEnd; })
                .subscribe(function (s) {
                var setup = findMode(_this._router);
                _this.mode = setup.mode;
            }),
            this._runs.activeRun.subscribe(function (r) { return _this.currentRunInfo = r && r.info; }),
            this._clients.currentClientChanged.subscribe(function (c) { return _this.currentClient = c; })
        ];
        this.showCookieConsent = this._configService.currentModel.oneTrustCookieDataDomainScript ? true : false;
    };
    SiteFooterComponent = __decorate([
        core_1.Component({ selector: 'site-footer', template: require('./siteFooter.html'), moduleId: module.id, directives: [components_2.LanguageSelectorComponent] }), 
        __metadata('design:paramtypes', [services_1.RunService, Router.Router, services_1.ClientService, services_1.ConfigService])
    ], SiteFooterComponent);
    return SiteFooterComponent;
}(ReactiveComponent_1.ReactiveComponent));
exports.SiteFooterComponent = SiteFooterComponent;



},{"./@toolkit/ReactiveComponent":2,"./@toolkit/backend":"@toolkit/backend","./@toolkit/components":"@toolkit/components","./@toolkit/services":"@toolkit/services","./account/authProvider":95,"./models/clientSearch":107,"./siteFooter.html":120,"./siteHeader.html":121,"@angular/core":"@angular/core","@angular/router":"@angular/router","angular2-modal/plugins/vex":"angular2-modal/plugins/vex","rxjs":"rxjs"}]},{},[102]);
